/**
 * EVO — inglizcha lug'at (AVTOMATIK YIG'ILGAN).
 *
 * Qoidalar `i18n.ru.ts` dagi bilan bir xil: tip `Partial`, topilmagan kalit
 * `uz` ga qaytadi, `{param}` o'rin egallari manba bilan solishtirib
 * tekshirilgan va mos kelmagani lug'atga kiritilmagan.
 *
 * ⚠️ Yangi kalit AVVAL `i18n.ts` dagi `uz` ga qo'shiladi.
 */
import type { TranslationKey } from './i18n';

export const en: Partial<Record<TranslationKey, string>> = {
  'month.1': 'January',
  'month.2': 'February',
  'month.3': 'March',
  'month.4': 'April',
  'month.5': 'May',
  'month.6': 'June',
  'month.7': 'July',
  'month.8': 'August',
  'month.9': 'September',
  'month.10': 'October',
  'month.11': 'November',
  'month.12': 'December',
  'norm.title': 'Discipline norm',
  'norm.standard': 'Company standard',
  'norm.overridden': '{count} months overridden',
  'norm.month': 'Month',
  'norm.purchase': 'Purchase / balance, %',
  'norm.payment': 'Payment / purchase, %',
  'norm.collection': 'Payment / (balance+purchase), %',
  'norm.reset': 'Back to standard',
  'norm.invalid': 'Wrong percentage format: 0..5000, up to two decimals.',
  'norm.hint': 'An EMPTY cell means the company standard applies (shown greyed) and it follows the standard when that changes next year. A filled cell overrides only that month — this is how «December is different for this dealer» is recorded. The norm is used in Reports → Customer discipline.',
  'common.loading': 'Loading…',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.edit': 'Edit',
  'common.close': 'Close',
  'common.retry': 'Retry',
  'common.search': 'Search',
  'common.prev': 'Previous',
  'common.next': 'Next',
  'availability.title': 'Where is it in stock?',
  'availability.hint': 'Stock across all branches and the main warehouse. A product that has run out at your branch may be available at another warehouse — you can see it here.',
  'availability.search': 'Product',
  'availability.searchPlaceholder': 'Code or name…',
  'availability.scarceOnly': 'Running low only',
  'availability.totalAvailable': 'Total available',
  'availability.inTransit': 'In transit',
  'availability.transitShort': 'in transit',
  'availability.scarce': 'Running low',
  'availability.empty': 'No products found',
  'availability.emptyHint': 'Check the code or name. Products with zero stock are not included in the list.',
  'availability.total': '{count} products',
  'common.noData': 'No data',
  'common.error': 'Error',
  'common.unknownError': 'An unknown error occurred',
  'common.networkError': 'Could not connect to the server. Check your internet connection.',
  'common.today': 'Today',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.back': 'Back',
  'common.create': 'Create',
  'common.creating': 'Creating…',
  'common.saving': 'Saving…',
  'common.saved': 'Saved',
  'common.reload': 'Reload',
  'common.clear': 'Clear',
  'common.notSet': 'Not set',
  'common.reason': 'Reason',
  'common.optional': 'optional',
  'common.remove': 'Remove',
  'common.apply': 'Apply',
  'common.refresh': 'Refresh',
  'common.of': '{done} / {total}',
  'search.hint': 'Press / to jump to search',
  'search.clear': 'Clear search',
  'search.searching': 'Searching…',
  'search.noResults': 'Nothing found',
  'search.openResult': 'Open',
  'search.commandOpen': 'Global search (Ctrl+K)',
  'search.commandTitle': 'Global search',
  'search.commandPlaceholder': 'Document number, SKU, barcode, customer, phone… — for example SO-2026-00042',
  'search.commandHint': 'Enter at least 2 characters',
  'search.commandKeys': '↑ ↓ — select · Enter — open · Esc — close',
  'search.commandFailed': 'Search could not be completed. Please try again.',
  'search.recentTitle': 'Recently opened',
  'search.sectionsTitle': 'Sections',
  // --- Keyboard shortcuts ---
  'keys.title': 'Keyboard shortcuts',
  'keys.hint': 'Press "?" anywhere to open this window.',
  'keys.palette': 'Search and sections window',
  'keys.help': 'Open this window',
  'keys.focusSearch': 'Jump to the on-screen search',
  'keys.completeSale': 'COMPLETE the sale — money moves',
  'keys.newSale': 'Start a new sale',
  'keys.openRow': 'Open the row',
  'keys.addRow': 'Add a row',
  'keys.close': 'Close the window',
  'keys.move': 'Move up/down a list',
  'keys.where.anywhere': 'anywhere',
  'keys.where.outsideField': 'outside input fields',
  'keys.where.listScreens': 'on list screens',
  'keys.where.directSale': 'direct sale',
  'keys.where.tables': 'in tables',
  'keys.where.editTables': 'in editable tables',
  'keys.where.dialogs': 'in dialogs',
  'keys.where.lists': 'in lists',
  'search.inactive': 'inactive',
  'search.type.product': 'Products',
  'search.type.customer': 'Customers',
  'search.type.supplier': 'Suppliers',
  'search.type.salesOrder': 'Sales orders',
  'search.type.purchaseOrder': 'Purchase orders',
  'search.type.shipment': 'Containers',
  'search.type.invoice': 'Invoices',
  'search.type.payment': 'Payments',
  'search.type.return': 'Returns',
  'search.type.installer': 'Installers',
  'search.type.delivery': 'Deliveries',
  'search.type.creditNote': 'Credit notes',
  'search.type.expense': 'Branch expenses',
  'search.type.goodsReceipt': 'Goods receipts',
  'search.type.employee': 'Employees',
  'form.required': 'This field is required',
  'form.hasErrors': 'The form has errors — check the highlighted fields',
  'product.title': 'Products',
  'ref.categories': 'Categories',
  'ref.brands': 'Brands',
  'ref.uoms': 'Units of measure',
  'ref.newTitle': 'New entry',
  'ref.editTitle': 'Edit entry',
  'ref.code': 'Code',
  'ref.name': 'Name',
  'ref.parent': 'Parent category',
  'ref.parentRoot': '— root (no parent) —',
  'ref.status': 'Status',
  'ref.active': 'Active',
  'ref.archivedBadge': 'Archived',
  'ref.archive': 'Archive',
  'ref.restore': 'Restore',
  'ref.showArchived': 'Show archived too',
  'ref.total': 'Total: {count}',
  'ref.empty': 'No entries yet — add one with the form above',
  'ref.created': 'Added',
  'ref.updated': 'Saved',
  'ref.archived': 'Archived',
  'ref.restored': 'Restored',
  'ref.archiveHint':
    'Entries are NEVER deleted, only archived: products linked to them must keep showing their category and brand, otherwise last year reports would come out different. An archived entry no longer appears in new pickers.',
  'product.new': 'New product',
  'product.newTitle': 'Create a new product',
  'product.searchPlaceholder': 'Search by SKU, name or legacy 1C code',
  'product.sku': 'SKU',
  'product.name': 'Name',
  'product.nameUz': 'Name (Uzbek)',
  'product.nameRu': 'Name (Russian)',
  'product.nameEn': 'Name (English)',
  'product.category': 'Category',
  'product.categoryAll': 'All categories',
  'product.brandAll': 'All brands',
  'product.importFile': 'Upload from file',
  'product.brand': 'Brand',
  'product.uom': 'Unit of measure',
  'product.availableStock': 'Available stock',
  'product.avgCost': 'Average cost',
  'product.avgCostHint': 'Cost is calculated from warehouse movements and cannot be entered manually.',
  'product.costBlock': 'Cost',
  'product.description': 'Description',
  'product.weightKg': 'Weight, kg',
  'product.volumeM3': 'Volume, m³',
  'product.minStock': 'Minimum stock',
  'product.maxStock': 'Maximum stock',
  'product.reorderPoint': 'Reorder point',
  'product.vatRate': 'VAT rate, %',
  'product.vatRatePlaceholder': 'Default (from settings)',
  'product.vatRateHint': 'Prices are shown INCLUDING VAT — the tax is not added on top of the price, it is extracted from it. At 12%, an item priced at 11 200 UZS contains 1 200 UZS of tax. Leave 0 for exports and exempt goods: 0 does not mean “not filled in”, it means “no tax”.',
  'product.isSellable': 'Sellable',
  'product.isPurchasable': 'Purchasable',
  'product.attributes': 'Attributes',
  'product.aliases': 'Alternative codes',
  'product.aliasesHint': 'A legacy 1C, supplier or packaging code. Staff will keep typing it for months — if it is missing, search returns nothing and duplicates appear.',
  'product.alias': 'Code',
  'product.aliasType': 'Type',
  'product.aliasSource': 'Source',
  'product.aliasAdd': 'Add code',
  'product.aliasRemove': 'Remove code',
  'product.aliasType.legacy': 'Legacy system',
  'product.aliasType.adines': 'Adines',
  'product.aliasType.1c': '1C',
  'product.aliasType.supplier': 'Supplier',
  'product.aliasType.custom': 'Other',
  'product.status': 'Status',
  'product.active': 'Active',
  'product.archived': 'Archived',
  'product.version': 'Version',
  'product.updatedAt': 'Last change',
  'product.empty': 'No products found',
  'product.emptyHint': 'The catalog is still empty or the filter is too narrow.',
  'product.emptySearch': 'No products found for “{q}”',
  'product.emptySearchHint': 'Try the legacy code as well — search treats Latin and Cyrillic spelling the same.',
  'product.loadError': 'Could not load the product list',
  'product.notFound': 'Product not found or not visible to you',
  'product.selectCategory': 'Select a category',
  'product.noBrand': 'No brand',
  'product.saved': 'Changes saved',
  'product.created': 'Product created',
  'product.editTitle': 'Edit product',
  'product.conflict.title': 'The record was changed by another user',
  'product.conflict.body': 'While you had this card open, someone else managed to save it. Your changes were NOT SAVED — so that newer data is not overwritten. Load the latest state and re-enter your edits.',
  'product.conflict.reload': 'Load latest state',
  'product.duplicate.title': 'A similar product already exists',
  'product.duplicate.body': 'The items below already exist in the catalog. Check them first: if one product is entered under two SKUs, its stock and cost are split in two.',
  'product.duplicate.force': 'Create anyway',
  'product.duplicate.cancel': 'Cancel and check',
  'product.skuExists': 'This SKU already exists — choose another code',
  'customer.title': 'Customers',
  'customer.searchPlaceholder': 'Code, name or phone',
  'customer.searchHint': 'Enter the phone in any format: both +998 90 123-45-67 and 901234567 will be found.',
  'customer.newTitle': 'New customer',
  'customer.newHint': 'Credit limit, contract terms and the discipline norm are NOT here — they are set on the card afterwards, in their own sections, and need a different permission. After saving you land on the card.',
  'customer.codeHint': 'Unique code. It cannot be changed later — documents reference it.',
  'customer.priceList': 'Price list',
  'customer.priceListDefault': '— default list —',
  'customer.code': 'Code',
  'customer.name': 'Name',
  'customer.type': 'Type',
  'customer.type.retail': 'Retail',
  'customer.type.wholesale': 'Wholesale',
  'customer.type.dealer': 'Dealer',
  'customer.type.key_account': 'Key account',
  'customer.phone': 'Phone',
  'customer.email': 'Email',
  'customer.address': 'Address',
  'customer.taxId': 'Tax ID',
  'customer.profile': 'General information',
  'customer.contacts': 'Contacts',
  'customer.contactsEmpty': 'No contacts entered',
  'customer.contactsOrg': 'Company details',
  'customer.contactsPeople': 'Representatives',
  'customer.contactsPeopleHint': 'One person places the order and another one pays — this is where you see whom to call.',
  'customer.contactPrimary': 'Primary',
  'customer.contactsLoadError': 'Could not load contacts',
  'customer.credit': 'Credit terms',
  'customer.creditLimit': 'Credit limit',
  'customer.creditLimitNone': 'No limit set',
  'customer.creditEdit': 'Change credit terms',
  'customer.creditEditTitle': 'Credit terms',
  'customer.creditEditHint': 'The limit is how much you may ship to the customer on credit. Before raising it, check the customer\'s CURRENT debt in the Receivables (AR) report: the limit and the debt are two different figures.',
  'customer.creditLimitAmount': 'Limit amount',
  'customer.creditLimitCurrency': 'Limit currency',
  'customer.creditLimitZeroHint': '0 does not mean “no limit”, it means “no credit allowed”.',
  'customer.creditTermDays': 'Payment term (days)',
  'customer.creditTermDaysHint': '0 means prepayment only. The maximum is 365 days.',
  'customer.creditAmountInvalid': 'The amount must be a non-negative number',
  'customer.creditTermInvalid': 'The term must be a whole number between 0 and 365',
  'customer.creditNoChanges': 'Nothing was changed',
  'customer.creditSaved': 'Credit terms saved',
  'customer.paymentTerms': 'Payment term',
  'customer.paymentTermsDays': '{days} days',
  'customer.paymentTermsPrepaid': 'Prepayment only',
  'customer.blocked': 'Blocked',
  'customer.notBlocked': 'Active',
  'customer.archived': 'Archived',
  'customer.blockReason': 'Block reason',
  'customer.block': 'Block',
  'customer.unblock': 'Unblock',
  'customer.blockTitle': 'Block customer',
  'customer.unblockTitle': 'Unblock customer',
  'customer.blockHint': 'A blocked customer stays in the list and their debt is still tracked, but no new order can be created for them.',
  'customer.blockReasonRequired': 'The reason must be at least 3 characters long',
  'customer.blockReasonWhy': 'The question “why was this customer blocked?” always comes up a week later — the reason stays in the audit log.',
  'customer.empty': 'No customers found',
  'customer.emptyHint': 'The list is empty or no customers are assigned to you.',
  'customer.emptySearch': 'No customers found for “{q}”',
  'customer.loadError': 'Could not load the customer list',
  'customer.notFound': 'Customer not found or not visible to you',
  'customer.fxPolicy': 'Who bears the FX difference',
  'customer.fxPolicy.payment_date.short': 'Rate on the payment date',
  'customer.fxPolicy.sale_date.short': 'Rate on the sale date',
  'customer.fxPolicy.payment_date.full': 'When a dollar debt is paid in soum, the rate ON THE PAYMENT DATE applies — the CUSTOMER covers the difference caused by the rate change.',
  'customer.fxPolicy.sale_date.full': 'When a dollar debt is paid in soum, the rate ON THE SALE DATE is locked in — the COMPANY absorbs the difference caused by the rate change.',
  'auth.login.title': 'Sign in',
  'auth.login.subtitle': 'Enter your email and password',
  'auth.email': 'Email',
  'auth.email.placeholder': 'name@company.uz',
  'auth.password': 'Password',
  'auth.password.placeholder': 'Your password',
  'auth.submit': 'Sign in',
  'auth.submitting': 'Signing in…',
  'auth.error.invalidCredentials': 'Invalid email or password',
  'auth.error.required': 'Email and password are required',
  'auth.logout': 'Sign out',
  'auth.sessionExpired': 'Your session has expired. Please sign in again.',
  'auth.restoring': 'Restoring session…',
  'fx.title': 'Daily FX rate',
  'fx.rateLine': '1 USD = {rate}',
  'fx.missing': 'Today\'s FX rate has not been entered',
  'fx.missingHint': 'Documents entered without a rate are not recalculated later.',
  'fx.stale': 'Latest rate: {date}',
  'fx.edit': 'Enter rate',
  'fx.editTitle': 'Enter today\'s rate',
  'fx.loading': 'Loading rate…',
  'fx.editHint': 'Documents created after this is entered LOCK IN this rate and are not recalculated later. If the rate is wrong, the document has to be cancelled and entered again.',
  'fx.uzsLabel': '1 USD = ? UZS (sales and cash)',
  'fx.cnyLabel': '1 USD = ? ¥ (purchasing, Chinese factories)',
  'fx.saved': 'Rate saved: {currencies}',
  'fx.noChange': 'The value has not changed',
  'nav.skipToContent': 'Skip to main content',
  'nav.menu': 'Menu',
  'nav.branch': 'Branch',
  'nav.reportsHub': 'Reports hub',
  'reportsHub.lead': 'Each report answers one question. Pick the question and the report opens itself.',
  'reportsHub.searchPlaceholder': 'Search by report or question',
  'reportsHub.empty': 'No reports found for this query.',
  'reportsHub.themeSales': 'Sales and customers',
  'reportsHub.themeStock': 'Warehouse and stock',
  'reportsHub.themeMoney': 'Money and debt',
  'reportsHub.themeImport': 'Import and supply',
  'reportsHub.themeAccounting': 'Accounting',
  'reportsHub.themeOther': 'Other',
  'reportsHub.hintSales': 'How much you sold — by day, month, branch, manager and product.',
  'reportsHub.hintAgentActivity': 'How much each sales agent did and who showed no activity at all.',
  'reportsHub.hintProfit': 'How much gross profit is left from sales — after cost is deducted.',
  'reportsHub.hintRfm': 'Which customers buy recently, often and a lot — who needs attention.',
  'reportsHub.hintLtv': 'How much profit one customer has brought over the whole relationship.',
  'reportsHub.hintCustomerProfit': 'Which customers are truly profitable and which ones lose money because of discounts.',
  'reportsHub.hintStock': 'How much stock is where right now — across all branches and the main warehouse.',
  'reportsHub.hintStockValue': 'How much money is tied up in the warehouse.',
  'reportsHub.hintDeadStock': 'Which products have not moved for a long time.',
  'reportsHub.hintStockAge': 'How long products have been sitting in the warehouse.',
  'reportsHub.hintAbc': 'Which products generate most of the turnover — focus on those.',
  'reportsHub.hintXyz': 'Which products sell steadily and which fluctuate — plan the stock accordingly.',
  'reportsHub.hintReorder': 'What has to be ordered right now — so it does not run out.',
  'reportsHub.hintArAging': 'Who owes how much and how many days the debt has been outstanding.',
  'reportsHub.hintCashFlow': 'Where money came from and where it went — by cash flow item.',
  'reportsHub.hintShipmentProfit': 'Which shipment made a profit and which made a loss — including cost.',
  'reportsHub.hintContainer': 'How efficiently the container space was used.',
  'reportsHub.hintSupplierScore': 'Which factory delivers on time and which one is late.',
  'reportsHub.hintIncomeStatement': 'Profit or loss for the period — broken down by income and expenses.',
  'reportsHub.hintBalanceSheet': 'What the company owns and whom it owes — as of a date.',
  'reportsHub.hintEquity': 'How the owner\'s equity changed.',
  'reportsHub.hintJournals': 'Every journal entry — together with the document it came from.',
  'reportsHub.hintPeriods': 'Which months are closed and which are still open.',
  'nav.allBranches': 'All branches',
  'nav.group.general': 'General',
  'nav.group.masterData': 'Master data',
  'nav.group.warehouse': 'Warehouse',
  'nav.group.supply': 'Supply',
  'nav.incomingSupply': 'Incoming goods',
  'nav.group.procurement': 'Purchasing and import',
  'nav.group.sales': 'Sales',
  'nav.group.finance': 'Finance',
  'nav.group.reports': 'Reports',
  'nav.group.system': 'System',
  'nav.dashboard': 'Home',
  'nav.reference': 'Categories and brands',
  'nav.products': 'Products',
  'nav.customers': 'Customers',
  'nav.suppliers': 'Suppliers',
  'nav.pricelists': 'Price lists',
  'nav.stock': 'Stock',
  'nav.receipts': 'Goods receipts',
  'nav.issue': 'Goods issues',
  'nav.transfers': 'Transfers',
  'nav.counts': 'Stock counts',
  'nav.movements': 'Stock ledger',
  'nav.purchaseOrders': 'Purchase orders',
  'nav.shipments': 'Containers',
  'nav.costing': 'Costing',
  'nav.landedCost': 'Landed cost',
  'nav.salesOrders': 'Sales orders',
  'nav.invoices': 'Invoices',
  'nav.returns': 'Returns',
  'nav.returnsQuarantine': 'Quarantine (QC)',
  'nav.payments': 'Payments',
  'nav.receivables': 'Receivables (AR)',
  'nav.payables': 'Payables (AP)',
  'nav.supplierPayments': 'Pay a supplier',
  'nav.cashAccounts': 'Cash and bank',
  'nav.fxRates': 'FX rates',
  'nav.reportStock': 'Warehouse stock',
  'nav.reportStockValue': 'Stock value',
  'nav.reportSales': 'Sales',
  'nav.reportProfit': 'Gross profit',
  'nav.reportDiscipline': 'Customer discipline',
  'nav.reportArAging': 'AR aging',
  'nav.reportApAging': 'AP aging',
  'nav.reportCashFlow': 'Cash flow',
  'nav.reportDeadStock': 'Slow-moving stock',
  'nav.reportShipmentProfit': 'Container profitability',
  'nav.reportReorder': 'When to reorder',
  'nav.reportAbc': 'ABC analysis',
  'nav.reportXyz': 'XYZ analysis',
  'nav.reportRfm': 'RFM — customer segmentation',
  'nav.reportLtv': 'Customer lifetime value (LTV)',
  'nav.reportSupplierScore': 'Supplier score',
  'nav.reportContainer': 'Container efficiency',
  'nav.reportStockAge': 'Stock age',
  'nav.reportCustomerProfit': 'Customer profitability',
  'nav.users': 'Users',
  'nav.group.security': 'Security',
  'nav.settings': 'Settings',
  'dashboard.title': 'Home',
  'dashboard.welcome': 'Welcome, {name}',
  'dashboard.subtitle': 'Metrics are shown according to your permissions.',
  'dashboard.yourRole': 'Your role',
  'dashboard.yourPermissions': 'Number of permissions',
  'dashboard.openReport': 'Open report →',
  'dashboard.empty': 'There are no metrics to show you',
  'dashboard.emptyHint': 'This may be expected: each card requires its own permission. The screens in the side menu are open to you.',
  'dashboard.salesToday': 'Sales today',
  'dashboard.salesTodayHint': 'Based on posted shipment notes',
  'dashboard.salesMonth': 'Sales this month',
  'dashboard.salesLines': '{count} lines',
  'dashboard.grossProfitMonth': 'Gross profit (this month)',
  // Short caption: the long one broke mid-word inside the tile.
  'dashboard.grossProfitHint': 'Revenue − cost',
  'dashboard.arTotal': 'Receivables (AR)',
  'dashboard.arHint': 'Outstanding balance of unpaid invoices',
  'dashboard.arOverdue': 'Of which overdue: {amount}',
  'dashboard.arCustomers': '{count} customers',
  'dashboard.stockValue': 'Stock value',
  'dashboard.stockValueHint': 'At landed cost, {count} warehouses',
  'dashboard.inTransitValue': 'Value of goods in transit',
  'dashboard.inTransitHint': 'Goods in a container, not yet received',
  'dashboard.inTransitQty': 'Quantity in transit: {qty}',
  'dashboard.inTransitTodo': 'The stock report gives the QUANTITY of goods in transit, not their value.',
  'dashboard.stockSummary': 'Warehouse stock',
  'dashboard.stockSummaryHint': 'Items with stock on hand',
  'dashboard.stockSkuCount': '{count} SKUs',
  'dashboard.deadStock': 'Slow-moving stock',
  'dashboard.deadStockHint': 'No goods issue for {days} days',
  'dashboard.deadStockCount': '{count} items',
  'dashboard.pendingTasks': 'Pending warehouse tasks',
  'dashboard.pendingTasksHint': 'Unreceived transfers and open stock counts',
  'dashboard.pendingTransfers': 'Unreceived transfers: {count}',
  'dashboard.pendingCounts': 'Open stock counts: {count}',
  'dashboard.openTransfers': 'Open transfers →',
  'dashboard.topCustomers': 'Top customers',
  'dashboard.topCustomersHint': 'By revenue this month, top five',
  'dashboard.cashFlowMonth': 'Cash flow (this month)',
  'dashboard.cashFlowHint': 'Inflow − outflow',
  'dashboard.cashIn': 'Inflow: {amount}',
  'dashboard.cashOut': 'Outflow: {amount}',
  'dashboard.lastContainer': 'Last container',
  'dashboard.lastContainerHint': 'Share of costs relative to the value of the goods',

  // Logistics row — replaces the two former tiles.
  'dashboard.logistics.inTransit': 'Goods in transit',
  'dashboard.logistics.lastContainer': 'Last container: {docNo}',
  'period.title': 'Period',
  'period.today': 'Today',
  'period.thisWeek': 'This week',
  'period.thisMonth': 'This month',
  'period.lastMonth': 'Last month',
  'period.thisYear': 'This year',
  'period.from': 'From',
  'period.to': 'To',
  'report.export': 'Export to Excel',
  'report.exportHint': 'The file is built from the rows on screen — no extra request is sent to the server.',
  'report.exportSubtitle': 'File created: {at} · Rows: {count}',
  'report.exportEmpty': 'No rows to export',
  'report.exportFailed': 'Could not download the file',
  'report.print': 'PDF',
  'report.printHint': 'Opens the print dialog — choose “Save as PDF” there',
  'report.generatedAt': 'Generated: {at}',
  'report.currency': 'Currency: {currency}',
  'report.orgUnknown': '⚠️ Organization name is unknown',
  'report.asOf': 'As of date',
  'report.total': 'Total',
  'report.loadError': 'Could not load the report',
  'report.empty': 'No data for these conditions',
  'report.emptyHint': 'Widen the period or check the filter.',
  'report.valueHidden': 'Monetary value columns are not shown to you — this is a permission matter, not an error.',
  'report.insufficient.no_data': 'No data — no activity was found in this period.',
  'report.insufficient.single_purchase': 'Only one purchase in the period — frequency cannot be measured. At least two purchases are needed to see repetition.',
  'report.insufficient.too_few_periods': 'Not enough observation periods — the product history is short. Choose a longer window or wait for the product to turn over.',
  'report.insufficient.too_few_peers': 'The comparison base is small — there are too few customers for quintile scores to be meaningful.',
  'report.insufficient.short_history': 'The relationship history is short — a monthly value would be extrapolation, so it is not given.',
  'report.insufficient.zero_base': 'The base is zero — a percentage or share cannot be calculated.',
  'report.insufficient.ambiguous_source': 'There are several sources — the metric cannot be attributed to just one.',
  'report.abc.title': 'ABC analysis',
  'report.abc.description': 'Products are split into A/B/C groups by revenue. Each row also shows how much money is tied up in that product today — the most valuable row is a group C product whose warehouse is full.',
  'report.abc.thresholds': 'Thresholds',
  'report.abc.preset': '{a}/{b}/{c}',
  'report.abc.rank': '№',
  'report.abc.class': 'Group',
  'report.abc.revenue': 'Revenue',
  'report.abc.share': 'Share',
  'report.abc.cumulative': 'Cumulative',
  'report.abc.quantity': 'Quantity',
  'report.abc.grossProfit': 'Gross profit',
  'report.abc.margin': 'Margin',
  'report.abc.stockValue': 'Money tied up in stock',
  'report.abc.groupCount': '{count} products',
  'report.xyz.title': 'XYZ analysis',
  'report.xyz.description': 'How stable demand is. X is predictable, Z is erratic and needs a large safety stock. Read it together with ABC: AX is important and stable, CZ is minor and erratic.',
  'report.xyz.class': 'XYZ',
  'report.xyz.combined': 'ABC-XYZ',
  'report.xyz.cv': 'Variation',
  'report.xyz.periods': 'Periods',
  'report.xyz.periodsValue': '{observed} ({active} with sales)',
  'report.xyz.totalQty': 'Total demand',
  'report.xyz.mean': 'Mean',
  'report.xyz.stdDev': 'Deviation',
  'report.xyz.reason': 'Note',
  'report.xyz.lookback': 'Lookback window',
  'report.xyz.bucket': 'Period',
  'report.xyz.bucket.week': 'Week',
  'report.xyz.bucket.month': 'Month',
  'report.xyz.matrix': 'ABC × XYZ matrix (number of products)',
  'report.xyz.matrixHint': 'AX — order automatically, a small stock is enough. AZ — important but erratic: keep a large safety stock. CZ — no need to keep stock at all.',
  'report.rfm.title': 'RFM — customer segmentation',
  'report.rfm.description': 'Customers by recency (R), frequency (F) and monetary value (M). The scores are RELATIVE: they show where a customer stands compared with your other customers. That is why the raw values are shown next to the scores.',
  'report.rfm.code': 'Code',
  'report.rfm.customer': 'Customer',
  'report.rfm.segment': 'Segment',
  'report.rfm.rfmCode': 'RFM',
  'report.rfm.r': 'R',
  'report.rfm.f': 'F',
  'report.rfm.m': 'M',
  'report.rfm.recencyDays': 'Since last purchase',
  'report.rfm.purchases': 'Purchases',
  'report.rfm.monetary': 'Amount',
  'report.rfm.lastPurchase': 'Last purchase',
  'report.rfm.reason': 'Note',
  'report.rfm.segments': 'Distribution by segment',
  'report.rfm.segment.champion': 'Most valuable',
  'report.rfm.segment.loyal': 'Loyal',
  'report.rfm.segment.potential': 'Potential',
  'report.rfm.segment.at_risk': 'At risk',
  'report.rfm.segment.lost': 'Lost',
  'report.rfm.segment.needs_attention': 'Needs attention',
  'report.rfm.segment.unscored': 'Not scored',
  'report.ltv.title': 'Customer lifetime value (LTV)',
  'report.ltv.description': 'How much gross profit the customer has brought over the whole relationship (after returns). This is not a FORECAST but a fact: a customer’s future "lifetime" would be a guess, while this figure comes from real sales.',
  'report.ltv.code': 'Code',
  'report.ltv.customer': 'Customer',
  'report.ltv.value': 'LTV',
  'report.ltv.monthly': 'Per month',
  'report.ltv.revenue': 'Revenue',
  'report.ltv.grossProfit': 'Gross profit',
  'report.ltv.returns': 'Returns',
  'report.ltv.orders': 'Orders',
  'report.ltv.avgOrder': 'Average order',
  'report.ltv.lifespan': 'Relationship length',
  'report.ltv.firstOrder': 'First purchase',
  'report.ltv.lastOrder': 'Last purchase',
  'report.ltv.minLifespan': 'Minimum history for the monthly value',
  'report.supplier.title': 'Supplier scorecard',
  'report.supplier.description': 'How reliable the factory is: promised lead time versus actual, defects (from returns), shortages at receipt and the price trend. A cheap supplier is not always cheap.',
  'report.supplier.code': 'Code',
  'report.supplier.name': 'Supplier',
  'report.supplier.score': 'Reliability',
  'report.supplier.onTime': 'On time',
  'report.supplier.promisedLead': 'Promised (days)',
  'report.supplier.actualLead': 'Actual (days)',
  'report.supplier.bias': 'Deviation (days)',
  'report.supplier.defect': 'Defects',
  'report.supplier.defectQty': 'Defect quantity',
  'report.supplier.shortage': 'Shortage',
  'report.supplier.priceChange': 'Price change',
  'report.supplier.priceChangeHint': 'There is no second period to compare against — widen the window.',
  'report.supplier.orders': 'Orders',
  'report.supplier.ordersValue': '{received} / {total}',
  'report.supplier.soleSource': 'Products defects can be attributed to',
  'report.supplier.soleSourceValue': '{sole} / {total}',
  'report.supplier.lookback': 'Lookback window',
  'report.supplier.unattributed': '{qty} pcs of defects could not be attributed to any supplier — these products have several active suppliers. To tell which factory is at fault, set a single supplier for the product.',
  'report.container.title': 'Container performance',
  'report.container.description': 'Plan versus actual: the ETA/ATA gap, the cost share of the goods value and the delay history. Whether a container made a profit is answered by the profitability report; this one measures the flow itself.',
  'report.container.docNo': 'Document',
  'report.container.containerNo': 'Container',
  'report.container.supplier': 'Supplier',
  'report.container.eta': 'ETA (plan)',
  'report.container.ata': 'ATA (actual)',
  'report.container.delay': 'Delay (days)',
  'report.container.delayValue': '{days} days',
  'report.container.notMeasured': 'Not measured: no ETA or actual date',
  'report.container.plannedTransit': 'Planned transit (days)',
  'report.container.actualTransit': 'Actual transit (days)',
  'report.container.purchaseValue': 'Goods value',
  'report.container.cost': 'Costs',
  'report.container.costShare': 'Cost share',
  'report.container.qty': 'Quantity',
  'report.container.lookback': 'Lookback window',
  'report.container.unmeasured': 'Delay was not measured for {count}',
  'report.container.delayChart': 'Delay history (by ETA)',
  'report.container.delayChartHint': 'The bars show DELAY only: a container that arrived on time or early leaves an empty slot, and unmeasured ones do not appear on the chart at all. Hover over a bar to see the exact value.',
  'report.container.costTypes': 'By cost type',
  'report.stockAge.title': 'Stock age',
  'report.stockAge.description': 'How many days the stock has been sitting on the shelf. Age is calculated over FIFO layers — the simple "since the last goods receipt" approach would hide slow-moving products.',
  'report.stockAge.onHand': 'Stock',
  'report.stockAge.avgAge': 'Average age',
  'report.stockAge.oldest': 'Oldest layer',
  'report.stockAge.unknown': 'Age unknown',
  'report.stockAge.unknownHint': 'No goods receipt record was found for this quantity — it is an opening stock carried over when the program went live or entered by hand.',
  'report.stockAge.unknownAlert': 'For {positions} positions the age of {qty} pcs of stock could not be determined — no goods receipt record was found. This quantity is NOT INCLUDED in the "oldest" group.',
  'report.stockAge.value': 'Value',
  'report.stockAge.chart': 'Stock by age group',
  'report.profitability.title': 'Customer profitability',
  'report.profitability.description': 'Revenue − cost − discounts − returns. The "not profitable" verdict usually comes from discounts and returns, and it is invisible in the gross profit report.',
  'report.profitability.code': 'Code',
  'report.profitability.customer': 'Customer',
  'report.profitability.netProfit': 'Net profit',
  'report.profitability.margin': 'Net margin',
  'report.profitability.listRevenue': 'Revenue (at list price)',
  'report.profitability.discount': 'Discount',
  'report.profitability.discountPct': 'Discount, %',
  'report.profitability.cogs': 'Cost',
  'report.profitability.bonusCost': 'Bonus cost',
  'report.profitability.returns': 'Returns',
  'report.profitability.orders': 'Orders',
  'report.profitability.quantity': 'Quantity',
  'report.profitability.excludesTitle': 'Costs NOT included in this report',
  'report.stock.title': 'Stock on hand',
  'report.stock.description': 'Stock for every warehouse and every SKU. The answer to "do we have this product?".',
  'report.stock.warehouse': 'Warehouse',
  'report.stock.onHand': 'Stock',
  'report.stock.reserved': 'Reserved',
  'report.stock.available': 'Available stock',
  'report.stock.inTransit': 'In transit',
  'report.stock.avgCost': 'Average cost',
  'report.stock.totalValue': 'Value',
  'report.stockValuation.title': 'Stock valuation',
  'report.stockValuation.description': 'Money tied up in warehouse stock, at landed cost. Broken down by warehouse.',
  'report.stockValuation.skuCount': 'SKU count',
  'report.stockValuation.totalQty': 'Total quantity',
  'report.stockValuation.totalValue': 'Total value',
  'report.stockValuation.warehouseName': 'Warehouse name',
  'report.sales.title': 'Sales',
  'report.sales.description': 'Revenue is calculated from shipments, not from invoices — the real sale is the moment the goods leave the warehouse.',
  'report.sales.chartLabel': 'Daily revenue',
  'report.sales.groupBy': 'Group by',
  'report.sales.groupBy.day': 'Day',
  'report.sales.groupBy.customer': 'Customer',
  'report.sales.groupBy.product': 'Product',
  'report.sales.groupBy.agent': 'Salesperson',
  'report.sales.date': 'Date',
  'report.sales.customer': 'Customer',
  'report.sales.sku': 'SKU',
  'report.sales.productName': 'Name',
  'report.sales.agent': 'Salesperson',
  'report.sales.agentUnnamed': 'Employee #{id}',
  'report.sales.agentNote': 'In the salesperson breakdown the report returns only the employee ID, not the name.',
  'report.sales.revenue': 'Revenue',
  'report.sales.quantity': 'Quantity',
  'report.sales.lineCount': 'Lines',
  'report.agent.title': 'Sales agent activity',
  'report.agent.description': 'How many orders each employee entered during the period, to how many different customers and for how much. For orders entered in the field, the visit location is checked as well.',
  'report.agent.agent': 'Sales agent',
  'report.agent.agentUnnamed': 'Employee #{id}',
  'report.agent.agentUnknown': 'No employee specified',
  'report.agent.orderCount': 'Orders',
  'report.agent.customerCount': 'Customers',
  'report.agent.totalBase': 'Total sales',
  'report.agent.avgOrderBase': 'Average order',
  'report.agent.fieldOrderCount': 'Entered in the field',
  'report.agent.measurable': 'Measurable',
  'report.agent.missing': 'Not measured',
  'report.agent.confirmed': 'Confirmed visits',
  'report.agent.confirmedOf': '{confirmed} of {measurable}',
  'report.agent.pct': 'Confirmed, %',
  'report.agent.pctUnmeasured': 'not measured',
  'report.agent.filterAgent': 'Sales agent',
  'report.agent.filterAgentAll': 'All',
  'report.agent.filterAgentHint': 'The list is built from the report\'s own rows: employees who entered orders during the period.',
  'report.agent.radius': 'Radius within which a visit counts as confirmed: {meters} m',
  'report.agent.radiusHint': 'An order entered within this distance of the customer\'s saved location counts as "confirmed".',
  'report.agent.caveatTitle': 'This metric is not a weapon',
  'report.agent.caveatBody': 'A low percentage does NOT mean the agent lied. Location permission may have been denied on the phone, GPS may not work inside a building, or the shop\'s saved location may be out of date. The number raises a question, it does not answer one — ask about the reason first.',
  'report.agent.scopeNote': 'Scope depends on the role: a salesperson sees only their own row, and the restriction is enforced on the server.',
  'report.agent.unmeasuredNote': '"Not measured" and "0%" are NOT the same: in the first case there were no measurable orders at all, in the second the measurement ran and not a single order was confirmed.',
  'report.profit.title': 'Gross profit',
  'report.profit.description': 'Profit = revenue − cost. The cost is locked in when the goods leave the warehouse and does not change afterwards.',
  'report.profit.by': 'Group by',
  'report.profit.by.product': 'Product',
  'report.profit.by.customer': 'Customer',
  'report.profit.code': 'Code',
  'report.profit.name': 'Name',
  'report.profit.quantity': 'Quantity',
  'report.profit.revenue': 'Revenue',
  'report.profit.cogs': 'Cost',
  'report.profit.bonusCost': 'Bonus cost',
  'report.profit.bonusHint': 'Bonus lines add 0 to revenue but subtract the cost IN FULL — a hidden discount that reduces profit.',
  'report.profit.grossProfit': 'Gross profit',
  'report.profit.marginPct': 'Margin',
  'disc.title': 'Customer discipline — plan vs fact',
  'disc.description':
    'One dealer month by month: how much they took, how much they paid, and whether that matched the agreed plan.',
  'disc.customer': 'Customer',
  'disc.pickCustomer': 'Pick a customer — this report is built for one dealer at a time.',
  'disc.failingCount': '{month}: {count} dealers deviated from the ratios (purchase or payment).',
  'disc.mustPay': 'Must pay',
  'disc.shortfall': 'Short by',
  'disc.lastPayment': 'Last payment',
  'disc.neverPaid': 'never paid',
  'disc.collectTotal':
    '{month}: {amount} still to collect from {count} dealers. The list starts with the largest amount.',
  'disc.allGood': '{month}: every dealer met the plan.',
  'disc.overviewHint': 'The list is sorted on the server: first by how many ratios were missed, then by debt. So the first row is the dealer to call today. Click a name to open that dealer month by month.',
  'disc.bucket': 'Breakdown',
  'disc.bucketMonth': 'Monthly',
  'disc.bucketWeek': 'Weekly',
  'disc.weekLabel': 'Week {week}',
  'disc.weekNote': 'Weekly rows are NOT judged (no colour): the norm is monthly — «pay 95% of your purchases this month» is not a weekly obligation. Weekly rows show WHEN inside the month the money arrived; the verdict is in the monthly view.',
  'disc.month': 'Month',
  'disc.opening': 'Opening debt',
  'disc.sales': 'Sales',
  'disc.payment': 'Payment',
  'disc.returned': 'Returns',
  'disc.discount': 'Discount',
  'disc.writeOff': 'Written off',
  'disc.closing': 'Closing debt',
  'disc.purchase': 'Purchase / prior balance',
  'disc.paymentRatio': 'Payment / purchase',
  'disc.collection': 'Payment / (balance + purchase)',
  'disc.planPurchase': 'Plan: purchase %',
  'disc.factPurchase': 'Fact: purchase %',
  'disc.planPayment': 'Plan: payment %',
  'disc.factPayment': 'Fact: payment %',
  'disc.planCollection': 'Plan: collection %',
  'disc.factCollection': 'Fact: collection %',
  'disc.hint':
    'The number in the cell is the FACT percentage; hover to see the plan. Green means the plan was met, yellow means more than half of it, red means less. No colour is shown when the plan is zero. Closing debt = opening debt + sales − payment − returns − discount − written off, and it becomes next month opening debt.',
  'report.arAging.title': 'Customer receivables (AR aging)',
  'report.arAging.description': 'Broken down by the age of the debt. Debt older than 90 days is not a collection case but a likely loss.',
  'report.arAging.code': 'Code',
  'report.arAging.customer': 'Customer',
  'report.arAging.notDue': 'Not due',
  'report.arAging.d0_30': '0–30 days',
  'report.arAging.d31_60': '31–60 days',
  'report.arAging.d61_90': '61–90 days',
  'report.arAging.d90plus': '90+ days',
  'report.arAging.total': 'Total debt',
  'report.arAging.overdue': 'Overdue debt',
  'report.arAging.oldestDue': 'Oldest due date',
  'report.arAging.invoiceCount': 'Invoices',
  'report.arAging.creditLimit': 'Credit limit',
  'report.cashFlow.title': 'Cash flow',
  'report.cashFlow.description': 'Daily money in and out for cash accounts and bank, broken down by cash flow item.',
  'report.cashFlow.date': 'Date',
  'report.cashFlow.category': 'Cash flow item',
  'report.cashFlow.in': 'Cash in',
  'report.cashFlow.out': 'Cash out',
  'report.cashFlow.net': 'Net',
  'report.deadStock.title': 'Slow-moving stock',
  'report.deadStock.description': 'Products that still have stock but have not moved out for a long time. This is money that has dropped out of circulation.',
  'report.deadStock.threshold': 'Idle threshold',
  'report.deadStock.days': '{days} days',
  'report.deadStock.daysIdle': 'Idle',
  'report.deadStock.lastOutbound': 'Last goods issue',
  'report.deadStock.never': 'Never issued',
  'report.deadStock.onHand': 'Stock',
  'report.deadStock.value': 'Value',
  'report.landedCost.title': 'SKU cost breakdown',
  'report.landedCost.description': '"Why does this panel cost {example}?" — the answer is in the cost lines below. Each SKU\'s cost is broken down to the cost type.',
  'report.landedCost.shipment': 'Shipment #{id}',
  'report.landedCost.sku': 'SKU',
  'report.landedCost.quantity': 'Quantity',
  'report.landedCost.purchaseUnitCost': 'Goods price (per unit)',
  'report.landedCost.landedUnitCost': 'Costs (per unit)',
  'report.landedCost.totalUnitCost': 'Landed cost (per unit)',
  'report.landedCost.costType': 'Cost type',
  'report.landedCost.costName': 'Note',
  'report.landedCost.allocMethod': 'Allocation',
  'report.landedCost.allocRatio': 'Share (ratio)',
  'report.landedCost.allocatedBase': 'Amount',
  'report.landedCost.uncategorized': 'Type not set',
  'report.landedCost.empty': 'No allocated costs were found for this shipment',
  'report.landedCost.emptyHint': 'Landed cost has not been run yet, or the shipment has no cost lines.',
  'report.landedCost.backToShipments': '← Container list',
  'report.landedCost.skuBreakdown': 'Cost breakdown',
  'report.landedCost.skuTotal': '{sku}: {qty} pcs × {cost}',
  'report.shipment.title': 'Container profitability',
  'report.shipment.description': '"Did this container make a profit?" is the core question of an import business. For each shipment: goods value, costs and the ratio between them.',
  'report.shipment.landedExplainer': 'Cost share is the most IMPORTANT column. It is the ratio of allocated costs to the goods value: 109% means that freight, customs, certificates and everything else together cost more than the goods themselves. This is why pricing from the Chinese invoice does not work.',
  'report.shipment.docNo': 'Document',
  'report.shipment.containerNo': 'Container',
  'report.shipment.eta': 'ETA',
  'report.shipment.ata': 'Arrived',
  'report.shipment.delay': 'Delay',
  'report.shipment.delayDays': '+{days} days',
  'report.shipment.earlyDays': '−{days} days',
  'report.shipment.onTime': 'On time',
  'report.shipment.lcStatus': 'Cost status',
  'report.shipment.skuCount': 'SKU',
  'report.shipment.receivedQty': 'Received',
  'report.shipment.shortageQty': 'Shortage',
  'report.shipment.purchaseValue': 'Goods value',
  'report.shipment.landedValue': 'Costs',
  'report.shipment.totalCost': 'Landed cost',
  'report.shipment.landedPct': 'Cost share',
  'report.shipment.openBreakdown': 'Breakdown',
  'report.shipment.rowHint': 'Click a row to open the cost breakdown of every SKU in that container.',
  'report.shipment.filterAll': 'All containers',
  'report.shipment.empty': 'No containers found',
  'report.shipment.emptyHint': 'It is possible that no shipment has been received yet.',
  'report.reorder.title': 'When to reorder',
  'report.reorder.description': 'Lead time is 120–150 days. The rule "we ran out, so I order now" means a four-month gap — the decision has to be made long before the stock runs out.',
  'report.reorder.formula': 'Daily average = SALES issues over the last {lookback} days ÷ {lookback}. Cover = (stock + in transit) ÷ daily average. When cover falls below lead time plus safety stock, it is time to order. Transfers and sample issues do not count as demand: they are not sales.',
  'report.reorder.lookbackDays': 'Demand period, days',
  'report.reorder.safetyDays': 'Safety stock, days',
  'report.reorder.leadTimeDays': 'Default lead time, days',
  'report.reorder.leadTimeHint': 'If the supplier has an actual lead time set, that one is used; this value applies only to the rest.',
  'report.reorder.onHand': 'Stock',
  'report.reorder.inTransit': 'In transit',
  'report.reorder.sold': 'Sold (period)',
  'report.reorder.dailyAverage': 'Daily average',
  'report.reorder.daysOfCover': 'Cover, days',
  'report.reorder.leadTime': 'Lead time',
  'report.reorder.suggestedQty': 'Suggested quantity',
  'report.reorder.status': 'Status',
  'report.reorder.status.order_now': 'ORDER NOW',
  'report.reorder.status.ok': 'Sufficient',
  'report.reorder.status.no_demand': 'No demand',
  'report.reorder.noDemandHint': 'There were no sales at all during the period, so cover is not calculated. This does not mean "sufficient" — it means "this product is not moving".',
  'report.reorder.empty': 'No purchased products found',
  'report.reorder.emptyHint': 'There may be no active products in the catalogue flagged as purchased.',
  'dashboard.pulse.title': 'Sales pulse',
  'dashboard.pulse.thisMonth': 'This month',
  'dashboard.pulse.today': 'Today',
  'dashboard.pulse.orders': '{count} lines',
  'dashboard.pulse.chartLabel': 'Daily revenue, this month',
  'dashboard.pulse.comparedTo': 'versus the same day last month',
  'dashboard.pulse.noSales': 'No sales this month yet',
  'dashboard.attention.title': 'Needs attention',
  'dashboard.attention.allClear': 'Nothing urgent',
  'dashboard.attention.allClearHint': 'No overdue debt, no unreceived transfers and no products running out.',
  'dashboard.attention.transfers': 'Unreceived transfers',
  'dashboard.attention.discipline': 'Dealers off plan',
  'dashboard.attention.arOverdue': 'Overdue receivables',
  'dashboard.attention.reorder': 'Time to reorder',
  'dashboard.attention.deadStock': 'Slow-moving stock',
  'dashboard.attention.counts': 'Open stock counts',
  'dashboard.attention.items': '{count} items',
  'dashboard.attention.unknown': 'Could not load',
  'dashboard.topProducts': 'Top selling products',
  'dashboard.share': 'Share',
  'nav.reorderRuns': 'Auto reorder',
  'reorder.title': 'Auto reorder',
  'reorder.description': 'The system runs the analysis itself on the category schedule: what is running out, how much is needed and from which factory. The result is draft purchase orders — a human does the approval.',
  'reorder.new': 'New run',
  'reorder.runDue': 'Check due categories',
  'reorder.docNo': 'Document',
  'reorder.runDate': 'Date',
  'reorder.category': 'Category',
  'reorder.categoryAll': 'All categories',
  'reorder.lineCount': 'Lines',
  'reorder.suggestedCount': 'To order',
  'reorder.poCount': 'Draft POs',
  'reorder.status': 'Status',
  'reorder.status.draft': 'New',
  'reorder.status.reviewed': 'Reviewed',
  'reorder.status.ordered': 'Ordered',
  'reorder.status.cancelled': 'Cancelled',
  'reorder.empty': 'No analysis has been run yet',
  'reorder.emptyHint': 'Start the first run with the "New run" button, or set a review period on the category.',
  'reorder.filterStatus': 'By status',
  'nav.staff': 'Staff',
  'nav.commission': 'Commission',
  'nav.kpi': 'KPI — plan versus actual',
  'hr.commission.title': 'Commission',
  'hr.commission.description': 'Commission for a period is calculated, reviewed and CLOSED. After closing the result does not change — if an error is found, a correction run is created.',
  'hr.commission.new': 'Calculate period',
  'hr.commission.preview': 'Dry run first',
  'hr.commission.docNo': 'Document',
  'hr.commission.period': 'Period',
  'hr.commission.employees': 'Employees',
  'hr.commission.totalNet': 'Payable',
  'hr.commission.totalDeduction': 'Deductions',
  'hr.commission.status': 'Status',
  'hr.commission.status.draft': 'Draft',
  'hr.commission.status.reviewed': 'Reviewed',
  'hr.commission.status.closed': 'Closed',
  'hr.commission.status.cancelled': 'Cancelled',
  'hr.commission.runType.regular': 'Regular',
  'hr.commission.runType.adjustment': 'Adjustment',
  'hr.commission.empty': 'No commission has been calculated yet',
  'hr.commission.emptyHint': 'A rule has to be defined first (a rate or tiers), then calculate the period. Calculating pays no one — it creates a draft.',
  'hr.commission.filterStatus': 'By status',
  'hr.commission.form.title': 'Calculate for period',
  'hr.commission.form.hint': 'Run a "dry run" first: it writes NOTHING and shows who gets how much. A real run reserves the period — there is one regular run per month.',
  'hr.commission.form.month': 'Month',
  'hr.commission.form.notes': 'Note',
  'hr.commission.form.dryRun': 'Dry run (nothing saved)',
  'hr.commission.form.submit': 'Calculate',
  'hr.commission.dryRunTitle': 'Dry run result — not saved',
  'hr.commission.dryRunHint': 'These numbers were not written to the database. You can change the rule and run it again.',
  'hr.commission.detail.title': 'Commission run',
  'hr.commission.employee': 'Employee',
  'hr.commission.rule': 'Rule',
  'hr.commission.basis': 'Basis',
  'hr.commission.basis.revenue': 'Revenue',
  'hr.commission.basis.gross_profit': 'Gross profit',
  'hr.commission.basis.collection': 'Collections',
  'hr.commission.basisAmount': 'Basis amount',
  'hr.commission.deductionBasis': 'Deductions from basis',
  'hr.commission.netBasis': 'Net basis',
  'hr.commission.rawCommission': 'Before deductions',
  'hr.commission.deduction': 'Deduction amount',
  'hr.commission.net': 'Payable',
  'hr.commission.rate': 'Effective rate',
  'hr.commission.orders': 'Orders',
  'hr.commission.customers': 'Customers',
  'hr.commission.newCustomers': 'New customers',
  'hr.commission.hiddenBasis': 'Not shown',
  'hr.commission.hiddenBasisHint': 'In a gross profit rule the basis amount is the margin. It is not disclosed to your role (spec §60). The payable amount is always visible.',
  'hr.commission.review': 'Reviewed',
  'hr.commission.close': 'CLOSE period',
  'hr.commission.closeConfirm': 'After closing the result CANNOT be changed. If an error is found, a correction run is created. Continue?',
  'hr.commission.closedAt': 'Closed',
  'hr.commission.correctsRun': 'Corrected run',
  'hr.commission.reviewFirst': 'The run has to be reviewed before closing — this action cannot be undone.',
  'hr.commission.flag.negative_basis': 'Deductions exceed the basis',
  'hr.commission.flag.negative_basisHint': 'Returns and cancellations exceeded sales. The commission was floored at zero — a negative commission is never recorded, because that would be a payroll deduction and that is a separate decision.',
  'hr.commission.flag.cap_hit': 'Cap reached',
  'hr.commission.flag.cap_hitHint': 'The maximum amount from the rule was applied. The employee may have earned more.',
  'hr.commission.flag.below_min_basis': 'Below the minimum basis',
  'hr.commission.flag.below_min_basisHint': 'The rule has a minimum threshold and the basis is below it — no commission is paid.',
  'hr.commission.flag.high_deduction': 'Deductions are too high',
  'hr.commission.flag.high_deductionHint': 'Deductions ate up more than half of the commission. This is almost never a sales issue but a different problem: the shop is not paying, there is a problem with the goods, or the orders are fake.',
  'hr.commission.flag.zero_commission': 'Zero commission',
  'hr.commission.flag.zero_commissionHint': 'There was a basis, but deductions or a rule condition left nothing to pay.',
  'hr.commission.flag.no_documents': 'No documents to calculate on',
  'hr.commission.flag.no_documentsHint': 'This is NOT "zero was paid". Not a single document reached the basis: the orders may still be drafts, or the payment has not arrived. The answer is not in the rule but in the process.',
  'hr.commission.sources': 'Source documents',
  'hr.commission.sources.hint': 'Every number is backed by a document. The total was checked against the basis during the run.',
  'hr.commission.sources.kind': 'Type',
  'hr.commission.sources.doc': 'Document',
  'hr.commission.sources.date': 'Date',
  'hr.commission.sources.amount': 'Amount',
  'hr.commission.sources.earning': 'To basis',
  'hr.commission.sources.return': 'Return',
  'hr.commission.sources.cancellation': 'Cancelled',
  'hr.commission.sources.overdue': 'Overdue',
  'hr.commission.sources.empty': 'No source documents',
  'hr.commission.sources.hidden': 'On a gross profit basis the source list also reveals the margin, so it is not shown.',
  'hr.rule.title': 'Commission rules',
  'hr.rule.code': 'Code',
  'hr.rule.name': 'Name',
  'hr.rule.target': 'Applies to',
  'hr.rule.targetAll': 'All employees',
  'hr.rule.method': 'Method',
  'hr.rule.method.percent': 'Percentage',
  'hr.rule.method.tiered': 'Tiered',
  'hr.rule.method.fixed': 'Fixed amount',
  'hr.rule.tiers': 'Tiers',
  'hr.rule.cap': 'Cap',
  'hr.rule.deductions': 'Deductions',
  'hr.rule.empty': 'No commission rules defined',
  'hr.rule.emptyHint': 'Without a rule the run creates no rows at all. A rule is defined for a role or for a specific employee.',
  'hr.kpi.title': 'KPI — plan versus actual',
  'hr.kpi.description': 'The actuals are calculated AT THE SAME TIME as the commission run and from the same numbers. There is no separate run, so the two cannot drift apart.',
  'hr.kpi.metric': 'Metric',
  'hr.kpi.plan': 'Plan',
  'hr.kpi.actual': 'Actual',
  'hr.kpi.achievement': 'Achievement',
  'hr.kpi.noPlan': 'No plan set',
  'hr.kpi.noPlanHint': 'No plan does NOT mean "not met". The achievement percentage is not shown either.',
  'hr.kpi.met': 'Met',
  'hr.kpi.notMet': 'Not met',
  'hr.kpi.empty': 'No KPI calculated for this period',
  'hr.kpi.emptyHint': 'KPIs are written together with the commission run. Calculate the period first.',
  'hr.kpi.metric.sales_volume': 'Sales volume',
  'hr.kpi.metric.gross_profit': 'Gross profit',
  'hr.kpi.metric.collection': 'Collections',
  'hr.kpi.metric.new_customers': 'New customers',
  'hr.kpi.metric.repeat_customers': 'Repeat customers',
  'hr.kpi.metric.avg_order': 'Average order',
  'hr.kpi.metric.order_count': 'Order count',
  'hr.kpi.metric.return_rate': 'Return rate',
  'hr.kpi.returnRateHint': 'For this metric LOWER is better: coming in under plan is a good result.',
  'hr.kpi.month': 'Month',
  'hr.kpi.employee': 'Employee',
  'hr.kpi.allEmployees': 'All employees',
  'reorder.form.title': 'New run',
  'reorder.form.hint': 'If a parameter is left empty it is taken from the category settings. The parameters are stored TOGETHER with the result — even if the category changes later, this run is still read with its own assumptions.',
  'reorder.form.lookbackDays': 'Demand period, days',
  'reorder.form.coverDays': 'Cover period, days',
  'reorder.form.safetyDays': 'Safety stock, days',
  'reorder.form.includeInTransit': 'Include stock in transit',
  'reorder.form.includeInTransitHint': 'Normally yes. Turn it off in periods when the factory has missed its deadlines several times: once a container marked as in transit can no longer be trusted, counting it as stock only creates a new gap.',
  'reorder.form.notes': 'Note',
  'reorder.form.submit': 'Run the analysis',
  'reorder.form.duplicate': 'An analysis has already been run for this category today. Open it, or run it again tomorrow.',
  'reorder.due.title': 'Categories that are due',
  'reorder.due.hint': 'Nothing is written at first — only a list is shown. After you confirm, a separate analysis is created for each one.',
  'reorder.due.none': 'No category is due today',
  'reorder.due.every': 'Every {days} days',
  'reorder.due.lastRun': 'Last analysis',
  'reorder.due.never': 'Never',
  'reorder.due.run': 'Analyse {count} categories',
  'reorder.due.created': '{count} analyses created',
  'reorder.detail.params': 'Assumptions',
  'reorder.detail.paramsValue': 'Demand period {lookback} days · cover {cover} days · safety stock {safety} days · in transit: {inTransit}',
  'reorder.detail.review': 'Mark as reviewed',
  'reorder.detail.createOrders': 'Create draft orders',
  'reorder.detail.createOrdersHint': 'Grouped by supplier. The documents stay DRAFTS — the system cannot commit to 3–4 months on its own.',
  'reorder.detail.ordersCreated': '{count} draft orders created',
  'reorder.detail.skipped': 'Not included in the order: rejected {rejected} · no supplier {noSupplier} · zero quantity {zeroQty}',
  'reorder.detail.missingPrice': '{count} lines without a price',
  'reorder.detail.alreadyOrdered': 'Orders have already been created from this analysis',
  'reorder.detail.openPo': 'Open order',
  'reorder.line.sku': 'SKU',
  'reorder.line.name': 'Name',
  'reorder.line.onHand': 'Stock',
  'reorder.line.inTransit': 'In transit',
  'reorder.line.inTransitHint': 'The remaining part of confirmed purchase orders: goods in production at the factory and goods arriving in a container.',
  'reorder.line.reserved': 'Reserved',
  'reorder.line.sold': 'Sold',
  'reorder.line.dailyAvg': 'Daily average',
  'reorder.line.leadTime': 'Lead time',
  'reorder.line.target': 'Required',
  'reorder.line.suggested': 'To order',
  'reorder.line.supplier': 'Supplier',
  'reorder.line.noSupplier': 'No supplier',
  'reorder.line.edit': 'Adjust',
  'reorder.line.reject': 'Reject',
  'reorder.line.rejected': 'Rejected',
  'reorder.line.restore': 'Restore',
  'reorder.line.rejectReason': 'Rejection reason',
  'reorder.line.rejectReasonHint': 'At least 3 characters. The reason stays on the document.',
  'reorder.line.onlySuggested': 'Only lines that will be ordered',
  'reorder.line.empty': 'No lines',
  'reorder.flag.negative_stock': 'Negative stock',
  'reorder.flag.negative_stockHint': 'This product is already oversold — it is first in the list.',
  'reorder.flag.no_supplier': 'No supplier',
  'reorder.flag.no_supplierHint': 'No active supplier is linked to the product — it will not be included in the order.',
  'reorder.flag.no_price': 'Price unknown',
  'reorder.flag.no_priceHint': 'The draft will carry a price of 0. The order is not stopped: delaying a 4-month order because of a single SKU without a price is exactly what we are trying to prevent.',
  'reorder.flag.above_formula': 'Above formula',
  'reorder.flag.above_formulaHint': 'Reason: MOQ (minimum order quantity) or a manual adjustment.',
  'reorder.flag.below_formula': 'Below formula',
  'reorder.flag.below_formulaHint': 'The quantity was reduced manually.',
  'reorder.flag.draft_po': 'Unconfirmed draft exists',
  'reorder.flag.draft_poHint': 'There is an open draft for this SKU and it is NOT counted here (it is not a commitment). The answer may be to confirm that draft rather than create a new order.',
  'table.rowsPerPage': 'Rows per page',
  'table.page': '{page} / {total}',
  'table.first': 'First',
  'table.previous': 'Previous',
  'table.next': 'Next',
  'table.last': 'Last',
  'table.empty': 'No rows found',
  'table.sortAsc': 'Ascending',
  'table.sortDesc': 'Descending',
  'table.total': 'Total: {count}',
  'table.addRow': 'New row (Enter)',
  'table.loadError': 'Could not load the data',
  'table.pending': 'This screen is not ready yet',
  // --- Bulk row actions ---
  'table.selectedCount': '{count} rows selected',
  'table.selectAll': 'Select all on this page',
  'table.selectRow': 'Select row',
  'table.expandRow': 'Show contents',
  'table.collapseRow': 'Hide contents',
  'bulk.progress': 'Running: {done} / {total}',
  'bulk.partial': 'Succeeded: {ok} · Failed: {failed}',
  'bulk.allDone': 'All done: {count}',
  'bulk.failedHint': 'Open the failed ones one by one — each stopped for its own reason.',
  'table.columns': 'Columns',
  'table.columnsAll': 'Show all',
  'table.columnsLast': 'At least one column must stay visible',
  'table.clearSearch': 'Clear search',
  'picker.product': 'Product',
  'picker.productPlaceholder': 'SKU or name',
  'picker.productEmpty': 'Product not found — try the old code as well',
  'picker.productNoStock': 'No stock',
  'picker.customer': 'Customer',
  'picker.customerPlaceholder': 'Code, name or phone',
  'picker.customerEmpty': 'Customer not found',
  'warehouse.title': 'Warehouse',
  'warehouse.select': 'Select a warehouse',
  'warehouse.all': 'All warehouses',
  'warehouse.from': 'From warehouse',
  'warehouse.to': 'To warehouse',
  'inv.qty': 'Quantity',
  'inv.unitCost': 'Unit cost',
  'inv.lotNo': 'Lot',
  'inv.notes': 'Note',
  'inv.occurredAt': 'Document date',
  'inv.occurredAtHint': 'Entering yesterday\'s document today is normal — the date must reflect the day the event actually happened.',
  'inv.product': 'Product',
  'inv.sku': 'SKU',
  'inv.name': 'Name',
  'inv.warnings': 'Warnings',
  'inv.done': 'Done',
  'inv.lineAdd': 'Add line',
  'inv.lineRemove': 'Remove line',
  'inv.selectWarehouseFirst': 'Select a warehouse first',
  'inv.docNo': 'Document',
  'inv.status': 'Status',
  'inv.date': 'Date',
  'stock.title': 'Warehouse stock',
  'stock.description': 'Current stock. Every row leads to the ledger: the answer to "where did this number come from?" is one click away.',
  'stock.searchPlaceholder': 'Search by SKU or name',
  'stock.onHand': 'Stock',
  'stock.reserved': 'Reserved',
  'stock.available': 'Available',
  'stock.inTransit': 'In transit',
  'stock.avgCost': 'Average cost',
  'stock.totalValue': 'Value',
  'stock.updatedAt': 'Last movement',
  'stock.includeZero': 'Show zero stock as well',
  'stock.includeZeroHint': 'A SKU that arrived once and sold out completely stays as a zero row forever — that is why such rows are normally hidden.',
  'stock.empty': 'No stock found',
  'stock.emptyHint': 'Widen the filter or turn on zero stock.',
  'stock.loadError': 'Could not load stock',
  'stock.valueHidden': 'The cost and value columns are not shown to you — this is a permission matter, not an error.',
  'stock.categoryGap': 'This screen has no breakdown by category. The category breakdown is in the "Warehouse stock" report.',
  'stock.openReport': 'Stock report →',
  'stock.rowHint': 'Click a row — the ledger for that product and warehouse opens.',
  'movement.title': 'Warehouse ledger',
  'movement.description': 'Every goods receipt and goods issue. Any number in stock opens up here line by line — an accounting argument ends at this table.',
  'movement.occurredAt': 'Time',
  'movement.txnType': 'Type',
  'movement.txnTypeAll': 'All types',
  'movement.quantity': 'Quantity',
  'movement.balanceQty': 'Stock (after)',
  'movement.unitCost': 'Unit cost',
  'movement.totalCost': 'Amount',
  'movement.avgCostAfter': 'Average (after)',
  'movement.source': 'Source',
  'movement.sourceAll': 'All documents',
  'movement.sourceRef': '{table} — document #{id}',
  'movement.reversal': 'Reversal',
  'movement.reversed': 'Reversed',
  'movement.empty': 'No movements found',
  'movement.emptyHint': 'Widen the period or remove the product filter.',
  'movement.loadError': 'Could not load the ledger',
  'movement.filterProduct': 'By product',
  'movement.clearFilters': 'Clear filters',
  'txn.receipt': 'Goods receipt',
  'txn.issue': 'Goods issue',
  'txn.transfer_in': 'Transfer (in)',
  'txn.transfer_out': 'Transfer (out)',
  'txn.adjustment': 'Adjustment',
  'txn.count': 'Stock count',
  'txn.return_in': 'Customer return',
  'txn.return_out': 'Return to supplier',
  'txn.revaluation': 'Revaluation',
  'txn.sample': 'Sample',
  'txn.display': 'Showroom',
  'txn.trial_out': 'Issued for trial',
  'txn.trial_in': 'Returned from trial',
  'src.manual': 'Manual',
  'src.stock_transfer_lines': 'Transfer between warehouses',
  'src.stock_count_lines': 'Stock count',
  'src.delivery_lines': 'Delivery note',
  'src.goods_receipt_lines': 'Receipt (import)',
  'src.sales_return_lines': 'Goods returned',
  'src.partner_supply_notices': 'Supply notice',
  'src.unknown': 'Other document',
  'receipt.title': 'Manual goods receipt',
  'receipt.description': 'Receipts OTHER than import receiving: goods returned by a customer, a sample back from trial, stock found by hand.',
  'receipt.txnType': 'Receipt type',
  'receipt.submit': 'Post receipt',
  'receipt.costWhy': 'Cost is MANDATORY: without it the average cost is not calculated and the COGS of the next issue comes out wrong.',
  'receipt.done': 'Receipt posted: {qty} {sku}',
  'receipt.importHint': 'Container receiving is not entered on this screen — it comes from the purchase document (goods receipt) and calculates landed cost.',
  'issue.title': 'Manual goods issue',
  'issue.description': 'Issues OTHER than sales: sample, showroom, trial hand-out, return to supplier.',
  'issue.txnType': 'Issue type',
  'issue.submit': 'Post issue',
  'issue.noCost': 'Cost is not entered on an issue: it is valued at the CURRENT average. Setting the issue price by hand would open a way to "adjust" profit.',
  'issue.done': 'Issue posted: {qty} {sku}',
  'issue.available': 'Available stock: {qty}',
  'transfer.title': 'Warehouse transfer',
  'transfer.description': 'The issue is posted IMMEDIATELY: the goods are physically in transit, and showing them in the source warehouse stock would be a lie. The receipt happens on arrival.',
  'transfer.new': 'New transfer',
  'transfer.create': 'Create transfer',
  'transfer.sameWarehouse': 'The source and destination warehouse cannot be the same',
  'transfer.lines': 'Lines',
  'transfer.receive': 'Receive',
  'transfer.partialHint': 'Enter ZERO for a line that did not arrive — the missing quantity stays on the document and raises a warning.',
  'transfer.receiveFull': 'Receive everything in full',
  'transfer.receivePartial': 'Partial receipt',
  'transfer.receivedQty': 'Received',
  'transfer.sentQty': 'Sent',
  'transfer.status.in_transit': 'In transit',
  'transfer.status.received': 'Received',
  'transfer.status.cancelled': 'Cancelled',
  'transfer.list': 'Transfer documents',
  'transfer.statusAll': 'All statuses',
  'transfer.lineCount': 'Lines',
  'transfer.totalQty': 'Total quantity',
  'transfer.createdBy': 'Created by',
  'transfer.empty': 'No transfer documents found',
  'transfer.emptyHint': 'Widen the filter or create a new transfer.',
  'transfer.loadError': 'Could not load transfer documents',
  'transfer.pending': 'Awaiting receipt: {count}',
  'transfer.pendingNone': 'No transfers are awaiting receipt',
  'transfer.openDoc': 'Open document',
  'transfer.closeDoc': 'Close document',
  'transfer.created': 'Transfer created: {docNo}',
  'transfer.receivedOk': '{docNo} received',
  'transfer.ledger': 'Transfer movements (from the ledger)',
  'count.title': 'Stock count',
  'count.description': 'The storekeeper enters the count, but ANOTHER employee approves it. A shortage counted and approved by the same person is visible to no one.',
  'count.new': 'New sheet',
  'count.create': 'Create sheet',
  'count.type': 'Count type',
  'count.type.full': 'Full (whole warehouse)',
  'count.type.cycle': 'Cycle (selected SKUs)',
  'count.type.blind': 'Blind count (system stock is hidden)',
  'count.typeHint': 'In a blind count the system stock is not shown to the counter. An employee who sees the number involuntarily writes down something that matches it, and the count loses its meaning.',
  'count.products': 'Products to count',
  'count.productsHint': 'If left empty, EVERY product that has a row in the warehouse goes onto the sheet (a full stock count).',
  'count.systemQty': 'System',
  'count.countedQty': 'Counted',
  'count.varianceQty': 'Variance',
  'count.varianceValue': 'Variance value',
  'count.reason': 'Reason',
  'count.reasonRequired': 'A reason must be given on a line with a variance',
  'count.saveLines': 'Save lines',
  'count.post': 'Approve and post to the ledger',
  'count.postHint': 'After approval the variances are posted to the warehouse ledger and cannot be undone.',
  'count.created': 'Sheet created: {docNo}',
  'count.saved': 'Lines saved',
  'count.posted': '{docNo} approved and posted to the ledger',
  'count.approveElsewhere': 'You cannot approve this sheet — this is deliberate: a shortage counted and approved by the same person is visible to no one. Save the lines and notify finance or your manager.',
  'count.list': 'Stock count documents',
  'count.kind': 'Document type',
  'count.kind.all': 'All',
  'count.kind.count': 'Stock count (CNT)',
  'count.kind.adjustment': 'Adjustment (ADJ)',
  'count.kindHint': 'Counts and adjustments are stored in one table and differ only by the document number prefix. Showing them mixed together raises the question "where did this document come from?".',
  'count.statusAll': 'All statuses',
  'count.lineCount': 'Lines',
  'count.varianceLines': 'Lines with variance',
  'count.createdBy': 'Created by',
  'count.empty': 'No stock count documents found',
  'count.emptyHint': 'Widen the filter or create a new sheet.',
  'count.loadError': 'Could not load stock count documents',
  'count.open': 'Open sheets: {count}',
  'count.openDoc': 'Open sheet',
  'count.closeDoc': 'Close sheet',
  'count.detailLoadError': 'Could not load the sheet',
  'count.blindSystemHidden': 'Blind count: system stock is NOT SHOWN on this screen. The server does send it in the read response, but the screen does not draw it, to keep the count meaningful.',
  'count.varianceValueHint': 'The money value of the variance is shown on this screen alone — it is a separate, narrow permission, and cost is not revealed anywhere else.',
  'count.status.draft': 'Being entered',
  'count.status.counted': 'Counted',
  'count.status.posted': 'Approved',
  'count.status.cancelled': 'Cancelled',
  'variance.damaged': 'Damaged',
  'variance.lost': 'Lost',
  'variance.miscount': 'Miscounted',
  'variance.theft': 'Theft',
  'variance.found': 'Surplus found',
  'variance.expired': 'Expired',
  'variance.other': 'Other',
  'variance.select': 'Select a reason',
  'so.title': 'Sales orders',
  'so.new': 'New order',
  'so.searchPlaceholder': 'Document number or customer',
  'so.docNo': 'Document',
  'so.customer': 'Customer',
  'so.orderDate': 'Date',
  'so.deliveryDate': 'Delivery',
  'so.total': 'Amount',
  'so.paymentMethod': 'Payment',
  'so.status': 'Status',
  'so.statusAll': 'All statuses',
  'so.empty': 'No orders found',
  'so.emptyHint': 'Widen the filter or create a new order.',
  'so.loadError': 'Could not load orders',
  'so.onlyPreorder': 'Only those with pre-order lines',
  'so.onlyPreorderHint': 'Orders sold from a container in transit. When a container ETA shifts, these are the ones affected.',
  'so.status.draft': 'Draft',
  'so.status.submitted': 'Submitted',
  'so.status.confirmed': 'Confirmed',
  'so.status.partially_delivered': 'Partially shipped',
  'so.status.delivered': 'Shipped',
  'so.status.invoiced': 'Invoiced',
  'so.status.closed': 'Closed',
  'so.status.cancelled': 'Cancelled',
  'so.pay.cash': 'Cash',
  'so.pay.transfer': 'Bank transfer',
  'so.pay.mixed': 'Mixed',

  'so.source': 'Channel',
  'so.source.erp': 'Office',
  'so.source.agent': 'Agent',
  'so.source.portal': 'Online',
  'so.source.pos': 'POS',

  'so.kinds': 'Lines',
  'so.kindsHint':
    'How many lines the order has — the same rows you see when it is expanded. Not quantity.',
  'so.linesLoadError': 'Could not load the order lines',
  'so.linesEmpty': 'This order has no lines',
  'so.openCard': 'Open the order card',
  'so.newTitle': 'New sales order',
  'so.header': 'Order header',
  'so.currency': 'Currency',
  'so.paymentTermDays': 'Payment term, days',
  'so.notes': 'Note',
  'so.submit': 'Create order',
  'so.customerRequired': 'A customer must be selected',
  'so.warehouseRequired': 'A warehouse must be selected',
  'so.linesRequired': 'At least one complete line is required',
  'so.created': 'Order created: {docNo}',
  'so.keyboardTitle': 'Keyboard entry',
  'so.keyboardHint': 'Tab — next cell, Enter — new line, Escape — clear the line. In the product field ↓/↑ move through the list, and Tab picks the highlighted row and jumps to the quantity. No mouse needed.',
  'bulk.open': 'Paste a list',
  'bulk.title': 'Paste the list',
  'bulk.hint': 'One row per line: CODE, quantity, price. Columns are separated by TAB or «;» (copying from Excel gives you that automatically). Leave the price empty and the contract price for that customer is used.',
  'bulk.placeholder': 'LMP-001\t10\nPNL-060\t25\t24.50',
  'bulk.hintNoPrice': 'One row per line: CODE, quantity. Columns are separated by TAB or «;» (copying from Excel gives you that automatically). This document has no price — the server derives it.',
  'bulk.placeholderNoPrice': 'LMP-001\t10\nPNL-060\t25',
  'bulk.rows': '{count} rows',
  'bulk.apply': 'Add',
  'bulk.resolving': 'Checking codes…',
  'bulk.tooMany': 'Up to {max} rows at a time. Paste the list in parts — nothing is lost.',
  'bulk.invalid': '{count} rows have errors (lines: {lines}). The code is empty, the quantity is not greater than zero, or the price format is wrong.',
  'bulk.unknownTitle': 'These codes were not found',
  'bulk.unknownBody': '{skus} — the rest were added. Check the code, or add the product to the catalogue first.',
  'bulk.noneResolved': 'Not a single code was found — nothing was added',
  'so.lines': 'Lines',
  'so.lineNo': '#',
  'so.lineQty': 'Quantity',
  'so.lineListPrice': 'List price',
  'so.linePrice': 'Price',
  'so.lineAmount': 'Amount',
  'so.lineDiscount': 'Discount',
  'so.lineType': 'Fulfilment',
  'so.linePriceSource': 'Price source',
  'so.lineBonus': 'Bonus',
  'so.lineRemove': 'Remove line',
  'so.lineAdd': 'Add line (Enter)',
  'so.priceLoading': 'Determining the price…',
  'so.priceMissing': 'Price not found — enter it manually',
  'price.customer_price': 'Customer price',
  'price.price_list': 'Price list',
  'price.manual': 'Manual',
  'price.sourceHint.customer_price': 'Special price agreed with the customer',
  'price.sourceHint.price_list': 'From price list "{code}"',
  'price.sourceHint.manual': 'Price entered manually — implied discount {pct}%',
  'so.fulfillment.stock': 'In stock',
  'so.fulfillment.preorder': 'In transit (pre-order)',
  'so.preorderShipment': 'Container',
  'so.preorderShipmentRequired': 'A container must be selected for a pre-order line',
  'so.preorderSelectShipment': 'Select a container',
  'so.preorderEta': 'ETA {date}',
  'so.preorderFree': 'available {qty}',
  'so.preorderNoShipment': 'This product is not in any open container',
  'so.preorderNoAccess': 'You do not have permission to view the container list — you cannot enter a pre-order line. Ask your manager if you need it.',
  'so.promisedDate': 'Promised date',
  'so.promisedDateHint': 'The date told to the customer. When a container ETA shifts, the warning comes for this line.',
  'so.preorderWhy': 'Lead time is 120–150 days: the customer buys goods that have not even left China yet. This is not an exception, it is half the business — so "in stock" and "in transit" on a line must never be CONFUSED.',
  'so.mixSummary': '{stock} lines in stock, {preorder} lines in transit',
  'so.bonusHint': 'A bonus line is priced at 0, but its COST is real: these goods cost the company money and are subtracted from the margin. A bonus is a hidden discount.',
  'so.bonusCostWarning': 'Bonus: price 0, cost is still kept',
  'so.bonusValue': 'Bonus value (at list price)',
  'so.totals': 'Totals',
  'so.subtotal': 'Line total',
  'so.discountTotal': 'Discount',
  'so.grandTotal': 'Amount payable',
  'so.totalPreview': 'Preliminary calculation — the final amount comes back from the server',
  'so.lineCount': '{count} lines',
  'so.paymentChanged': 'Payment method changed: {from} → {to}',
  'so.paymentChangedBody': 'Every line has been REPRICED. Cash and bank transfer prices differ by 3–7%, and that difference must not disappear quietly — what changed is shown below.',
  'so.repricing': 'Repricing the lines…',
  'so.repricedNone': 'No line price changed.',
  'so.repricedManualKept': 'Manually entered prices were left untouched — they are the result of a negotiation and are not corrected automatically.',
  'so.repricedOld': 'Old price',
  'so.repricedNew': 'New price',
  'so.repricedDelta': 'Difference',
  'so.repricedLost': 'No price found for this payment method',
  'so.dismiss': 'Close',
  'so.credit': 'Credit status',
  'so.creditLimit': 'Limit',
  'so.creditDebt': 'Current debt',
  'so.creditAvailable': 'Available limit',
  'so.creditOverdue': 'Overdue',
  'so.creditBlockedCustomer': 'The customer is BLOCKED — this order will not be confirmed',
  'so.creditWillExceed': 'The order amount exceeds the available limit. The credit check will stop it on confirmation.',
  'so.creditNoLimit': 'No limit set',
  'so.creditCurrencyNote': 'The comparison is shown only for USD orders: debt is kept in USD, and an amount in another currency is converted at the server FX rate.',
  'so.creditLoadError': 'Could not load the customer\'s debt',
  'so.detailTitle': 'Order {docNo}',
  'so.confirm': 'Confirm',
  'so.confirmHint': 'On confirmation the credit limit is checked and the goods are reserved.',
  'so.confirmed': 'Order confirmed',
  'so.cancel': 'Cancel',
  'so.cancelTitle': 'Cancel the order',
  'so.cancelReason': 'Cancellation reason',
  'so.cancelReasonRequired': 'The reason must be at least 3 characters long',
  'so.cancelled': 'Order cancelled',
  'so.createDelivery': 'Create delivery note',
  'so.createDeliveryHint': 'The delivery note is created but NOT POSTED: it is printed, loaded onto the vehicle, and the storekeeper confirms it once the goods have left.',
  'so.deliveryCreated': 'Delivery note created: {docNo}',
  'so.createInvoice': 'Create invoice',
  'so.createInvoiceHint': 'An invoice is issued for goods that ACTUALLY left — it is built from the lines of a posted delivery note.',
  'so.invoiceCreated': 'Invoice created: {docNo}',
  'so.deliveries': 'Delivery notes',
  'so.invoices': 'Invoices',
  'so.noDeliveries': 'No delivery notes',
  'so.noInvoices': 'No invoices',
  'so.notFound': 'Order not found or not visible to you',
  'so.deliveredQty': 'Shipped',
  'so.creditCheck': 'Credit check',
  'so.creditCheck.passed': 'Passed',
  'so.creditCheck.blocked': 'Blocked',
  'so.creditBlockedBody': 'This order is on hold because of the credit limit. It has not been cancelled — it is open for negotiation: if the customer pays or a manager overrides the limit, confirmation continues.',
  'so.creditCheck.overridden': 'LIMIT OVERRIDDEN',
  'so.creditOverriddenTitle': 'This order was pushed through OVER the credit limit',
  'so.creditOverriddenBody': 'The customer\'s open debt exceeds the limit, but an employee deliberately let the order through. The reason is kept in the audit log. This decision cannot be made invisible — if the debt is never collected, the answer starts at this line.',
  'so.overrideTitle': 'Override the credit limit',
  'so.overrideReason': 'Reason',
  'so.overrideReasonRequired': 'The reason must be at least 5 characters long',
  'so.overrideSubmit': 'Confirm with a reason',
  'so.overrideNoPermission': 'You do not have permission to override the credit limit. Contact your manager.',
  'so.margin': 'Margin',
  'so.marginCogs': 'Cost',
  'so.marginProfit': 'Gross profit',
  'so.marginPct': 'Margin, %',
  'so.marginBonusCost': 'Bonus cost',
  'so.marginHidden': 'Margin figures are not revealed to you — this is a permission matter.',
  'dlv.title': 'Deliveries',
  'dlv.description': 'What is being delivered today and who is taking it. Once a delivery note is issued, a driver is assigned to it — the storekeeper loads the vehicle, so he also knows who to hand it to.',
  'dlv.docNo': 'Delivery note',
  'dlv.salesOrder': 'Order',
  'dlv.date': 'Date',
  'dlv.status': 'Document status',
  'dlv.status.draft': 'Draft',
  'dlv.status.posted': 'Posted',
  'dlv.status.cancelled': 'Cancelled',
  'dlv.statusAll': 'All statuses',
  'dlv.driver': 'Driver',
  'dlv.driverAll': 'All drivers',
  'dlv.driverStatus': 'Delivery status',
  'dlv.driverStatus.unassigned': 'Unassigned',
  'dlv.driverStatus.pending': 'Pending',
  'dlv.driverStatus.delivered': 'Delivered',
  'dlv.driverStatus.failed': 'Not delivered',
  'dlv.filterUnassigned': 'Unassigned only',
  'dlv.filterUnassignedHint': 'The morning starts with this list: deliveries that have not been handed to anyone yet.',
  'dlv.filterDate': 'Delivery date',
  'dlv.searchPlaceholder': 'Delivery note or order number',
  'dlv.empty': 'No deliveries found',
  'dlv.emptyHint': 'Widen the date or status filter.',
  'dlv.loadError': 'Could not load the delivery list',
  'dlv.actions': 'Action',
  'dlv.assign': 'Assign',
  'dlv.reassign': 'Reassign',
  'dlv.unassign': 'Unassign',
  'dlv.assignTitle': '{docNo} — assign to a driver',
  'dlv.assignDriverPlaceholder': 'Select a driver',
  'dlv.assignMany': 'Assign to {count} deliveries',
  'dlv.assignVehicle': 'Vehicle number',
  'dlv.assignVehicleHint': 'Optional. You can see the vehicle being loaded right now — entering it later on a separate screen almost never happens.',
  'dlv.assignSubmit': 'Assign',
  'dlv.assigned': '{docNo} — assigned to {driver}',
  'dlv.unassignDone': '{docNo} — assignment removed',
  'dlv.unassignHint': 'Removing it clears both the driver name and the vehicle number: they were recorded from that driver during assignment.',
  'dlv.assignedAt': 'Assigned',
  'dlv.driversEmpty': 'No active drivers. To assign one, an employee must first be given the driver role — the administrator does that.',
  'dlv.driversLoadError': 'Could not load the driver list',
  'dlv.notAssignable': 'Cannot be changed',
  'dlv.notAssignableHint': 'A cancelled document or a completed delivery cannot be reassigned — that would mean rewriting history.',
  'dlv.failReason': 'Reason for failed delivery',
  'dlv.receivedBy': 'Received by',
  'dlv.deliveredAt': 'Delivered at',
  'dlv.cashTitle': 'Cash held by drivers',
  'dlv.cashHint': 'This is NOT a payment: it does not reduce the customer\'s debt and has not reached the cash account. When the money is handed over, the finance officer creates the payment — that is when the debt is settled.',
  'dlv.cashEmpty': 'No cash was collected by drivers in this period',
  'dlv.cashLoadError': 'Could not load cash data',
  'dlv.cashDeliveries': '{count} deliveries',
  'dlv.cashTotal': 'Total',
  'dlv.cashAmount': 'Amount',
  'customer.tab.card': 'Card',
  'customer.tab.portal': 'Portal users',
  'pu.title': 'Customer portal users',
  'pu.description': 'Shop staff sign in to the portal with a PHONE number. Each employee gets a separate account, so you can later tell who placed an order.',
  'pu.empty': 'This customer has no portal users',
  'pu.emptyHint': 'Once the portal is opened, the shopkeeper enters orders directly and can see their debt.',
  'pu.loadError': 'Could not load portal users',
  'pu.phone': 'Phone',
  'pu.fullName': 'Name',
  'pu.position': 'Position',
  'pu.positionHint': 'Their role in the shop: owner, salesperson, accountant. Free text.',
  'pu.canOrder': 'Ordering',
  'pu.canOrder.yes': 'Can place orders',
  'pu.canOrder.no': 'View only',
  'pu.canOrderHint': '"View only" is NOT a block: the person signs in to the portal and sees the catalogue, their debt and their order history, but cannot submit a new order. That is exactly what a shop accountant needs.',
  'pu.status': 'Status',
  'pu.active': 'Active',
  'pu.blocked': 'Blocked',
  'pu.mustChange': 'Must change password',
  'pu.invitedAt': 'Opened',
  'pu.lastLoginAt': 'Last sign-in',
  'pu.neverLoggedIn': 'Never signed in',
  'pu.new': 'Open portal access',
  'pu.newTitle': 'New portal user',
  'pu.phoneHint': 'Enter it in any format (+998 90 123-45-67 works too) — the server normalises it to a single form.',
  'pu.phoneRequired': 'The phone number must be at least 9 characters',
  'pu.fullNameRequired': 'The name must be at least 2 characters',
  'pu.submit': 'Open access and issue password',
  'pu.block': 'Block',
  'pu.unblock': 'Unblock',
  'pu.blockTitle': '{name} — block portal access',
  'pu.blockReasonRequired': 'The block reason must be at least 3 characters',
  'pu.blockReasonWhy': 'The reason stays in the audit trail: a month later, someone will inevitably ask why this account was closed.',
  'pu.blockDone': '{name} — portal access blocked',
  'pu.unblockDone': '{name} — portal access restored',
  'pu.reset': 'Reset password',
  'pu.resetHint': 'The old password stops working immediately and open sessions are terminated. You deliver the new password to the shopkeeper yourself.',
  'pu.secretTitle': 'Temporary password — shown ONCE',
  'pu.secretBody': 'Write this password down now or tell it to the shopkeeper. Only its hash is stored in the database, so the server WILL NOT SHOW IT AGAIN: once this window closes, the only option is another password reset.',
  'pu.secretFor': '{name} · {phone}',
  'pu.secretAck': 'I have written it down',
  'pu.actions': 'Action',
  'pu.created': 'Portal access opened for {name}',
  'pu.resetDone': 'A new password was issued for {name}',
  'po.title': 'Purchase orders',
  'po.description': 'An order placed with the Chinese factory. Lines are in the factory currency (CNY), with the US dollar equivalent alongside at the DOCUMENT rate — not at today\'s rate.',
  'po.new': 'New order',
  'po.newTitle': 'New purchase order',
  'po.detailTitle': 'Purchase order {docNo}',
  'po.searchPlaceholder': 'Document number or supplier',
  'po.docNo': 'Document',
  'po.supplier': 'Supplier',
  'po.supplierRequired': 'A supplier must be selected',
  'po.legalEntity': 'Legal entity',
  'po.orderDate': 'Order date',
  'po.expectedDate': 'Expected date',
  'po.expectedDateHint': 'The date expected from the factory. Lead time is 120–150 days — planning is based on that.',
  'po.currency': 'Currency',
  'po.status': 'Status',
  'po.statusAll': 'All statuses',
  'po.notes': 'Notes',
  'po.lines': 'Lines',
  'po.lineQty': 'Quantity',
  'po.lineUnitPrice': 'Price ({currency}/pc)',
  'po.lineAmount': 'Amount ({currency})',
  'po.lineBase': 'USD equivalent',
  'po.received': 'Received',
  'po.outstanding': 'Pending',
  'po.total': 'Total ({currency})',
  'po.totalBase': 'Total (USD)',
  'po.fxRate': 'Document rate',
  'po.fxRateLine': '1 USD = {rate} {currency}',
  'po.fxRateWhy': 'The USD equivalent is calculated at the DOCUMENT rate, not at today\'s rate. If the order was placed 4 months ago, that day\'s rate has nothing to do with today\'s value — the rate is fixed on the document and does not change.',
  'po.priceHidden': 'The price and amount columns are hidden from you — you do not have permission to view supplier data. This is a permission matter, not an error; ask your manager if you need it.',
  'po.submit': 'Create order',
  'po.created': 'Order created: {docNo}',
  'po.approve': 'Approve',
  'po.approveTitle': 'Approve order',
  'po.approveHint': 'Once approved, the order counts as sent to the factory and its lines can no longer be changed: if the document drifts from the goods actually in transit, the difference shows up as a "shortage" at receipt when in fact the document is wrong.',
  'po.approveNotes': 'Notes (recorded in the audit trail)',
  'po.approved': 'Order approved',
  'po.approvedAt': 'Approved',
  'po.notApprovable': 'Approval is not possible in this status — only draft and submitted orders can be approved.',
  'po.cancel': 'Cancel',
  'po.cancelTitle': 'Cancel order',
  'po.cancelHint': 'A cancelled order drops out of the "goods expected" list and cannot be restored. If the goods have already arrived (the receipt is posted), cancellation is NOT POSSIBLE — cancelling the document does not remove the warehouse stock or the calculated cost.',
  'po.cancelReason': 'Reason (required, recorded in the audit trail)',
  'po.cancelReasonHint': 'At least 3 characters. The answer to "why was this cancelled?" stays right here.',
  'po.cancelConfirm': 'Yes, cancel it',
  'po.cancelled': 'Order cancelled',
  'po.cancelledTitle': 'Order cancelled',
  'po.notCancellable': 'Cancellation is not possible in this status — the goods have already been received or the document is closed.',
  'po.linesRequired': 'At least one complete line is required',
  'po.empty': 'No orders found',
  'po.emptyHint': 'Widen the filter or create a new order.',
  'po.loadError': 'Could not load purchase orders',
  'po.notFound': 'Order not found or not visible to you',
  'po.includeCancelled': 'Also show cancelled',
  'po.noSuppliers': 'The supplier list is empty or not available to you',
  'po.status.draft': 'Draft',
  'po.status.submitted': 'Submitted',
  'po.status.approved': 'Approved',
  'po.status.in_production': 'In production',
  'po.status.shipped': 'Shipped',
  'po.status.partially_received': 'Partially received',
  'po.status.received': 'Received',
  'po.status.closed': 'Closed',
  'po.status.cancelled': 'Cancelled',
  'shp.title': 'Containers',
  'shp.description': 'Shipments in transit and arrived. Each line shows the ETA against the actual, the cost status and, MOST IMPORTANTLY, how much of the container has been sold.',
  'shp.new': 'New container',
  'shp.newTitle': 'New container',
  'shp.detailTitle': 'Container {docNo}',
  'shp.searchPlaceholder': 'Document or container number',
  'shp.docNo': 'Document',
  'shp.containerNo': 'Container',
  'shp.blNo': 'Bill of lading (BL)',
  'shp.departurePort': 'Port of departure',
  'shp.arrivalPort': 'Port of arrival',
  'shp.etd': 'ETD (plan)',
  'shp.eta': 'ETA (plan)',
  'shp.atd': 'Departed (actual)',
  'shp.ata': 'Arrived (actual)',
  'shp.delay': 'Delay',
  'shp.delayDays': '+{days} days',
  'shp.earlyDays': '−{days} days',
  'shp.onTime': 'On time',
  'shp.noAta': 'Not arrived yet',
  'shp.delayHint': 'Delay is the only measure of supplier reliability. The 120–150 day plan rests on exactly this column.',
  'shp.status': 'Status',
  'shp.statusAll': 'All statuses',
  'shp.lcStatus': 'Cost status',
  'shp.lcStatusAll': 'All cost statuses',
  'shp.notes': 'Notes',
  'shp.lines': 'Lines',
  'shp.lineQty': 'Quantity',
  'shp.sold': 'Sold',
  'shp.free': 'Available',
  'shp.soldPct': 'Share sold',
  'shp.weightKg': 'Gross, kg/pc',
  'shp.netWeightKg': 'Net, kg/pc',
  'shp.volumeM3': 'Volume, m³/pc',
  'shp.dimHint': 'This is the ACTUAL measurement: with different packaging it differs from the product card. If left blank, the allocation takes the values from the product master data. GROSS includes packaging (freight is allocated by it), NET is the goods themselves (for the customs declaration).',
  'shp.customsTitle': 'Customs totals',
  'shp.customsHint': 'One shipment — one document: these figures go into the declaration as they are. The total is computed FROM THE LINES (quantity × per-piece value), so adding up the table column by eye gives a different result.',
  'shp.totalQty': 'Total pieces',
  'shp.totalCartons': 'Total cartons',
  'shp.totalGross': 'Total gross, kg',
  'shp.totalNet': 'Total net, kg',
  'shp.totalVolume': 'Total volume, m³',
  'shp.customsIncompleteTitle': 'The total is incomplete',
  'shp.customsIncompleteBody': 'Lines with no measurement: gross — {gross}, net — {net}, volume — {volume}. They are NOT included in the total, so the declaration may end up understated. Check the N.W. and G.W. columns in the invoice.',
  'shp.presoldTitle': 'Sold before the container arrived',
  'shp.presoldBody': '100% of {sku} from this shipment has been sold — available stock is zero. If everything sells before the container even arrives, you UNDER-ORDERED: money was left on the table. Set the quantity for the next order based on this line.',
  'shp.presoldBadge': 'Fully sold',
  'shp.underOrdered': 'Under-ordered — no available stock for {count} SKUs',
  'shp.linesUnavailable': 'Could not load lines — "sold/available" is not shown',
  'shp.empty': 'No containers found',
  'shp.emptyHint': 'Widen the filter or include closed ones.',
  'shp.includeClosed': 'Also show closed',
  'shp.loadError': 'Could not load containers',
  'shp.notFound': 'Container not found or not visible to you',
  'shp.created': 'Container created: {docNo}',
  'shp.submit': 'Create container',
  'shp.advanceStatus': 'Move status to {status}',
  'shp.statusChanged': 'Status changed: {status}',
  'shp.openReceipt': 'Receive goods',
  'shp.openProfit': 'Profitability report',
  'shp.status.planned': 'Planned',
  'shp.status.in_transit': 'In transit',
  'shp.status.at_customs': 'At customs',
  'shp.status.cleared': 'Cleared customs',
  'shp.status.received': 'Received',
  'shp.status.closed': 'Closed',
  'lcs.pending': 'Not calculated',
  'lcs.estimated': 'Estimated',
  'lcs.final': 'Final',
  'shp.tab.lines': 'Lines',
  'shp.tab.costs': 'Costs',
  'shp.tab.landedCost': 'Cost calculation',
  'cost.title': 'Container costs',
  'cost.description': 'Freight, customs, broker, certificates. Each cost is entered in ITS OWN currency and converted to US dollars at the rate for ITS OWN date.',
  'cost.add': 'Add cost',
  'cost.type': 'Cost type',
  'cost.typeSelect': 'Select a type',
  'cost.description2': 'Notes',
  'cost.amount': 'Amount',
  'cost.currency': 'Currency',
  'cost.fxRate': 'FX rate',
  'cost.amountBase': 'USD equivalent',
  'cost.incurredDate': 'Cost date',
  'cost.incurredDateHint': 'The rate is taken for EXACTLY this date. Duty is paid in UZS and calculated at the rate on the duty date — not at today\'s rate.',
  'cost.documentRef': 'Document number',
  'cost.isEstimate': 'Estimated (document not received yet)',
  'cost.isEstimateHint': 'With an estimated cost, the landed cost is calculated as an "estimate" and the goods go on sale. Once the documents arrive, it is recalculated as "final".',
  'cost.estimateBadge': 'Estimated',
  'cost.supplier': 'Who gets paid',
  'cost.supplierHint': 'Leave empty: duty and state fees are paid to the state, there is no credit',
  'cost.supplierNone': 'Nobody (duty, state fee)',
  'cost.supplierAssign': 'Assign a counterparty',
  'cost.supplierSaved': 'Counterparty saved',
  'cost.invoicedBadge': 'Invoice received',
  'cost.invoicedLocked':
    'An invoice has been recognized for this line — the counterparty and amount can no longer change.',
  'cost.allocMethod': 'Allocation method',
  'cost.allocRecommended': 'Recommended: {method}',
  'cost.allocOverridden': 'Differs from the recommendation',
  'cost.allocWhy': 'The allocation method is a FINANCE decision, not a developer’s choice. LED products are light but bulky: allocating sea freight by weight makes a large shade artificially cheap and a small lamp artificially expensive. On a typical container, one wrong choice moves $448 onto the wrong SKU.',
  'cost.totalBase': 'Total costs (USD)',
  'cost.added': 'Cost added',
  'cost.empty': 'No costs have been entered for this container',
  'cost.emptyHint': 'Without costs, the calculation returns only the goods price — that is not the landed cost.',
  'cost.loadError': 'Could not load costs',
  'cost.amountRequired': 'The amount must be greater than zero',
  'cost.typeRequired': 'A cost type must be selected',
  'cost.noEditPermission': 'You do not have permission to add costs. Ask your manager if you need it.',
  'alloc.value': 'By value',
  'alloc.quantity': 'By quantity',
  'alloc.weight': 'By weight',
  'alloc.volume': 'By volume',
  'alloc.manual': 'Manual',
  'alloc.hint.value': 'Insurance, duty, bank fees — proportional to value',
  'alloc.hint.quantity': 'Per-piece fees, certification',
  'alloc.hint.weight': 'Inland transport, air freight — by weight',
  'alloc.hint.volume': 'Container freight and storage — space is sold by volume',
  'alloc.hint.manual': 'A cost belonging to a single SKU — the operator enters the share',
  'costing.title': 'Costing',
  'costing.intro': 'Select a container: upload the factory invoice, enter the costs and see the cost of each product. Costs are allocated by volume, weight, quantity or value — the method is chosen on each cost line.',
  'costing.selectPrompt': 'To get started, select a container from the list above.',
  'costing.containers': 'Containers',
  'costing.docNo': 'Document',
  'costing.container': 'Container',
  'costing.lcStatus': 'Cost status',
  'costing.lineCount': 'Lines',
  'costing.costCount': 'Costs',
  'costing.costTotal': 'Total costs',
  'costing.eta': 'Arrival (ETA)',
  'costing.noContainers': 'No containers found',
  'costing.open': 'Open',
  'costing.estimateCount': '{count} estimated',
  'costing.totalRow': 'TOTAL',
  'costing.archived': 'Archived',
  'costing.basis.receipt': 'By receipt — will be posted',
  'costing.basis.shipment': 'By shipment — expected, not posted',
  'costing.basis.none': 'Not calculated',
  'costing.rate': '{currency} rate {rate} ({date})',
  'costing.totalQty': 'Total quantity',
  'costing.totalCartons': 'Cartons',
  'costing.totalVolume': 'Total volume',
  'costing.totalWeight': 'Total weight',
  'costing.purchaseBase': 'China price (USD)',
  'costing.costsBase': 'Costs (USD)',
  'costing.runType': 'Calculation type',
  'costing.runType.estimate': 'Estimate',
  'costing.runType.final': 'Final',
  'costing.runTypeHint': 'Estimate — until all documents have arrived. Final — once every document is in; the difference goes to inventory value and, for the sold portion, to COGS.',
  'costing.result': 'RESULT — cost of each product',
  'costing.resultHint': 'Each cost column shows two figures: the amount charged to that product and its share of the allocation base. The share matches that cost\'s own method (if it is allocated by volume, it is the volume share).',
  'costing.sku': 'Product',
  'costing.qty': 'Quantity',
  'costing.bases': 'Allocation base',
  'costing.chinaPrice': 'China price',
  'costing.landedUnit': 'Costs / pc',
  'costing.totalUnitCost': 'COST / pc',
  'costing.landedPct': 'Cost share',
  'costing.noLines': 'No lines — upload the invoice first',
  'costing.cartons': '{count} cartons · {dims} cm',
  'costing.valueShare': 'value {pct}',
  'costing.balance': 'Totals check',
  'costing.balanceHint': 'For each cost: the amount entered and the amount allocated across the lines. The difference must be ZERO — the rounding remainder is not lost, it is charged to the largest line.',
  'costing.cost': 'Cost',
  'costing.entered': 'Entered',
  'costing.allocated': 'Allocated',
  'costing.diff': 'Difference',
  'costing.balanced': 'Balanced ✓',
  'costing.unbalanced': 'NOT BALANCED',
  'costing.noCosts': 'No costs entered',
  'costing.costs': 'Costs and allocation method',
  'costing.import': 'Upload factory invoice',
  'costing.importHint': 'Excel or CSV. Columns are detected automatically from the headers. Start with "Preview" — nothing is written to the database; "Write" only becomes available once there are no errors.',
  'costing.import.file': 'Invoice file',
  'costing.import.mode': 'Mode',
  'costing.import.append': 'Append',
  'costing.import.replace': 'Replace (existing lines are deleted)',
  'costing.import.po': 'Purchase order ID',
  'costing.import.poHint': 'If provided: the lines are linked to the order and the yuan price on the invoice is compared with the price on the order.',
  'costing.import.preview': 'Preview',
  'costing.import.commit': 'Write',
  'costing.import.template': 'Template (.xlsx)',
  'costing.import.done': '{created} lines written, {removed} lines deleted',
  'costing.import.rows': 'Rows',
  'costing.import.recognized': 'Recognised',
  'costing.import.unknown': 'Unknown code',
  'costing.import.missingDims': 'No dimensions',
  'costing.import.errors': 'Errors',
  'costing.import.columns': 'Sheet "{sheet}", header row {headerRow}. Recognised columns: {columns}',
  'costing.import.unmapped': 'Unrecognised columns: {columns}',
  'costing.import.row': 'Row',
  'costing.import.grossKg': 'Gross, kg',
  'costing.import.netKg': 'Net, kg',
  'costing.import.issues': 'Error / warning',
  'costing.import.ok': 'Clean',
  'costing.runs': 'Cost calculations',
  'costing.run.done': 'The {runType} calculation has been posted. Inventory value: {value}',
  'costing.run.needsReceipt': 'A goods receipt is required for posting: costs are allocated to the quantity that ACTUALLY arrived, not to the expected one.',
  'costing.run.estimate': 'Post estimated cost',
  'costing.run.final': 'Post final cost',
  'costing.run.hint': 'Correcting anything after posting means reversing and revaluing.',
  'costing.run.type': 'Type',
  'costing.run.date': 'Date',
  'costing.run.status': 'Status',
  'costing.run.none': 'Not calculated yet',
  'costing.defaults': 'Default method per cost type',
  'costing.defaultsHint': '"Customs clearance is usually by kg" — set once, then selected automatically whenever a new cost is added. The cost of existing containers DOES NOT CHANGE.',
  'costing.defaultAlloc': 'Default allocation',
  'lc.title': 'Landed cost calculation',
  'lc.description': '"What did this product actually cost by the time it reached the warehouse?" — the only correct answer to that question. The price on the Chinese invoice is not even half of it.',
  'lc.preview': 'Preview calculation',
  'lc.previewAgain': 'Recalculate',
  'lc.previewHint': 'This calculation SAVES NOTHING. Correcting anything after posting means reversing and revaluing, and every sale in between will already have been recorded at the wrong cost — which is why you look first and write afterwards.',
  'lc.purchaseBase': 'Goods value (USD)',
  'lc.costsBase': 'Costs (USD)',
  'lc.inventoryValue': 'Total inventory value (USD)',
  'lc.landedPct': 'Cost share',
  'lc.landedPctBig': 'Costs amount to {pct}% of the goods price',
  'lc.landedPctOver100': 'COSTS EXCEED THE GOODS THEMSELVES. Freight, customs, certificates and the rest together cost more than the goods. That is exactly why quoting prices from the Chinese invoice does not work.',
  'lc.landedPctExample': '{sku}: China price {purchase}, cost into the warehouse {total} — a difference of {pct}.',
  'lc.landedPctUnder100': 'The cost share is the ratio of allocated costs to the goods price. Pricing is based on the TOTAL LANDED COST, not on the goods price.',
  'lc.purchaseRate': 'Goods rate ({currency})',
  'lc.purchaseRateHint': 'The rate is taken for the RECEIPT DATE: that is the day the goods become an asset. The order date was 4 months ago, and that day\'s rate has nothing to do with today\'s asset value.',
  'lc.receiptDate': 'Receipt date',
  'lc.sku': 'SKU',
  'lc.quantity': 'Quantity received',
  'lc.expectedQuantity': 'Expected',
  'lc.shortage': 'Shortage',
  'lc.purchaseUnitCost': 'Goods price (per pc)',
  'lc.landedUnitCost': 'Costs (per pc)',
  'lc.totalUnitCost': 'Total landed cost (per pc)',
  'lc.linePct': 'Landed %',
  'lc.purchaseTotal': 'Goods amount',
  'lc.landedTotal': 'Cost amount',
  'lc.warnings': 'Warnings',
  'lc.empty': 'No data to calculate',
  'lc.emptyHint': 'The landed cost is calculated on RECEIVED goods: if there is no goods receipt for this container yet, there are no lines to calculate either.',
  'lc.loadError': 'Could not calculate the landed cost',
  'lc.compare': 'Compare allocation methods',
  'lc.compareHint': 'TEMPORARILY switch the method on a cost line here and see the difference. Nothing is saved — this answers the question "what if we did it the other way?".',
  'lc.compareRun': 'Compare',
  'lc.compareReset': 'Restore original methods',
  'lc.compareBase': 'Current method',
  'lc.compareAlt': 'Selected method',
  'lc.deltaUnit': 'Difference (per pc)',
  'lc.deltaTotal': 'Difference (total)',
  'lc.deltaZeroSum': 'The differences add up to EXACTLY ZERO: switching the method does not change the total cost, it only moves it between SKUs. If the sum is not zero, there is an error in the calculation.',
  'lc.deltaMoved': 'A single method choice moves {amount} from the "{from}" line onto other SKUs.',
  'lc.deltaNone': 'The selected method did not change the result',
  'lc.deltaWhy': 'This is the single most expensive choice in the whole system. The panel comes out 6.3% too low and the strip 6.8% too high, and BOTH end up priced wrong.',
  'lc.runType': 'Calculation type',
  'lc.runType.estimate': 'Estimate',
  'lc.runType.final': 'Final',
  'lc.runTypeHint': 'Goods usually arrive before the documents. "Estimate" — the known costs are allocated and the goods go on sale. "Final" — once every document is in, the earlier calculation is reversed and the difference is worked out.',
  'lc.runDate': 'Document date',
  'lc.run': 'Calculate and post',
  'lc.runConfirm': 'The cost will be written to the inventory ledger and the stock revalued. This action stays in the audit log.',
  'lc.runNotes': 'Notes',
  'lc.ran': 'The landed cost has been calculated and posted (run #{runId})',
  'lc.noRunPermission': 'You do not have permission to run the cost calculation. Ask your manager if you need it.',
  'lc.cogsVariance': 'Variance on goods sold (COGS variance)',
  'lc.cogsVarianceHint': 'This amount DOES NOT GO BACK to inventory: the cost of goods already sold is not changed retroactively, otherwise the profit of a closed period would be rewritten. The variance falls into the current period.',
  'lc.runs': 'Calculation history',
  'lc.runNo': 'Run #{id}',
  'lc.runStatus': 'Status',
  'lc.runPostedAt': 'Posted',
  'lc.runTotal': 'Total costs',
  'lc.runReversalOf': 'Reverses #{id}',
  'lc.runsEmpty': 'Not calculated yet',
  'lc.reverse': 'Reverse',
  'lc.reverseTitle': 'Reverse cost calculation',
  'lc.reverseReason': 'Reason for reversal',
  'lc.reverseReasonRequired': 'The reason must be at least 3 characters',
  'lc.reverseHint': 'A reversal changes the cost, the margin and ALL reports. You will certainly be asked "why?" — the reason stays in the audit log.',
  'lc.reversed': 'The calculation has been reversed',
  'lc.noReversePermission': 'You do not have permission to reverse the calculation — only the administrator and the finance officer have it. Ask them if you need it.',
  'lc.breakdown': 'Cost breakdown',
  'lc.costName': 'Cost',
  'lc.allocBasis': 'Base',
  'lc.allocRatio': 'Share',
  'lc.allocated': 'Amount (USD)',
  'lc.roundingAbsorbed': 'The rounding difference was added to this line',
  'lc.roundingHint': 'So that no fraction of a cent is lost in the allocation, the rounding difference is added to the line with the largest base. The total must be EXACTLY equal to the cost.',
  'lc.noViewPermission': 'You do not have permission to view the landed cost calculation. Ask your manager if you need it.',
  'gr.title': 'Goods receipt',
  'gr.description': 'Receiving goods from a container. Landed cost is allocated to the quantity that ACTUALLY ARRIVED — a shortage RAISES the cost of the remaining pieces.',
  'gr.new': 'New receipt',
  'gr.newTitle': 'Receive from container',
  'gr.detailTitle': 'Receipt {docNo}',
  'gr.docNo': 'Document',
  'gr.shipment': 'Container',
  'gr.shipmentSelect': 'Select a container',
  'gr.shipmentRequired': 'A container must be selected',
  'gr.purchaseOrder': 'Purchase order',
  'gr.warehouse': 'Warehouse',
  'gr.receiptDate': 'Receipt date',
  'gr.receiptDateHint': 'The receipt date is the FX RATE DATE for the CNY→USD conversion: that is the day the goods become an asset.',
  'gr.status': 'Status',
  'gr.statusAll': 'All statuses',
  'gr.status.draft': 'Draft',
  'gr.status.posted': 'Posted',
  'gr.status.cancelled': 'Cancelled',
  'gr.lines': 'Lines',
  'gr.expectedQuantity': 'Expected',
  'gr.quantity': 'Actually received',
  'gr.shortage': 'Shortage',
  'gr.excess': 'Excess',
  'gr.shortageReason': 'Reason for the shortage',
  'gr.shortageReasonRequired': 'A reason must be given on any line with a shortage',
  'gr.claimStatus': 'Claim status',
  'gr.claimAmount': 'Claim amount',
  'gr.claimNote': 'Claim notes',
  'gr.shortageWhy': 'Cost is allocated to the quantity RECEIVED, not to the expected one. So if 500 pieces were expected and 480 arrived, the costs are divided by 480 and every piece becomes more expensive. Allocating to the expected quantity would make the goods that never arrived look "free".',
  'gr.claimWhy': 'The claim status decides where the MONEY for a shortage goes: "accepted" — the supplier refunds it and it is not a cost; "rejected" or "none" — the amount is charged to the PERIOD LOSS, NOT to the cost. Otherwise the remaining pieces become artificially expensive and cannot be compared with the next batch.',
  'gr.post': 'Post',
  'gr.postHint': 'Once posted, the goods enter the warehouse stock and are ready for the cost calculation.',
  'gr.posted': '{docNo} has been posted',
  'gr.created': 'Receipt created: {docNo}',
  'gr.submit': 'Create receipt',
  'gr.linesRequired': 'At least one line is required',
  'gr.noPoLine': 'This line has no purchase order line: the price (CNY) comes precisely from the PO line, and without it the cost cannot be calculated.',
  'gr.empty': 'No goods receipts found',
  'gr.emptyHint': 'Widen the filter or create a new receipt from a container.',
  'gr.loadError': 'Could not load goods receipts',
  'gr.notFound': 'Goods receipt not found or not visible to you',
  'gr.pickShipment': 'Select a container first',
  'gr.loadLines': 'Load container lines',
  'gr.linesFromShipment': 'The lines were taken from the selected container — correct the quantity actually received.',
  'gr.costHidden': 'Cost columns are not shown to you — this is a permission setting, not an error.',
  'shortage.shortage': 'Shortage',
  'shortage.damaged': 'Damaged',
  'shortage.wrong_item': 'Wrong product',
  'shortage.excess': 'Excess',
  'claim.none': 'No claim',
  'claim.pending': 'In preparation',
  'claim.sent': 'Sent',
  'claim.accepted': 'Accepted',
  'claim.rejected': 'Rejected',
  'claim.closed': 'Closed',
  'imp.title': '1C and Excel import',
  'imp.description': 'Import has four steps: upload → map columns → validate → commit. You move on to the next step only after you have SEEN the result of the previous one.',
  'imp.whyStaged': 'In real files the header sits in row 3, numbers arrive as text, and one cell says «100 pcs». A single «you picked a file — it is imported» button either fails on such a file or, worse, silently commits 4,000 rows incorrectly.',
  'imp.step1': 'File',
  'imp.step2': 'Columns',
  'imp.step3': 'Validation',
  'imp.step4': 'Commit',
  'imp.stepOf': 'Step {n}',
  'imp.entityType': 'What is being imported',
  'imp.entity.product': 'Products',
  'imp.entity.customer': 'Customers',
  'imp.entity.supplier': 'Suppliers',
  'imp.entity.stock': 'Stock (opening balance)',
  'imp.entity.ar': 'Customer debt (opening balance)',
  'imp.entity.ap': 'Supplier debt (opening balance)',
  'imp.entity.price': 'Prices',
  'imp.openingTitle': 'Opening balance — two conditions',
  'imp.openingBody':
    '1) ORDER: products, customers and suppliers must be migrated first — the stock and debt files reference them. 2) LEDGER: this upload writes NO journal entry. The accountant posts the single opening entry by hand under «Accounting → Journals» (which equity account it hits is their decision).',
  'imp.entityHint': 'One file — ONE type. The type cannot be guessed from the headers: a customer list with «Code | Name» looks exactly like a supplier list, and 4,000 rows that landed in the wrong table are almost impossible to separate afterwards.',
  'imp.template': 'Download template',
  'imp.templateHint': 'The template has the correct column names and one sample row. A file filled in from it maps completely on the first attempt — no guessing column names.',
  'imp.templateFailed': 'Could not download the template',
  'imp.file': 'File (.xlsx or .csv)',
  'imp.upload': 'Upload',
  'imp.uploading': 'Uploading…',
  'imp.fileRequired': 'A file is required',
  'imp.uploadFailed': 'Could not upload the file',
  'imp.sheets': 'Sheets in the file',
  'imp.sheet': 'Sheet',
  'imp.selectedSheet': 'Selected sheet',
  'imp.rowCount': '{count} rows',
  'imp.headerRow': 'Header row',
  'imp.headerRowDetected': 'Detected: row {row}',
  'imp.headerRowHint': 'Automatic header row detection is a GUESS. A wrongly detected header makes the whole file useless, so it can be corrected by hand.',
  'imp.detectedColumns': 'Detected columns',
  'imp.mappingTitle': 'Column mapping',
  'imp.mappingHint': 'On the left is the Alight field, on the right the column from the file. The automatic suggestion is already filled in; check it and change it if needed.',
  'imp.evoField': 'Alight field',
  'imp.fileColumn': 'File column',
  'imp.columnNone': '— not mapped —',
  'imp.required': 'required',
  'imp.suggested': 'auto-suggested',
  'imp.defaultValue': 'Fixed value',
  'imp.defaultHint': 'If the column is missing from the file entirely (for example «type» is not filled in because everything is wholesale) — set the value once here.',
  'imp.applyMapping': 'Save mapping',
  'imp.mappingSaved': 'Mapping saved',
  'imp.previewTitle': 'Result preview (first rows)',
  'imp.previewRow': 'Row {n}',
  'imp.skippedRows': 'Rows skipped before the header: {count}',
  'imp.requiredMissing': 'Required fields are not mapped: {fields}',
  'imp.validate': 'Validate',
  'imp.validating': 'Validating…',
  'imp.validateHint': 'Validation can be run as many times as you like and writes nothing. Instead of fixing the file and uploading it again — fix the mapping and validate again.',
  'imp.totalRows': 'Total rows',
  'imp.validRows': 'Valid',
  'imp.errorRows': 'Errors',
  'imp.warningRows': 'Warnings',
  'imp.topErrors': 'Most frequent errors',
  'imp.rowNo': 'Row',
  'imp.rowStatus': 'Status',
  'imp.rowMessage': 'Message',
  'imp.rowData': 'Value from the file',
  'imp.filterAll': 'All rows',
  'imp.filterErrors': 'Errors only',
  'imp.filterWarnings': 'Warnings only',
  'imp.filterValid': 'Valid rows only',
  'imp.warningNotError': 'A warning is not an ERROR. A near duplicate («Chandelier 60W» and «Chandelier 80W») is two real products, and both must be created. Such a row stays «valid» and goes into the database at the «Commit» step; the warning only draws attention.',
  'imp.rowsEmpty': 'No rows match this filter',
  'imp.rowsLoadError': 'Could not load the rows',
  'imp.commit': 'Commit to database',
  'imp.committing': 'Committing…',
  'imp.commitHint': 'Only «valid» rows are committed, and all of them in ONE transaction: no half-finished import is left behind.',
  'imp.commitBlocked': 'Run the validation first',
  'imp.committed': '{count} rows committed',
  'imp.commitFailed': 'Commit failed',
  'imp.imported': 'Imported',
  'imp.rollback': 'Roll back',
  'imp.rollbackTitle': 'Roll back import batch',
  'imp.rollbackReason': 'Rollback reason',
  'imp.rollbackReasonRequired': 'The reason must be at least 3 characters long',
  'imp.rollbackHint': 'A rollback DELETES records from the database — the only exception to the rule that master data is never deleted. A week later somebody will certainly ask «why was it rolled back?»',
  'imp.rolledBack': 'Batch rolled back',
  'imp.rollbackFailed': 'Rollback failed',
  'imp.batches': 'Import batches',
  'imp.batchNo': 'Batch #{id}',
  'imp.fileName': 'File',
  'imp.createdAt': 'Created',
  'imp.batchStatus': 'Status',
  'imp.open': 'Open',
  'imp.newBatch': 'New import',
  'imp.batchesEmpty': 'No imports yet',
  'imp.batchesLoadError': 'Could not load the batches',
  'imp.status.uploaded': 'Uploaded',
  'imp.status.validated': 'Validated',
  'imp.status.dry_run': 'Dry run',
  'imp.status.committed': 'Committed',
  'imp.status.rolled_back': 'Rolled back',
  'imp.rowStatus.pending': 'Pending',
  'imp.rowStatus.valid': 'Valid',
  'imp.rowStatus.error': 'Error',
  'imp.rowStatus.imported': 'Imported',
  'imp.rowStatus.skipped': 'Skipped',
  'settings.title': 'Settings',
  'settings.usersTitle': 'Users',
  'settings.rolesTitle': 'Roles and permissions',
  'settings.priceListsTitle': 'Price lists',
  'settings.cashAccountsTitle': 'Cash and bank accounts',
  'settings.systemTitle': 'System settings',
  'settings.auditTitle': 'Audit log',
  'usr.description': 'Users, roles and scope. If a role or a password changes, ALL of that employee\'s sessions are revoked.',
  'usr.sessionsRevokedWarning': 'ATTENTION: if the role, scope or password is changed, all of the user’s open sessions are revoked immediately and they have to sign in again. This is not a technical detail — otherwise they would keep working with the old permissions in an already open window, which would make lowering a role meaningless.',
  'usr.sessionsRevokedDone': 'Sessions revoked ({count})',
  'usr.new': 'New user',
  'usr.fullName': 'Full name',
  'usr.email': 'Email',
  'usr.phone': 'Phone',
  'usr.password': 'Password',
  'usr.passwordHint': 'At least {min} characters. Length matters more than complexity: mandatory character rules push people towards predictable passwords.',
  'usr.passwordTooShort': 'The password must be at least {min} characters',
  'usr.locale': 'Language',
  'usr.role': 'Role',
  'usr.roleSelect': 'Select a role',
  'usr.scope': 'Scope',
  'usr.scopeType': 'Scope type',
  'usr.scope.all': 'Entire organization',
  'usr.scope.branch': 'Branch',
  'usr.scope.warehouse': 'Warehouse',
  'usr.scopeId': 'Scope object',
  'usr.scopeHint': 'The scope defines «which data is visible»: a warehouse keeper sees only their own warehouse, a salesperson only their own branch.',
  'org.title': 'Organization structure',
  'org.description': 'Branches with their warehouses and cash accounts. A new branch is opened together with its warehouse and cash account, otherwise it cannot trade.',
  'org.newBranch': 'New branch',
  'org.wizardTitle': 'Open a new branch',
  'org.wizardHint': 'The branch, its warehouse and its cash account are created in a SINGLE action. If the warehouse and cash account codes are left empty, they are derived from the branch code.',
  'org.branchCode': 'Branch code',
  'org.branchCodeHint': 'Capital letters, digits and hyphens: SAMARQAND. The code CANNOT be changed later — it is printed on documents.',
  'org.branchName': 'Branch name',
  'org.address': 'Address',
  'org.phone': 'Phone',
  'org.legalEntity': 'Legal entity',
  'org.warehouseCode': 'Warehouse code',
  'org.warehouseName': 'Warehouse name',
  'org.cashCode': 'Cash account code',
  'org.cashName': 'Cash account name',
  'org.optional': 'optional',
  'org.create': 'Open branch',
  'org.creating': 'Opening…',
  'org.setupDone': 'Branch opened: {code}',
  'org.setupDetails': 'Warehouse: {warehouse} · Cash account: {cash} ({currency})',
  'org.nextStep': 'Next step',
  'org.goToUsers': 'Assign an employee',
  'org.branch': 'Branch',
  'org.warehouses': 'Warehouses',
  'org.cashAccounts': 'Cash accounts',
  'org.staff': 'Employees',
  'org.staffCount': '{count} employees',
  'org.noStaff': 'No employees assigned',
  'org.noStaffHint': 'Nobody works in this branch — no documents will appear in it. Give an employee the branch scope under Settings → Users.',
  'org.stockValue': 'Stock value',
  'org.warehouseCount': '{count} warehouses',
  'org.positions': '{count} items',
  'org.empty': 'Empty',
  'org.archived': 'Archived',
  'org.archive': 'Archive',
  'org.archiveBranchHint': 'A branch is NOT DELETED — the history of the documents linked to it remains. Before archiving, move the stock to another branch and transfer the employees.',
  'org.archiveWarehouseHint': 'A warehouse with stock cannot be archived — the goods would disappear from the reports.',
  'org.archiveCashHint': 'A cash account with a balance cannot be archived.',
  'org.branchArchived': 'Branch archived: {code}',
  'org.warehouseArchived': 'Warehouse archived: {code}',
  'org.cashArchived': 'Cash account archived: {code}',
  'org.newWarehouse': 'Add warehouse',
  'org.warehouseCreated': 'Warehouse created: {code}',
  'org.whType': 'Type',
  'org.whType.main': 'Main',
  'org.whType.transit': 'Transit (goods in transit)',
  'org.whType.quarantine': 'Quarantine (inspection)',
  'org.whTypeHint': 'There is one transit warehouse for the whole company — at head office. There is one quarantine warehouse per branch, and it is only for returns that require inspection.',
  'org.unassignedCash': 'Cash accounts not assigned to a branch',
  'org.unassignedCashHint': 'Central and foreign currency accounts stay here. Pick a branch cash account from the list and assign it.',
  'org.attach': 'Assign',
  'org.detach': 'Unassign',
  'org.attached': 'Cash account assigned to the branch',
  'org.selectBranch': 'Select a branch',
  'org.save': 'Save',
  'org.saved': 'Saved',
  'org.edit': 'Edit',
  'org.loadError': 'Could not load the organization structure',
  'usr.status': 'Status',
  'usr.active': 'Active',
  'usr.inactive': 'Blocked',
  'usr.lastLogin': 'Last sign-in',
  'usr.neverLoggedIn': 'Never signed in',
  'usr.create': 'Create',
  'usr.created': 'User created: {email}',
  'usr.setRole': 'Change role',
  'usr.roleChanged': 'Role changed: {role}',
  'usr.setScope': 'Change scope',
  'usr.scopeChanged': 'Scope changed',
  'usr.resetPassword': 'Reset password',
  'usr.resetPasswordTitle': 'Set a new password',
  'usr.passwordReset': 'Password changed',
  'usr.newPasswordHint': 'The new password is NOT RETURNED in the response: you enter it yourself and pass it on to the employee yourself.',
  'usr.activate': 'Activate',
  'usr.deactivate': 'Block',
  'usr.activated': 'User activated',
  'usr.deactivated': 'User blocked',
  'usr.sessions': 'Sessions',
  'usr.sessionsTitle': '{name} — sessions',
  'usr.sessionAgent': 'Device',
  'usr.sessionIp': 'IP',
  'usr.sessionCreated': 'Started',
  'usr.sessionExpires': 'Expires',
  'usr.sessionRevoked': 'Revoked',
  'usr.sessionActive': 'Active',
  'usr.revokeSessions': 'Revoke all sessions',
  'usr.sessionsEmpty': 'No sessions',
  'usr.self': 'This is YOUR record. You cannot change your own role, scope or active status: otherwise an administrator could accidentally strip their own permissions.',
  'usr.noRoleAssign': 'You do not have permission to change the role and scope — only the administrator has it. Ask the administrator if you need it.',
  'usr.empty': 'No users found',
  'usr.loadError': 'Could not load the users',
  'role.description': 'The role → permission matrix. With the `role.manage` permission you open or close every section and function right here; without it the screen stays read only.',
  'role.code': 'Code',
  'role.name': 'Name',
  'role.users': 'Users',
  'role.permissions': 'Permissions',
  'role.module': 'Module',
  'role.permissionCode': 'Permission code',
  'role.granted': 'Granted',
  'role.notGranted': 'No',
  'role.select': 'Select a role',
  'role.label.admin': 'Administrator',
  'role.label.manager': 'Manager',
  'role.label.finance': 'Finance',
  'role.label.warehouse': 'Warehouse keeper',
  'role.label.sales': 'Salesperson',
  'nav.language': 'Language',
  'nav.theme.toDark': 'Switch to dark theme',
  'nav.theme.toLight': 'Switch to light theme',
  'role.matrixHint': 'Columns are roles, rows are permissions. This table must match the agreed list of permissions; if they differ, the truth is IN THE DATABASE.',
  'role.loadError': 'Could not load the roles',
  'role.empty': 'No roles found',
  'role.editHint': 'Pick a role, then tick the functions inside each section. Nothing changes until you press Save. The change takes effect immediately — the next click of anyone in that role already uses the new permissions.',
  'role.viewEditor': 'Edit',
  'role.viewMatrix': 'Full matrix',
  'role.new': 'New role',
  'role.newCode': 'Code',
  'role.newCodeHint': 'lowercase latin letters, digits and dashes only; 2–32 characters',
  'role.newName': 'Name',
  'role.newDescription': 'Description',
  'role.created': 'Role «{code}» created. It is EMPTY for now — tick its functions below.',
  'role.codeInvalid': 'Invalid code: lowercase latin letters, digits and dashes only (2–32 characters)',
  'role.deleteConfirm': 'Delete the role «{name}» completely? All of its permission links go with it and this cannot be undone.',
  'role.deleted': 'Role «{code}» deleted',
  'role.systemHint': 'System roles cannot be deleted — the program refers to them by name. Their permissions can still be changed.',
  'role.selectHint': 'Pick one of the roles above to edit it.',
  'role.permissionsOf': 'Role «{name}»: sections and functions',
  'role.summary': '{modules} sections, {permissions} functions',
  'role.filter': 'Search by section or function',
  'role.filterEmpty': 'No function matches the search',
  'role.selectAll': 'Select all',
  'role.clearAll': 'Clear all',
  'role.pendingChanges': '{added} to grant, {removed} to revoke',
  'role.noChanges': 'No changes',
  'role.savedResult': 'Saved: {added} granted, {removed} revoked. The role now holds {granted} permissions.',
  'role.locked': 'You do not hold this permission — you cannot grant it to a role',
  'role.lockedBanner': 'This role holds {count} permissions you do NOT have ({codes}). The server refuses to write such a set back, so saving is closed here. Someone who holds those permissions has to edit this role.',
  'role.catalogueError': 'Could not load the list of sections and functions',
  'role.err.escalation': 'You cannot grant a permission you do not hold',
  'role.err.lockout': 'The last administrator cannot be locked out',
  'role.err.systemRole': 'A system role cannot be deleted',
  'role.err.inUse': 'The role still has users',
  'pl.description': 'Without a price list no order can be priced. The payment method is the most important column: the cash price and the bank transfer price differ by 3–7%.',
  'pl.paymentWhy': 'Cash and bank transfer are TWO DIFFERENT prices. The gap is 3–7% and it disappears quietly: the salesperson agrees on «cash», but the document is issued from the bank transfer price list. That is why the payment method sits in plain sight on the list.',
  'pl.new': 'New price list',
  'pl.code': 'Code',
  'pl.name': 'Name',
  'pl.currency': 'Currency',
  'pl.paymentMethod': 'Payment method',
  'pl.payment.any': 'Any',
  'pl.payment.cash': 'Cash',
  'pl.payment.transfer': 'Bank transfer',
  'pl.isDefault': 'Default price list',
  'pl.isDefaultHint': 'There can be ONLY ONE default price list: with two, the price selection order becomes ambiguous and the same product is sold at two different prices.',
  'pl.validFrom': 'Valid from',
  'pl.validTo': 'Valid to',
  'pl.itemCount': 'Lines',
  'pl.status': 'Status',
  'pl.create': 'Create',
  'pl.created': 'Price list created: {code}',
  'pl.items': 'Price lines',
  'pl.itemsOf': '{name} — price lines',
  'pl.sku': 'SKU',
  'pl.product': 'Product',
  'pl.price': 'Price',
  'pl.minQty': 'Minimum quantity',
  'pl.minQtyHint': 'Volume tier: this price applies from this quantity upwards.',
  'pl.itemsEmpty': 'This price list has no lines',
  'pl.selectList': 'Select a price list on the left',
  'pl.bulk': 'Bulk entry',
  'pl.bulkTitle': 'Paste prices from Excel',
  'pl.bulkHint': 'Copy the columns from Excel and paste them here. Each line: SKU, price and (optionally) minimum quantity — separated by TAB or semicolon.',
  'pl.bulkPlaceholder': 'LED-PNL-600	18.00\nLED-BLB-09	1.50	100',
  'pl.bulkParsed': '{count} rows recognized',
  'pl.bulkUnknownSku': 'Not found in the catalog: {sku}',
  'pl.bulkInvalid': 'Row {n}: price or SKU is invalid',
  'pl.bulkApply': 'Apply',
  'pl.bulkDone': 'Total {total}: {created} new, {updated} updated',
  'pl.bulkEmpty': 'No rows to apply',
  'pl.loadError': 'Could not load the price lists',
  'pl.noEdit': 'You do not have permission to edit price lists. Ask your manager if you need it.',
  'cash.description': 'Cash and bank accounts. Without them no payment can be recorded. Each account is in ITS OWN currency: a soum account and a dollar account are two separate records.',
  'cash.new': 'New account',
  'cash.code': 'Code',
  'cash.name': 'Name',
  'cash.type': 'Type',
  'cash.type.cash': 'Cash account',
  'cash.type.bank': 'Bank',
  'cash.currency': 'Currency',
  'cash.legalEntity': 'Legal entity',
  'cash.bankName': 'Bank name',
  'cash.accountNo': 'Account number',
  'cash.balance': 'Balance',
  'cash.status': 'Status',
  'cash.create': 'Create',
  'cash.created': 'Account created: {code}',
  'cash.archive': 'Archive',
  'cash.archived': 'Account archived',
  'cash.archiveHint': 'An account with a balance cannot be archived: the money would disappear from the report but stay in the transactions, and the cash account would no longer match the books.',
  'cash.empty': 'No accounts found',
  'cash.loadError': 'Could not load the accounts',
  'cash.noEdit': 'You do not have permission to create accounts. Ask your manager if you need it.',
  'cfg.description': 'Configurable values of the business rules. They live in the database, not in the code: the BUSINESS changes them, and every change goes into the audit log.',
  'cfg.key': 'Key',
  'cfg.value': 'Value',
  'cfg.dataType': 'Type',
  'cfg.about': 'What it is for',
  'cfg.edit': 'Edit',
  'cfg.saved': '{key} saved',
  'cfg.invalidNumber': 'Only a number is allowed',
  'cfg.invalidJson': 'Invalid JSON format',
  'cfg.moneyAsText': 'Money and percentage values are stored as TEXT — stored as a number, the value is rounded and drifts at the level of a cent.',
  'cfg.typeMismatch': 'The value type in the database differs from the declared one ({declared}). The editor was chosen from the actual type.',
  'cfg.empty': 'No settings found',
  'cfg.loadError': 'Could not load the settings',
  'cfg.boolTrue': 'Enabled',
  'cfg.boolFalse': 'Disabled',
  'audit.occurredAt': 'Time',
  'audit.actor': 'Who',
  'audit.actorIp': 'IP',
  'audit.entity': 'Document',
  'audit.entityTable': 'Document type',
  'audit.entityId': 'Record ID',
  'audit.action': 'Action',
  'audit.changes': 'Changes',
  'audit.field': 'Field',
  'audit.oldValue': 'Old',
  'audit.newValue': 'New',
  'audit.noChanges': 'No field changes',
  'audit.limit': 'Number of records',
  'audit.unknownActor': 'Employee #{id}',
  'audit.system': 'System',
  'audit.empty': 'No records found',
  'audit.loadError': 'Could not load the audit log',
  'audit.clearFilters': 'Clear filters',
  'audit.action.insert': 'Created',
  'audit.action.update': 'Updated',
  'audit.action.delete': 'Deleted',
  'audit.action.login': 'Signed in',
  'audit.action.logout': 'Signed out',
  'audit.description': 'One list: document changes, sign-ins and sign-outs, printing and permission denials. Every record shows which account, from which IP and on what device.',
  'audit.filtersError': 'Could not load the filter lists — filtering by document type is unavailable',
  'audit.total': '{count} record(s)',
  'audit.device': 'Device',
  'audit.rawUserAgent': 'Raw User-Agent: {value}',
  'audit.filterAction': 'Action',
  'audit.filterActionHint': 'Several can be selected at once. With none selected, everything is shown.',
  'audit.groupDocument': 'Document actions',
  'audit.groupAccess': 'Access and other events',
  'audit.actionAll': 'All',
  'audit.action.override': 'Overridden',
  'audit.action.loginFailed': 'Sign-in rejected',
  'audit.action.permissionDenied': 'Permission denied',
  'audit.action.export': 'Exported',
  'audit.action.print': 'Printed',
  'audit.action.unknown': 'Unknown action ({code})',
  'audit.editWindow.override': 'Correction window bypassed',
  'audit.editWindow.overrideHint': 'The 24-hour correction window had closed. The action went through DELIBERATELY under `correction.override` — the rule was not broken, it was bypassed.',
  'audit.editWindow.within': 'Within the correction window',
  'audit.event': 'Event',
  'audit.device.notRecorded': 'Device not recorded',
  'audit.device.notRecordedHint': 'This record predates device capture — the evidence itself does not exist.',
  'audit.device.unrecognized': 'Not recognized',
  'audit.device.unrecognizedHint': 'The device string EXISTS but matched no pattern. The raw string is here.',
  'audit.device.desktop': 'desktop',
  'audit.device.mobile': 'mobile',
  'audit.device.tablet': 'tablet',
  'audit.device.bot': 'script',
  'audit.device.unknownKind': 'unknown type',
  'audit.allTables': 'All document types',
  'audit.tableUntranslated': 'No name yet: {code}',
  'audit.tableUntranslatedHint': 'This document type has no name yet — the developer code is on screen. The code itself is shown: replacing it with “Other document” would lose which document it was entirely.',
  'audit.untranslatedCount': '{count} document type(s) without a name',
  'audit.table.accountingPeriods': 'Accounting period',
  'audit.table.approvalDelegations': 'Approval delegation',
  'audit.table.approvalRequests': 'Approval request',
  'audit.table.approvalRules': 'Approval rule',
  'audit.table.bonusEntries': 'Bonus entry',
  'audit.table.branches': 'Branch',
  'audit.table.cashAccounts': 'Cash account',
  'audit.table.cashFlowItems': 'Cash-flow item',
  'audit.table.cashTransactions': 'Cash transaction',
  'audit.table.charityAppropriations': 'Charity appropriation',
  'audit.table.charityPayouts': 'Charity payout',
  'audit.table.commissionRules': 'Commission rule',
  'audit.table.commissionRuns': 'Commission run',
  'audit.table.costTypes': 'Cost type',
  'audit.table.creditNotes': 'Credit note',
  'audit.table.customerContacts': 'Customer contact',
  'audit.table.customerPrices': 'Customer price',
  'audit.table.customerUsers': 'Customer portal user',
  'audit.table.customers': 'Customer',
  'audit.table.dailyRates': 'Daily FX rate',
  'audit.table.dayClosings': 'Day closing',
  'audit.table.dealerRebateTiers': 'Dealer rebate tier',
  'audit.table.dealerUsers': 'Dealer user',
  'audit.table.dealers': 'Dealer',
  'audit.table.deliveries': 'Delivery note',
  'audit.table.documents': 'Document (scan, certificate)',
  'audit.table.employeeAdvances': 'Employee advance',
  'audit.table.employeeDebts': 'Employee debt',
  'audit.table.employees': 'Employee',
  'audit.table.expenses': 'Expense',
  'audit.table.fxRevaluations': 'FX revaluation',
  'audit.table.goodsReceipts': 'Goods receipt',
  'audit.table.installers': 'Installer',
  'audit.table.inventoryTransactions': 'Inventory movement',
  'audit.table.invoices': 'Invoice',
  'audit.table.journals': 'Journal entry',
  'audit.table.kpiPlans': 'KPI plan',
  'audit.table.landedCostRuns': 'Landed-cost run',
  'audit.table.payments': 'Payment',
  'audit.table.payrollRuns': 'Payroll run',
  'audit.table.poPaymentTerms': 'Purchase payment term',
  'audit.table.priceListItems': 'Price-list line',
  'audit.table.priceLists': 'Price list',
  'audit.table.printTemplates': 'Print template',
  'audit.table.productPoints': 'Product points (installer)',
  'audit.table.products': 'Product',
  'audit.table.purchaseOrders': 'Purchase order',
  'audit.table.qrBatches': 'QR batch',
  'audit.table.qrCodes': 'QR code',
  'audit.table.redemptions': 'Reward redemption',
  'audit.table.reorderRunLines': 'Reorder line',
  'audit.table.reorderRuns': 'Reorder run',
  'audit.table.rewards': 'Reward',
  'audit.table.salesOrders': 'Sales order',
  'audit.table.salesReturnLines': 'Return line',
  'audit.table.salesReturns': 'Sales return',
  'audit.table.sessions': 'Session',
  'audit.table.settings': 'System setting',
  'audit.table.shipmentCosts': 'Shipment cost',
  'audit.table.shipments': 'Shipment',
  'audit.table.stockCounts': 'Stock count',
  'audit.table.stockTransfers': 'Stock transfer',
  'audit.table.supplierInvoices': 'Supplier invoice',
  'audit.table.suppliers': 'Supplier',
  'audit.table.tenants': 'Organization',
  'audit.table.userRoles': 'User role',
  'audit.table.users': 'User',
  'audit.table.warehouses': 'Warehouse',
  'audit.field.status': 'Status',
  'audit.field.amount': 'Amount',
  'audit.field.amountBase': 'Amount (base currency)',
  'audit.field.totalAmount': 'Total',
  'audit.field.totalBase': 'Total (base currency)',
  'audit.field.balanceBase': 'Balance (base currency)',
  'audit.field.balanceAmount': 'Balance',
  'audit.field.vatAmount': 'VAT amount',
  'audit.field.vatBase': 'VAT (base currency)',
  'audit.field.vatRate': 'VAT rate',
  'audit.field.listAmount': 'List price',
  'audit.field.discountAmount': 'Discount',
  'audit.field.priceAmount': 'Price',
  'audit.field.unitCost': 'Unit cost',
  'audit.field.quantity': 'Quantity',
  'audit.field.currency': 'Currency',
  'audit.field.currencyCode': 'Currency code',
  'audit.field.rate': 'Rate',
  'audit.field.fxRate': 'FX rate',
  'audit.field.fxRateManual': 'Rate entered manually',
  'audit.field.rateDate': 'Rate date',
  'audit.field.docNo': 'Document no.',
  'audit.field.invoiceNo': 'Invoice no.',
  'audit.field.deliveryNo': 'Delivery no.',
  'audit.field.batchNo': 'Batch no.',
  'audit.field.lineCount': 'Line count',
  'audit.field.codeCount': 'Code count',
  'audit.field.format': 'Format',
  'audit.field.mode': 'Mode',
  'audit.field.method': 'Method',
  'audit.field.paymentMethod': 'Payment method',
  'audit.field.paymentTermDays': 'Payment term (days)',
  'audit.field.dueDate': 'Due date',
  'audit.field.invoiceDate': 'Invoice date',
  'audit.field.orderDate': 'Order date',
  'audit.field.receiptDate': 'Receipt date',
  'audit.field.incurredDate': 'Cost date',
  'audit.field.businessDate': 'Business date',
  'audit.field.validFrom': 'Valid from',
  'audit.field.postedAt': 'Posted at',
  'audit.field.occurredAt': 'Occurred at',
  'audit.field.name': 'Name',
  'audit.field.nameUz': 'Name (Uzbek)',
  'audit.field.nameRu': 'Name (Russian)',
  'audit.field.fullName': 'Full name',
  'audit.field.legalName': 'Legal name',
  'audit.field.code': 'Code',
  'audit.field.sku': 'SKU',
  'audit.field.phone': 'Phone',
  'audit.field.address': 'Address',
  'audit.field.notes': 'Notes',
  'audit.field.description': 'Description',
  'audit.field.reason': 'Reason',
  'audit.field.reasonCode': 'Reason code',
  'audit.field.reversalReason': 'Reversal reason',
  'audit.field.reversalDocNo': 'Reversal document',
  'audit.field.writeoffReason': 'Write-off reason',
  'audit.field.overrideReason': 'Override reason',
  'audit.field.differenceReason': 'Difference reason',
  'audit.field.isActive': 'Active',
  'audit.field.isBlocked': 'Blocked',
  'audit.field.isDefault': 'Default',
  'audit.field.isSellable': 'Sellable',
  'audit.field.isPurchasable': 'Purchasable',
  'audit.field.creditLimitAmount': 'Credit limit',
  'audit.field.creditLimitBase': 'Credit limit (base currency)',
  'audit.field.creditLimitCurrency': 'Credit limit currency',
  'audit.field.outstandingBase': 'Outstanding debt (base currency)',
  'audit.field.creditCheckResult': 'Credit check result',
  'audit.field.creditOverrideBy': 'Who overrode the limit',
  'audit.field.privilegeEscalationDenied': 'Privilege escalation denied',
  'audit.field.sessionsRevoked': 'Sessions revoked',
  'audit.field.role': 'Role',
  'audit.field.locale': 'Language',
  'audit.field.document': 'Document',
  'audit.field.missingFields': 'Missing fields',
  'audit.field.salaryAmount': 'Salary',
  'audit.field.position': 'Position',
  'audit.field.employeeNo': 'Employee no.',
  'audit.field.hiredAt': 'Hired on',
  'audit.field.firedAt': 'Left on',
  'audit.field.containerNo': 'Container no.',
  'audit.field.vehicleNo': 'Vehicle no.',
  'audit.field.driverName': 'Driver',
  'audit.field.eta': 'ETA',
  'audit.field.etd': 'ETD',
  'audit.field.ata': 'Actual arrival',
  'audit.field.weightKg': 'Weight (kg)',
  'audit.field.volumeM3': 'Volume (m³)',
  'audit.field.cashBalance': 'Cash balance',
  'audit.field.cashIn': 'Cash in',
  'audit.field.cashOut': 'Cash out',
  'audit.field.countedAmount': 'Counted amount',
  'audit.field.openingBalance': 'Opening balance',
  'audit.field.expectedBalance': 'Expected balance',
  'audit.field.difference': 'Difference',
  'audit.field.inventoryValue': 'Inventory value',
  'audit.field.txnType': 'Transaction type',
  'audit.field.accountType': 'Account type',
  'audit.field.customerType': 'Customer type',
  'audit.field.orderSource': 'Order source',
  'audit.field.source': 'Source',
  'dlr.description': 'A dealer is an independent trader: they buy goods from us, keep them in their own warehouse and sell them to their own customers. Their sales DO NOT enter our reports; from them we only see the purchase volume, and the rebate is calculated from that volume.',
  'dlr.channelTitle': 'A dealer also exists as a customer',
  'dlr.channelWhy': 'Every dealer is linked to one of OUR customers, and that is mandatory: the annual bonus (rebate) is calculated from the total of the invoices issued to that customer. A dealer record without a customer would always show a bonus of zero.',
  'dlr.openBonus': 'Go to bonus accounts',
  'dlr.code': 'Code',
  'dlr.name': 'Name',
  'dlr.customer': 'Customer',
  'dlr.customerPick': 'Select a customer',
  'dlr.customerHint': 'The rebate basis is taken from the invoices issued to this customer.',
  'dlr.territory': 'Territory',
  'dlr.contract': 'Contract',
  'dlr.until': 'until {date}',
  'dlr.status': 'Status',
  'dlr.statusActive': 'Active',
  'dlr.statusSuspended': 'Suspended',
  'dlr.statusTerminated': 'Terminated',
  'dlr.filterAll': 'All',
  'dlr.suspend': 'Suspend',
  'dlr.activate': 'Activate',
  'dlr.terminate': 'Terminate contract',
  'dlr.finalState': 'Final state — cannot be undone',
  'dlr.new': 'New dealer',
  'dlr.create': 'Create dealer',
  'dlr.createdMsg': 'Dealer created: {code}',
  'dlr.noManage': 'You do not have permission to change a dealer record — it is a commercial decision and the finance officer does not have that right. Ask your manager if you need it.',
  'dlr.searchPlaceholder': 'Code, name or territory',
  'dlr.empty': 'No dealers found',
  'dlr.emptyHint': 'Use the form below to add a new dealer.',
  'dlr.loadError': 'Could not load the list of dealers',
  // `dlr.searchLabel` o'chirildi — sabab `i18n.ts` da (ekran `common.search` ni ishlatadi).
  'bns.description': 'A bonus is paid to two parties: to the dealer as a percentage of the annual purchase volume (rebate), and to the installer as points for the products they mounted. In the end both turn into ONE thing — money leaving the cash account — which is why they sit in a single list.',
  'bns.pointValue': 'Point value',
  'bns.pointValueIs': '1 point = {value} USD',
  'bns.pointValueWhy': 'The value is derived from the reward catalog: the cost of all active rewards ÷ their price in points. So the real value of a point changes together with the catalog, and the value used at the moment of payment is RECORDED on the document.',
  'bns.pointValueUnknown': 'The point value could not be calculated: there is no active reward in the catalog with a cost entered. Before an installer bonus can be cashed out, enter the costs first (Installer program → Reward catalog).',
  'bns.partyType': 'Who',
  'bns.partyDealer': 'Dealer',
  'bns.partyInstaller': 'Installer',
  'bns.code': 'Code / phone',
  'bns.name': 'Name',
  'bns.points': 'Points',
  'bns.accrued': 'Accrued',
  'bns.paid': 'Paid',
  'bns.balance': 'Balance',
  'bns.balanceFilter': 'Balance',
  'bns.onlyWithBalance': 'With a balance only',
  'bns.filterAll': 'All',
  'bns.blocked': 'Blocked',
  'bns.accrue': 'Accrue rebate',
  'bns.accruedMsg': '{docNo}: {amount} USD accrued',
  'bns.payout': 'Cash out',
  'bns.payoutTitle': '{name} — cash out the bonus',
  'bns.payoutConfirm': 'Pay',
  'bns.payoutWarn': 'This action TAKES MONEY OUT OF THE CASH ACCOUNT and it cannot be undone. The movement is recorded against a cash flow item and the cash balance drops immediately.',
  'bns.cashAccount': 'Cash account',
  'bns.cashPick': 'Select a cash account',
  'bns.cashHint': 'The currency comes from the cash account, and the rate from the payment date.',
  'bns.amountUsd': 'Amount (USD)',
  'bns.amountHint': 'Balance: {balance} USD. It may be paid in parts.',
  'bns.pointsToCash': 'Points to cash out',
  'bns.pointsHint': 'Balance: {balance} points. The points are deducted immediately.',
  'bns.notes': 'Note',
  'bns.paidMsg': '{docNo}: {amount} {currency} paid',
  'bns.noPayout': 'You do not have permission to cash out a bonus — it is the same as taking money out of the cash account, and only the finance officer and the administrator have it. Ask them if you need it.',
  'bns.searchPlaceholder': 'Dealer code, installer phone or name',
  'bns.empty': 'No bonus account found',
  'bns.loadError': 'Could not load the bonus accounts',
  'bns.ledgerHint': 'Every accrual and every payout stays in the ledger.',
  'bns.openLedger': 'Open the bonus ledger',
  'bnl.description': 'The bonus ledger is the immutable history of accruals and payouts. An entry is never deleted or edited: a bonus is a liability of the company, and a payout is money that has left the cash account.',
  'bnl.immutable': 'The ledger is IMMUTABLE. A correction is made only by a reversing entry, and that is a separate, recorded action.',
  'bnl.docNo': 'Document',
  'bnl.occurredAt': 'Time',
  'bnl.entryType': 'Type',
  'bnl.typeAccrual': 'Accrued',
  'bnl.typePayout': 'Paid',
  'bnl.basis': 'Basis',
  'bnl.pointsUnit': 'points',
  'bnl.amountBase': 'Amount (USD)',
  'bnl.amount': 'Cash amount',
  'bnl.balanceAfter': 'Balance (after)',
  'bnl.reversal': 'Reversal',
  'bnl.searchPlaceholder': 'Document number',
  'bnl.empty': 'The ledger is empty',
  'bnl.loadError': 'Could not load the bonus ledger',
  'loy.points': 'Points',
  'loy.pointsUnit': '{points} points',
  'loy.actions': 'Actions',
  'loy.sku': 'SKU',
  'loy.product': 'Product',
  'loy.pointValue': 'Point value',
  'loy.pointValueUnit': '{value} / 1 point',
  'loy.pointValueBasis': '{rewards} active rewards: total cost {cost} ÷ {points} points in total',
  'loy.pointValueWhy': 'The point value is DERIVED FROM THE CATALOG: the total cost of the rewards ÷ their total price in points. So when the catalog changes, the money value of the points already earned changes too — while the number of points stays the same.',
  'loy.pointValueMissing': 'POINT VALUE CANNOT BE CALCULATED',
  'loy.pointValueMissingBody': 'There is no active reward in the catalog with a cost entered. In that case EVERY money figure on this screen is unknown: «150 points owed» tells the budget nothing. First enter the reward’s cost in the reward catalog.',
  'loy.pointValueZeroRewards': 'The value was derived from ZERO rewards — so it is not a value at all. Enter the cost in the reward catalog.',
  'loy.pointValueSample': 'This value is a SAMPLE: it is a temporary placeholder and must be replaced with the real one. Once marketing approves it, it will be derived from the reward catalog.',
  'loy.title': 'Installer program — program status',
  'loy.description': 'An installer mounts an LED product, scans the QR code and earns points. Every point is a LIABILITY OF THE COMPANY: no money has left, no goods have shipped, but a promise has been made. This screen shows that liability.',
  'loy.outstanding': 'Outstanding liability',
  'loy.outstandingHint': 'Points held by installers — a reward can be requested any day',
  'loy.outstandingInstallers': '{withBalance} installers have points (out of {total})',
  'loy.pending': 'Redemptions in the queue',
  'loy.pendingHint': 'Rewards requested or approved but not handed over yet',
  'loy.pendingCount': '{count} requests',
  'loy.awaiting': 'Awaiting scan',
  'loy.awaitingHint': 'The goods are SOLD, the installer has not scanned yet',
  'loy.awaitingCodes': '{codes} activated codes',
  'loy.awaitingWhy': 'This is a POTENTIAL liability, not an error. A code is activated only when the goods are sold, so these points are GUARANTEED to be awarded: the installer simply has not scanned yet. The budget has to account for them already.',
  'loy.awaitingByProduct': 'By product',
  'loy.awaitingEmpty': 'No activated, unscanned codes',
  'loy.codes': 'Codes',
  'loy.pointsPerCode': 'Points / code',
  'loy.missingRuleBadge': 'No rule',
  'loy.missingRuleWarn': '{count} products have activated codes but NO point rule in effect today. Scanning these codes awards no points, and the installer calls to say «the QR does not work».',
  'loy.totalOwed': 'Total liability',
  'loy.totalOwedHint': 'Balance + queue + points awaiting a scan',
  'loy.quickLinks': 'Program screens',
  'loy.fraudSignals': '{count} signals in the review queue',
  'loy.fraudNone': 'The review queue is empty',
  'loy.loadError': 'Could not load the program status',
  'loy.installersTotal': 'Registered installers',
  'lpr.title': 'Point rules',
  'lpr.description': 'How many points one box of each product gives. A product WITHOUT a rule gives no points, and its code cannot be scanned at all.',
  'lpr.frozenWhy': 'Awarded points are frozen AT THE MOMENT OF THE SCAN. If you change the rule later, past scans are not recalculated — otherwise the points an installer has earned would change every week.',
  'lpr.versionedWhy': 'A rule is NOT EDITED, it is VERSIONED by date (the same pattern as the price list): a promotion adds a new line. That is why there is no «edit» button on this screen.',
  'lpr.points': 'Points',
  'lpr.validFrom': 'Valid from',
  'lpr.validTo': 'Valid to',
  'lpr.validToHint': 'Leave empty for no end date. For a promotion, set the end date.',
  'lpr.notes': 'Note',
  'lpr.state': 'Status',
  'lpr.state.active': 'Active',
  'lpr.state.future': 'Future',
  'lpr.state.expired': 'Overdue',
  'lpr.showAll': 'Show all versions',
  'lpr.showAllHint': 'Normally only the rules in effect TODAY are shown: over time a single product accumulates dozens of versions, and they bury the answer.',
  'lpr.new': 'New rule',
  'lpr.create': 'Create rule',
  'lpr.created': '{sku} — {points} points (from {from})',
  'lpr.productRequired': 'A product is required',
  'lpr.pointsInvalid': 'Points must be a whole number from 0 to 1,000,000',
  'lpr.zeroAllowed': '0 IS ALLOWED and it differs from having NO rule: 0 means «no points are awarded for this product on purpose», while a missing rule means «somebody forgot to set it up».',
  'lpr.noEdit': 'You do not have permission to change point rules — only the administrator and the manager have it. The point rate is a MARKETING decision, not a finance one; ask your manager if you need it.',
  'lpr.missingTitle': 'Products with no point rule: {count}',
  'lpr.missingBody': 'Scanning these products is REJECTED with the reason "No point rule". The installer calls to say «the QR does not work», and the cause takes an hour to find — that is why this list is here.',
  'lpr.missingNone': 'Every product on sale has a point rule in effect today.',
  'lpr.missingLoadError': 'Could not load the list of products without rules.',
  'lpr.missingOrder': 'The order is by URGENCY: the product with the most activated codes comes first. An activated code means «the goods are sold», so an installer may be trying to scan right now and getting rejected.',
  'lpr.activatedCodes': 'Activated codes',
  'lpr.missingUrgent': '{count} of them have activated codes',
  'lpr.missingUrgentHint': 'The goods are sold, the code is activated, but there is no rule — the scan is rejected.',
  'lpr.missingScanning': 'May be scanned right now',
  'lpr.missingRest': 'Another {count} products have no rule — they are less urgent.',
  'lpr.stats.active': 'Active rules',
  'lpr.stats.future': 'Future',
  'lpr.stats.expired': 'Overdue',
  'lpr.stats.missing': 'Products without a rule',
  'lpr.empty': 'No point rules found',
  'lpr.emptyHint': 'Widen the filter or create the first rule.',
  'lpr.loadError': 'Could not load the point rules',
  'lpr.filterProduct': 'By product',
  'lpr.clearFilter': 'Clear filter',
  'lqr.title': 'QR batches',
  'lqr.description': 'A UNIQUE code for every box. The code is born in the "In warehouse" state and IS NOT SCANNABLE — it is only activated when the product is sold.',
  'lqr.lifecycleWhy': 'created → (product sold) → activated → (installer scanned) → scanned. Activation is tied to the shipment, so points cannot be granted for goods sitting in the warehouse, and even if a roll of stickers falls into the wrong hands, points can only be earned for what has been SOLD.',
  'lqr.batchNo': 'Batch',
  'lqr.quantity': 'Number of codes',
  'lqr.printedAt': 'Exported',
  'lqr.notPrinted': 'Not exported',
  'lqr.notes': 'Note',
  'lqr.st.created': 'In warehouse',
  'lqr.st.activated': 'Sold',
  'lqr.st.scanned': 'Scanned',
  'lqr.st.void': 'Void',
  'lqr.new': 'New batch',
  'lqr.createSubmit': 'Create batch',
  'lqr.createdMsg': '{batchNo}: {quantity} codes created',
  'lqr.quantityHint': 'From 1 to {max}. Extra codes eat up the printing budget.',
  'lqr.quantityInvalid': 'Quantity must be a whole number from 1 to {max}',
  'lqr.noGenerate': 'You do not have permission to issue and export codes — only the administrator and the manager have it. Ask your manager if you need it.',
  'lqr.export': 'Export codes',
  'lqr.exportTitle': 'Export is not reading — it is equivalent to ISSUING CODES',
  'lqr.exportBody': 'The response contains ALL codes of the batch in plain text. Whoever gets them can collect every point as soon as the goods are sold, so this file is a security document.',
  'lqr.exportAudited': 'The action ITSELF is recorded in the audit log as an "export", and the batch is stamped with the export date. Even if you do not save the file, the record stays — it cannot be undone.',
  'lqr.exportUnderstood': 'I understand: the action is audited and the date will be stamped',
  'lqr.exportReprint': 'WARNING: this batch was already exported on {date}. A second export means "let us print them again" and looks suspicious in the audit — state the reason in the note.',
  'lqr.exportConfirm': 'Yes, export {count} codes',
  'lqr.exportDone': '{batchNo}: {count} codes written to file',
  'lqr.exportFailed': 'Could not export the codes',
  'lqr.exportFileHint': 'The file is built from EXACTLY the codes returned by the server — no second request is sent. The columns are: sequence number, code, status, product code (SKU) and batch number. The file header is serial;code;status;sku;batch_no',
  'lqr.empty': 'No QR batches found',
  'lqr.emptyHint': 'It is possible that no batch has been created yet.',
  'lqr.loadError': 'Could not load QR batches',
  'lst.title': 'Sticker stock',
  'lst.why': 'When a shipment is posted, the codes of that product are activated. If there are NOT ENOUGH codes, the delivery WILL NOT STOP — only a warning is written to the log, so the goods leave without stickers and the installer has nothing to scan. This silent failure is visible exactly here.',
  'lst.created': 'Remaining stock',
  'lst.productStock': 'Product stock',
  'lst.order': 'Sorted by stock ascending: products that are running out come first.',
  'lst.rest': '{count} more products in the list.',
  'lst.emptyWarn': '{count} products have NO code stock: at the next delivery their boxes will get no stickers. Create a new batch.',
  'lst.lowWarn': '{count} products have less than {threshold} in stock — printing and applying a batch takes time, order in advance.',
  'lst.badgeEmpty': 'No stock',
  'lst.badgeLow': 'Low stock',
  'lst.empty': 'No QR codes have been created for any product',
  'lst.loadError': 'Could not load sticker stock',
  'lrw.title': 'Reward catalog',
  'lrw.description': 'What points are exchanged for. Cost is the price of the reward TO THE COMPANY; it is what defines the real value of a point.',
  'lrw.code': 'Code',
  'lrw.name': 'Name',
  'lrw.pointsCost': 'Price in points',
  'lrw.costBase': 'Cost (USD)',
  'lrw.costBaseHint': 'The expense to the company. If left empty, this reward IS NOT INCLUDED in the point value calculation.',
  'lrw.stockQty': 'Stock',
  'lrw.stockUnlimited': 'Unlimited',
  'lrw.stockHint': 'Left empty — unlimited (like a certificate). 0 — out of stock.',
  'lrw.status': 'Status',
  'lrw.active': 'Active',
  'lrw.inactive': 'Disabled',
  'lrw.derivedValue': 'Point value (derived)',
  'lrw.average': 'Catalog average: {value}',
  'lrw.averageMissing': 'Could not calculate the catalog average — cost is not filled in',
  'lrw.divergeWhy': 'The ratio must be CONSISTENT. If one reward is more profitable than the others, the installer will certainly work it out and the rest of the catalog will go unused. The "point value" in each row = cost ÷ price in points; rows deviating from the average by more than ±{pct}% are flagged.',
  'lrw.divergeAlert': '{count} rewards differ from the catalog average by more than ±{pct}% — the real point rate is set by those rows.',
  'lrw.flag.high': 'Better than average',
  'lrw.flag.highHint': 'The installer will pick exactly this reward — in practice the point rate is set by this row.',
  'lrw.flag.low': 'Worse than average',
  'lrw.flag.lowHint': 'This reward is not requested in practice — a dead item in the catalog.',
  'lrw.flag.unknown': 'No cost',
  'lrw.new': 'New reward',
  'lrw.create': 'Create reward',
  'lrw.createdMsg': 'Reward created: {code}',
  'lrw.edit': 'Edit',
  'lrw.editTitle': '{name} — edit',
  'lrw.saved': 'Reward saved: {name}',
  'lrw.codeImmutable': 'The code IS NOT EDITABLE: it is a stable identifier and changing it breaks the redemption history.',
  'lrw.deactivate': 'Disable',
  'lrw.activate': 'Activate',
  'lrw.deactivateHint': 'A disabled reward is not visible to the installer, but old requests stay in place and it also drops out of the point value calculation.',
  'lrw.moneyAsText': 'Cost and stock are kept EXACTLY: they are not converted into a rounded number, because here even 0.01 matters.',
  'lrw.invalidMoney': 'Invalid amount format (for example "12.5000")',
  'lrw.invalidPoints': 'Price in points must be a whole number greater than 1',
  'lrw.codeRequired': 'Code and name are required',
  'lrw.noEdit': 'You do not have permission to change the reward catalog. The catalog is a MARKETING budget; ask your manager if you need it.',
  'lrw.empty': 'No rewards found',
  'lrw.loadError': 'Could not load the reward catalog',
  'lrd.title': 'Reward redemptions',
  'lrd.description': 'Requests sent by installers. Approve → issue; rejecting RETURNS the points.',
  'lrd.deductedWhy': 'Points are ALREADY deducted at request time — otherwise the installer would spend the same points on two rewards. So "approve" is not a money movement, and "reject" is NOT free: on rejection the points go back to the installer through a reversing entry and their balance increases immediately.',
  'lrd.separationWhy': 'You cannot go from "Requested" straight to "Issued": the person who approves the request and the person who hands over the reward must not be the same, otherwise the storekeeper could write a reward out to themselves.',
  'lrd.docNo': 'Document',
  'lrd.installer': 'Installer',
  'lrd.reward': 'Reward',
  'lrd.pointsCost': 'Points',
  'lrd.status': 'Status',
  'lrd.statusAll': 'All statuses',
  'lrd.requestedAt': 'Request date',
  'lrd.issuedAt': 'Issued',
  'lrd.rejectReason': 'Rejection reason',
  'lrd.deliveryNote': 'Delivery note',
  'lrd.status.requested': 'Requested',
  'lrd.status.approved': 'Approved',
  'lrd.status.issued': 'Issued',
  'lrd.status.rejected': 'Rejected',
  'lrd.status.cancelled': 'Cancelled',
  'lrd.approve': 'Approve',
  'lrd.approved': '{docNo} approved — the reward can now be issued',
  'lrd.issue': 'Issue',
  'lrd.issueNote': 'Issue note (phone, address)',
  'lrd.issued': '{docNo} issued — FINAL status',
  'lrd.reject': 'Reject',
  'lrd.rejectTitle': 'Reject the request',
  'lrd.rejectHint': 'The reason is MANDATORY and the installer sees it: a request rejected without a reason is resubmitted immediately and the queue fills up again.',
  'lrd.rejectReasonRequired': 'The reason must be at least 3 characters long',
  'lrd.rejected': '{docNo} rejected — {points} points returned to the installer (new balance {balance})',
  'lrd.noApprove': 'You do not have permission to approve requests. Ask your manager if you need it.',
  'lrd.empty': 'No redemption requests found',
  'lrd.emptyHint': 'Widen the status filter.',
  'lrd.loadError': 'Could not load redemptions',
  'lrd.filterInstaller': 'Filtered by installer #{id}',
  'lrd.clearFilter': 'Clear filter',
  'lin.title': 'Installers',
  'lin.description': 'Installers registered in the program, their point balance and latest activity.',
  'lin.notUserWhy': 'An installer uses the app only to scan codes and has no access to Alight. That is why this screen grants them neither roles nor permissions — only blocking.',
  'lin.policyMore': 'More details',
  'lin.blockPolicy': 'A block is placed on suspicion and a review may not confirm it, while the points already earned are what the company owes the installer. That is why blocking never touches the points. Taking back points granted by mistake is a separate action: find the scan in the review queue and reverse it.',
  'lin.phone': 'Phone',
  'lin.name': 'Full name',
  'lin.balance': 'Balance',
  'lin.earned': 'Earned',
  'lin.redeemed': 'Spent',
  'lin.lastScan': 'Last scan',
  'lin.neverScanned': 'Never scanned',
  'lin.lastLogin': 'Last login',
  'lin.createdAt': 'Registered',
  'lin.status': 'Status',
  'lin.active': 'Active',
  'lin.blocked': 'Blocked',
  'lin.verified': 'Verified',
  'lin.block': 'Block',
  'lin.unblock': 'Unblock',
  'lin.blockTitle': '{name} — block',
  'lin.unblockTitle': '{name} — unblock',
  'lin.blockReason': 'Blocking reason',
  'lin.blockReasonRequired': 'A reason is required — it goes into the audit log',
  'lin.blockKeepsPoints': 'Blocking stops scanning — the points already earned stay with the installer.',
  'lin.blockedOk': '{name} blocked. The balance is unchanged: {balance} points.',
  'lin.unblockedOk': '{name} unblocked',
  'lin.noBlock': 'You do not have permission to block installers — that is why the button is not shown in the rows. Ask your manager if you need it.',
  'lin.filterAll': 'All',
  'lin.filterActive': 'Active only',
  'lin.filterBlocked': 'Blocked only',
  'lin.searchPlaceholder': 'Name or phone',
  'lin.openRedemptions': 'Redemptions →',
  'lin.openFraud': 'Review queue →',
  'lin.empty': 'No installers found',
  'lin.emptyHint': 'Widen the filter or clear the search.',
  'lin.loadError': 'Could not load installers',
  'lin.notFound': 'Installer not found or not visible to you',
  'lin.openCard': 'Card →',
  'lin.unblockHint': 'After being unblocked the installer can scan again. Codes not scanned during the block are not lost — they are still active and can be scanned later.',
  'lid.back': '← Installer list',
  'lid.telegram': 'Telegram connected',
  'lid.balanceHint': 'What the company owes this installer',
  'lid.earnedTotal': 'Earned: {points}',
  'lid.redeemedTotal': 'Spent: {points}',
  'lid.scanCount': 'Successful scans',
  'lid.scanCountHint': 'Number of codes that earned points',
  'lid.rejectedCount': 'Rejected attempts',
  'lid.rejectedCountHint': 'Not an accusation in ITSELF: an honest installer also mistypes a code. The decision is made in the review queue, together with the other breakdowns.',
  'lid.ledger': 'Point ledger',
  'lid.ledgerWhy': 'The ledger is IMMUTABLE: an entry is never deleted or corrected, only a REVERSING entry is added. That is why "reversal" (this entry is itself a reversal) and "reversed" (this entry was later reversed) are two different markers. The source column shows the SKU for a scan and the reward name for a redemption.',
  'lid.ledgerEmpty': 'The ledger is empty — this installer has not earned any points yet',
  'lid.ledgerLimit': 'The last 200 entries are shown.',
  'lid.occurredAt': 'Time',
  'lid.direction': 'Direction',
  'lid.balanceAfter': 'Balance (after)',
  'lid.source': 'Source',
  'lid.sourceRef': '{table} #{id}',
  'lid.reversal': 'Reversal',
  'lid.reversed': 'Reversed',
  'lid.dir.earn': 'Earned',
  'lid.dir.redeem': 'Spent',
  'lid.dir.adjust': 'Adjustment',
  'lid.dir.expire': 'Expired',
  'lid.redemptions': 'Redemptions',
  'lid.redemptionsEmpty': 'This installer has not requested a reward yet',
  'lid.reconOk': 'Balance matches the ledger: {balance} = {ledger}',
  'lid.reconFailedTitle': 'BALANCE DOES NOT MATCH THE LEDGER',
  'lid.reconNumbers': 'Balance {balance}, ledger total {ledger}, difference {diff} points',
  'lid.reconFailedBody': 'This is not a DISPLAY error, it is a data error. The balance you see is a fast copy, while the truth is the movement history; if the two have drifted apart, both the balance shown to the installer and the liability report are wrong. Until the cause is found, do not approve this installer’s redemptions, and enter the correction as a separate corrective movement, not by editing the balance by hand.',
  'lfr.title': 'Review queue',
  'lfr.description': 'REJECTED scan attempts. Fraud patterns are visible exactly here — not in successful scans.',
  'lfr.days': 'Window, days',
  'lfr.minAttempts': 'Signal threshold',
  'lfr.minAttemptsHint': 'Fewer attempts do not enter the queue (2…1000).',
  'lfr.limit': 'Row limit',
  'lfr.window': 'Last {days} days · threshold {min} attempts',
  'lfr.summary': 'Rejection reasons',
  'lfr.summaryTotal': 'Total rejections',
  'lfr.reason.not_found': 'Code not found',
  'lfr.reason.already_scanned': 'Already scanned',
  'lfr.reason.not_activated': 'Not activated',
  'lfr.reason.void': 'Void code',
  'lfr.reason.installer_blocked': 'Installer blocked',
  'lfr.reason.rate_limited': 'Rate limit exceeded',
  'lfr.reason.no_points_rule': 'No point rule',
  'lfr.summaryMeaning': 'A high share of "Code not found" means codes are being GUESSED. The share of "No point rule", on the other hand, is not fraud but a CONFIGURATION error: an honest installer gets no points, and the cause is on the point rules screen.',
  'lfr.byInstaller': 'By installer',
  'lfr.byInstallerMeaning': 'Many rejections from a single account. A high share of "Code not found" means they are GUESSING codes: an honest installer does not make 200 mistakes, even when mistyping.',
  'lfr.byCode': 'By code',
  'lfr.byCodeMeaning': 'One code submitted many times. Every box code is UNIQUE, so if one code arrives from many ACCOUNTS it has been SHARED: a photo was posted in a chat or the sticker was peeled off.',
  'lfr.byIp': 'By IP address',
  'lfr.byIpMeaning': 'Many ACCOUNTS from one address. Opening dozens of accounts on one phone and burning each one\'s per-minute limit separately is the simplest way around the cap (an "account farm").',
  'lfr.recent': 'Latest attempts',
  'lfr.recentMeaning': 'Raw view, no aggregation. An investigation always starts with the question "what exactly did this person do?", and that cannot be reconstructed from summary tables.',
  'lfr.attempts': 'Attempts',
  'lfr.distinctCodes': 'Distinct codes',
  'lfr.distinctInstallers': 'Distinct installers',
  'lfr.lastAt': 'Last attempt',
  'lfr.reasons': 'Reasons',
  'lfr.code': 'Code',
  'lfr.ip': 'IP',
  'lfr.installer': 'Installer',
  'lfr.notFoundShare': 'Not found',
  'lfr.signal': 'Signal',
  'lfr.signal.guessing': 'Code guessing',
  'lfr.signal.shared': 'Shared code',
  'lfr.signal.farming': 'Account farm',
  'lfr.unknownInstaller': 'Not registered',
  'lfr.empty': 'No signals for this window and threshold',
  'lfr.emptyHint': 'Widen the window or lower the threshold.',
  'lfr.loadError': 'Could not load the review queue',
  'lfr.blockFromHere': 'Blocking an installer is done on the "Installers" screen.',
  'lfr.reverseTitle': 'Reverse scan',
  'lfr.reverseWhy': 'Revokes the granted points with a reversing entry. The code status DOES NOT CHANGE — it is the EVIDENCE that points were granted and is needed for the investigation. BLOCKING THE INSTALLER ALONE is not enough: a block stops scanning, but the points already earned remain and will be exchanged for a reward.',
  'lfr.reverseSearch': 'Find a scan by code',
  'lfr.reverseSearchPlaceholder': 'Full code or part of it',
  'lfr.reverseSearchHint': 'The search also works on a substring — a few characters from the sticker tail are enough. The list contains only scans that GRANTED POINTS: rejected attempts are in the tables above.',
  'lfr.reverseSearchShort': 'Enter at least {min} characters',
  'lfr.reverseSearchError': 'Could not search scans',
  'lfr.reverseNoScans': 'No point-granting scan found for this code',
  'lfr.reverseSelect': 'Select',
  'lfr.reverseAlready': 'Reversed',
  'lfr.reverseSelected': '{code} — {points} points, installer: {installer}. The points will be revoked with a reversing entry.',
  'lfr.scannedAt': 'Scanned',
  'lfr.reverseReason': 'Reversal reason',
  'lfr.reverseReasonRequired': 'The reason must be at least 3 characters long',
  'lfr.reverseSubmit': 'Revoke points',
  'lfr.reverseDone': '{code}: {points} points revoked. New balance of installer #{installer} — {balance} points.',
  'lfr.reverseNoPermission': 'You do not have permission to reverse a scan — it is the SAME right as blocking an installer: both are parts of one disciplinary measure. Ask your manager if you need it.',
  'lfr.reverseExceeds': 'Not enough points — the installer has ALREADY spent them on a reward. This is not a technical error: the company took the loss, and a partial reversal would HIDE it. A separate decision on the reward is required.',
  'nav.goodsReceipts': 'Goods receipts',
  'nav.supplierInvoices': 'Supplier invoices',
  'nav.import': 'Upload from file',
  'nav.roles': 'Roles',
  'nav.systemSettings': 'System settings',
  'nav.organization': 'Organization structure',
  'nav.group.loyalty': 'Installer program',
  'nav.loyaltyStatus': 'Program status',
  'nav.loyaltyPointRules': 'Point rules',
  'nav.loyaltyQrBatches': 'QR batches',
  'nav.loyaltyRewards': 'Reward catalog',
  'nav.loyaltyRedemptions': 'Redemptions',
  'nav.loyaltyInstallers': 'Installers',
  'nav.loyaltyFraud': 'Review queue',
  'nav.dealers': 'Dealers',
  'nav.bonusAccounts': 'Bonus accounts',
  'nav.bonusLedger': 'Bonus ledger',
  'nav.deliveries': 'Deliveries',
  'nav.reportAgentActivity': 'Sales agent activity',
  'ret.title': 'Returns',
  'ret.quarantineTitle': 'Goods in quarantine',
  'ret.description': 'Goods returned by a customer: receipt, inspection and disposition. Goods requiring inspection go to the QUARANTINE warehouse and are not put on sale.',
  'ret.new': 'New return',
  'ret.empty': 'No return documents',
  'ret.emptyHint': 'When a customer returns goods, a document opens here.',
  'ret.docNo': 'Document',
  'ret.date': 'Date',
  'ret.customer': 'Customer',
  'ret.invoice': 'Invoice',
  'ret.warehouse': 'Warehouse',
  'ret.quarantineWarehouse': 'Quarantine warehouse',
  'ret.reason': 'Reason',
  'ret.settlement': 'Settlement',
  'ret.total': 'Amount',
  'ret.status': 'Status',
  'ret.lineCount': 'Lines',
  'ret.qcRequired': 'Inspection required',
  'ret.qcRequiredYes': 'Goes to quarantine',
  'ret.qcRequiredNo': 'Straight to the main warehouse',
  'ret.qcRequiredHint': 'Default value based on the reason. If you change it, where the goods end up changes too.',
  'ret.filterStatus': 'Status',
  'ret.filterReason': 'Reason',
  'ret.filterAll': 'All',
  'ret.searchPlaceholder': 'Document number or customer name',
  'ret.status.draft': 'Draft',
  'ret.status.approved': 'Approved',
  'ret.status.received': 'Received',
  'ret.status.inspected': 'Inspected',
  'ret.status.settled': 'Settled',
  'ret.status.cancelled': 'Cancelled',
  'ret.reason.defect': 'Defect',
  'ret.reason.damaged': 'Damaged',
  'ret.reason.warranty': 'Warranty',
  'ret.reason.wrong_item': 'Wrong item',
  'ret.reason.customer_change': 'Customer changed their mind',
  'ret.reason.other': 'Other',
  'ret.settlement.credit_note': 'Credit note',
  'ret.settlement.refund': 'Refund',
  'ret.settlement.replacement': 'Replacement',
  'ret.qc.pass': 'Pass',
  'ret.qc.fail': 'Fail',
  'ret.qc.conditional': 'Conditional pass',
  'ret.qc.pending': 'Not inspected',
  'ret.disp.resale': 'Back to the shelf',
  'ret.disp.repair': 'To repair',
  'ret.disp.replacement': 'To be replaced',
  'ret.disp.supplier_claim': 'Claim to the factory',
  'ret.disp.quarantine': 'No decision',
  'ret.disp.scrap': 'Scrap',
  'ret.disp.resaleHint': 'Transferred from quarantine to the main warehouse and sold again. Once done, the warehouse stock changes.',
  'ret.disp.repairHint': 'Stays in quarantine until the installer repairs it — no stock movement.',
  'ret.disp.replacementHint': 'The customer gets a new one, the old one stays with us in quarantine — no stock movement.',
  'ret.disp.supplier_claimHint': 'EVIDENCE for the claim to the factory. It is not written off: otherwise there would be nothing behind the money being claimed back.',
  'ret.disp.quarantineHint': 'No decision has been made yet — the goods wait in quarantine.',
  'ret.disp.scrapHint': 'It is written off and this CANNOT BE UNDONE. Finance approval is required — ask the finance officer.',
  'ret.defect.burnt': 'Burnt out / does not light',
  'ret.defect.not_working': 'Does not work at all',
  'ret.defect.low_output': 'Low brightness',
  'ret.defect.flicker': 'Flickers',
  'ret.defect.physical_damage': 'Housing damaged',
  'ret.defect.packaging_damage': 'Packaging damaged only',
  'ret.defect.wrong_spec': 'Specification does not match',
  'ret.defect.incomplete': 'Incomplete set',
  'ret.defect.other': 'Other (note required)',
  'ret.detail.approve': 'Approve',
  'ret.detail.receive': 'Receive goods',
  'ret.detail.dispose': 'Execute disposition',
  'ret.detail.settle': 'Settle the money side',
  'ret.detail.cancel': 'Cancel',
  'ret.detail.approveHint': 'Once approved the document cannot be edited — the storekeeper relies on it while waiting for the goods.',
  'ret.detail.receiveHint': 'The goods enter the WAREHOUSE: to quarantine if inspection is required, otherwise to the main warehouse. This changes the warehouse stock.',
  'ret.detail.disposeHint': 'The decision taken for each line IS EXECUTED: "back to the shelf" means a transfer, "scrap" means a write-off; in all other cases the goods stay in quarantine.',
  'ret.detail.settleHint': 'The document is closed. Double-entry accounting is not in the system yet — the finance department issues the credit note or the refund MANUALLY.',
  'ret.detail.cancelReason': 'Cancellation reason',
  'ret.detail.cancelReasonHint': 'The reason stays in the document and in the audit log',
  'ret.detail.pendingDisposition': 'Lines without a disposition: {count}',
  'ret.detail.settledAt': 'Settled',
  'ret.detail.approvedAt': 'Approved',
  'ret.detail.noPermission': 'You do not have permission for this action',
  'ret.line.sku': 'SKU',
  'ret.line.name': 'Name',
  'ret.line.qty': 'Quantity',
  'ret.line.price': 'Price',
  'ret.line.amount': 'Amount',
  'ret.line.cost': 'Cost',
  'ret.line.qc': 'Inspection',
  'ret.line.defect': 'Defect',
  'ret.line.disposition': 'Disposition',
  'ret.line.state': 'Goods',
  'ret.line.inStock': 'In warehouse',
  'ret.line.notReceived': 'Not received',
  'ret.line.done': 'Done',
  'ret.line.saveQc': 'Save inspection',
  'ret.line.qcTitle': '{sku} — inspection result',
  'ret.line.notes': 'Note',
  'ret.line.add': 'Add line',
  'ret.line.remove': 'Remove',
  'ret.line.empty': 'Add a line',
  'ret.form.title': 'New return document',
  'ret.form.hint': 'The document is created as a DRAFT: the warehouse is not touched yet. The goods enter the warehouse only at the "receive" step.',
  'ret.form.customer': 'Customer',
  'ret.form.warehouse': 'Which warehouse it returns to',
  'ret.form.warehouseHint': 'The warehouse the goods will ULTIMATELY belong to. If inspection is required, they go to quarantine first.',
  'ret.form.submit': 'Create return',
  'ret.form.priceRequired': 'If no invoice is given, the price is entered manually — the refundable amount is calculated from it.',
  'ret.qr.description': 'Goods sitting in quarantine whose disposition has not been executed yet. Lines waiting for the factory\'s reply are here too — they are the most easily forgotten part.',
  'ret.qr.empty': 'Quarantine is empty',
  'ret.qr.emptyHint': 'Goods appear here when a return requiring inspection is received.',
  'ret.qr.days': 'In quarantine, days',
  'ret.qr.daysLong': 'For {days} days',
  'ret.qr.minDays': 'Minimum days',
  'ret.qr.open': 'Open document',
  'ret.qr.searchPlaceholder': 'Document, customer, SKU or name',
  'supplier.description': 'Factories and suppliers. Lead time is the key parameter of the reorder formula: with a 120–150 day cycle the order must be placed a quarter of a year before the goods run out.',
  'supplier.new': 'New supplier',
  'supplier.code': 'Code',
  'supplier.name': 'Name',
  'supplier.country': 'Country',
  'supplier.address': 'Address',
  'supplier.phone': 'Phone',
  'supplier.email': 'Email',
  'supplier.taxId': 'Tax ID',
  'supplier.currency': 'Currency',
  'supplier.paymentTerm': 'Payment term',
  'supplier.leadTime': 'Lead time',
  'supplier.leadTimeHint': 'Days from the order to the arrival of the goods. The reorder calculation relies on this number.',
  'supplier.days': '{days} days',
  'supplier.status': 'Status',
  'supplier.active': 'Active',
  'supplier.archived': 'Archived',
  'supplier.contactOnlyNote': 'You can see the supplier\'s name and contacts. Currency, payment term, lead time and prices are not shown — they are commercial information and require a different permission.',
  'supplier.filterSearch': 'Search',
  'supplier.filterSearchHint': 'Code or name',
  'supplier.filterCountry': 'Country code',
  'supplier.countryPlaceholder': 'CN',
  'supplier.filterStatus': 'Status',
  'supplier.filterStatusAll': 'All',
  'supplier.empty': 'No suppliers found',
  'supplier.emptyHint': 'Change the filter or add a new supplier.',
  'supplier.contacts': 'Contacts',
  'supplier.noContacts': 'No contacts entered',
  'supplier.primaryContact': 'Primary',
  'supplier.products': 'Linked products',
  'supplier.productsHint': 'The factory\'s own SKU, minimum order quantity (MOQ) and the last agreed price. These lines are used when a purchase order is created.',
  'supplier.noProducts': 'No products linked',
  'supplier.supplierSku': 'Factory SKU',
  'supplier.productRef': 'Catalog ID',
  'supplier.productRefValue': '#{id}',
  'supplier.moq': 'MOQ',
  'supplier.moqHint': 'The smallest batch the factory accepts',
  'supplier.lastPrice': 'Last price',
  'supplier.lastPriceDate': 'Price date',
  'supplier.defectRate': 'Defect rate, %',
  'supplier.formCreate': 'New supplier',
  'supplier.formEdit': 'Edit supplier',
  'invoice.description': 'Invoices issued to customers. Overdue ones with an outstanding balance are marked in red.',
  'invoice.docNo': 'Number',
  'invoice.customer': 'Customer',
  'invoice.date': 'Date',
  'invoice.dueDate': 'Due date',
  'invoice.total': 'Amount (incl. VAT)',
  'invoice.net': 'Amount excl. tax',
  'invoice.vat': 'VAT ({rate})',
  'invoice.vatShort': 'VAT',
  'invoice.vatBase': 'VAT (USD)',
  'invoice.lineVatRate': 'VAT %',
  'invoice.lineVat': 'VAT',
  'invoice.paid': 'Paid',
  'invoice.credited': 'Credited',
  'invoice.balance': 'Balance',
  'invoice.statusLabel': 'Status',
  'invoice.overdueDays': '{days} days overdue',
  'invoice.fxRate': 'Document FX rate',
  'invoice.totalBase': 'Amount (USD)',
  'invoice.notes': 'Notes',
  'invoice.status.draft': 'Draft',
  'invoice.status.issued': 'Issued',
  'invoice.status.partially_paid': 'Partially paid',
  'invoice.status.paid': 'Paid',
  'invoice.status.cancelled': 'Cancelled',
  'invoice.filterSearch': 'Search',
  'invoice.filterSearchHint': 'Invoice number or customer',
  'invoice.filterStatus': 'Status',
  'invoice.filterStatusAll': 'All',
  'print.action': 'Print',
  'print.hint': 'The official form is printed in Russian',
  'print.invoice': 'Print invoice',
  'print.deliveryNote': 'Print delivery note',
  'print.cashReceipt': 'Print cash voucher',
  'print.priceList': 'Print price list',
  'print.barcodeLabel': 'Print label',
  'invoice.filterFrom': 'Date from',
  'invoice.filterTo': 'Date to',
  'invoice.filterOpenOnly': 'With outstanding balance only',
  'invoice.filterOverdue': 'Overdue only',
  'invoice.empty': 'No invoices found',
  'invoice.emptyHint': 'Change the filter. An invoice is created from a posted delivery note.',
  'invoice.lines': 'Lines',
  'invoice.linesHint': 'Lines are built from the POSTED delivery note — that is, they show the goods that actually left the warehouse, not the plan from the order.',
  'invoice.lineSku': 'SKU',
  'invoice.lineName': 'Name',
  'invoice.lineQty': 'Quantity',
  'invoice.linePrice': 'Price',
  'invoice.lineAmount': 'Amount',
  'invoice.fxGapTitle': 'Payment received, but debt remains',
  'invoice.fxGapBody': 'Invoice {total}, paid {paid}, balance {balance}.',
  'invoice.fxGapWhy': 'The usual reason is an FX difference: the customer pays the agreed sum in soum in full, but it is converted to USD at the rate of the payment day and does not fully close the debt. The exact calculation is shown on the payment card.',
  'invoice.fxGapUnexplained': 'Attention: the paid and remaining amounts do not add up to the invoice total. A return or a write-off may have been applied to the document — check payments and returns.',
  'invoice.equationHint': 'Paid, credited and balance add up to the invoice total.',
  'invoice.equationTotal': 'Total',
  'invoice.equationBrokenTitle': 'The figures do not add up',
  'invoice.equationBroken':
    'Paid, credited and balance do not add up to the invoice total. This is a data fault — show the document to accounting, do not fix it yourself.',
  'invoice.creditsHidden':
    'Part of this invoice was closed by a credit note. Which document closed it is not shown to you — the amount itself is above.',
  'invoice.customerPayments': 'Customer payments',
  'invoice.customerPaymentsHint': 'These are ALL of the CUSTOMER\'s payments, not only those for this invoice: the API does not link a payment to an invoice. Which payment closed which invoice is shown on the payment card.',
  'invoice.noPayments': 'No payments',
  'payment.description': 'Money received from a customer. A payment is first created as a draft, then posted — at that moment the money enters the cash account and the debt is closed.',
  'payment.new': 'New payment',
  'payment.docNo': 'Number',
  'payment.date': 'Date',
  'payment.customer': 'Customer',
  'payment.amount': 'Amount',
  'payment.currency': 'Currency',
  'payment.amountBase': 'In USD',
  'payment.methodLabel': 'Method',
  'payment.statusLabel': 'Status',
  'payment.reference': 'Document number / note',
  'payment.cashAccount': 'Cash account / bank account',
  'payment.notes': 'Notes',
  'payment.status.draft': 'Draft',
  'payment.status.posted': 'Posted',
  'payment.status.cancelled': 'Cancelled',
  'payment.method.cash': 'Cash',
  'payment.method.bank_transfer': 'Bank transfer',
  'payment.method.card': 'Card',
  'payment.method.other': 'Other',
  'payment.filterSearch': 'Search',
  'payment.filterSearchHint': 'Payment number or customer',
  'payment.filterStatus': 'Status',
  'payment.filterStatusAll': 'All',
  'payment.filterFrom': 'Date from',
  'payment.filterTo': 'Date to',
  'payment.filterUnallocated': 'Unallocated only (advance)',
  'payment.empty': 'No payments found',
  'payment.emptyHint': 'Change the filter or enter a new payment.',
  'payment.emptyHintReadOnly': 'Change the filter. Payments are entered by finance — you see the FACT of the payment.',
  'payment.post': 'Post',
  'payment.allocate': 'Allocate to debt',
  'payment.autoAllocate': 'Allocate to debt automatically',
  'payment.autoAllocateHint': 'Closing starts from the invoice with the earliest due date. If switched off, the money stays as an advance and is allocated manually later.',
  'payment.chainTitle': 'Calculation chain',
  'payment.chainReceived': 'Amount received',
  'payment.chainRate': 'FX rate',
  'payment.chainRateHint': 'Locked into the document — it does not change afterwards',
  'payment.chainBase': 'USD equivalent',
  'payment.chainBaseHint': 'The debt is reduced by this amount',
  'payment.chainRemaining': 'Customer\'s remaining debt',
  'payment.chainWhyFx': 'The debt is in USD, but the payment arrived in another currency. The amount was converted to USD at the rate of the payment day and did not match the debt exactly — the remainder stays as debt. The customer may well have paid the agreed sum in full: the difference is in the rate, not in the payment.',
  'payment.chainWhyPartial': 'The payment did not close the debt in full — the remainder will be closed by the next payment.',
  'payment.unallocatedNote': 'Unallocated part: {amount}. This money is a customer advance — it has arrived but has not yet been applied to any invoice.',
  'payment.allocations': 'Allocation to debt',
  'payment.allocationsHint': 'Which invoice this payment closed and by how much. The "before" and "after" columns are read together: the difference is the closed part, "after" is the remaining debt.',
  'payment.notPostedYet': 'The payment has not been posted yet — the debt is not closed.',
  'payment.noAllocations': 'Not allocated to any invoice (advance).',
  'payment.allocInvoice': 'Invoice',
  'payment.allocDueDate': 'Due date',
  'payment.allocAmount': 'Closed',
  'payment.allocAmountBase': 'Closed (USD)',
  'payment.allocBefore': 'Debt — before',
  'payment.allocAfter': 'Debt — after',
  'payment.allocFx': 'FX difference',
  'payment.writtenOff': 'The remaining {amount} was closed as an FX difference — it is below the threshold and will not be collected.',
  'payment.allocFxHint': 'Zero does not mean "no difference": if the customer\'s policy is "payment day", the difference is not recorded separately and stays in the balance.',
  'payment.formTitle': 'New payment',
  'payment.formHint': 'The payment is created as a DRAFT: the money does not enter the cash account yet and the debt is not closed. The second step is "Post".',
  'payment.formSubmit': 'Create draft',
  'payment.manualRate': 'Manual FX rate',
  'payment.manualRatePlaceholder': 'daily rate',
  'payment.manualRateHint': 'If left empty, the daily rate is used. If the bank\'s actual rate differs from the daily rate, enter the bank rate — the money arrived at that rate. The rate is locked into the document and does not change afterwards.',

  'payment.reverseAction': 'Reverse',
  'payment.reverseTitle': 'Reverse {docNo}',
  'payment.reverseHint':
    'The payment is NOT deleted — a reversing (storno) entry is created and both stay in the history. The money returns to the cash account, the balances of the closed invoices are restored, and the mirror of the original ledger entry is written.',
  'payment.reverseReason': 'Reason for the reversal',
  'payment.reverseReasonPlaceholder': 'For example: wrong customer selected; the bank transfer bounced',
  'payment.reverseReasonHint':
    'Write down what actually went wrong — at least {min} characters. A month from now, the answer «mistake» explains nothing; the reason stays in the audit trail.',
  'payment.reverseSubmit': 'Yes, reverse it',
  'payment.reverseDone': 'Reversed',
  'payment.reverseDoneHint':
    '{docNo} was cancelled and a storno entry was created in its place. The original document stays in the history — the cash report printed yesterday still reads the same today.',
  'payment.reverseReturned': 'Returned to the cash account',
  'payment.reverseCashAfter': 'Cash balance',
  'payment.reverseRestoredCount': 'Documents restored',
  'payment.reverseRestoredDoc': 'Document',
  'payment.reverseRestoredAmount': 'Balance restored',

  'supplierPay.title': 'Pay a supplier — who we owe',
  'supplierPay.description':
    'What we owe the factory and how we pay it. The money on this screen LEAVES the company: it is withdrawn from a cash or bank account and closes the supplier invoices. Click a row to open that factory\'s open invoices.',
  'supplierPay.tileOutstanding': 'Total open debt',
  'supplierPay.tileOutstandingHint': 'Across {count} suppliers, in USD',
  'supplierPay.tileOverdue': 'Overdue',
  'supplierPay.tileOverdueHint': 'The amount that has to be paid today',
  'supplierPay.tileAdvance': 'Open advances',
  'supplierPay.tileAdvanceHint': 'Money paid but not yet allocated to an invoice',
  'supplierPay.tileInvoices': 'Open invoices',
  'supplierPay.tileInvoicesHint': 'As of {asOf}',
  'supplierPay.filterSearch': 'Search',
  'supplierPay.filterSearchHint': 'Invoice number or factory name',
  'supplierPay.filterOverdue': 'Overdue only',
  'supplierPay.colCode': 'Code',
  'supplierPay.colSupplier': 'Supplier',
  'supplierPay.colOutstanding': 'Open debt',
  'supplierPay.colOverdue': 'Overdue',
  'supplierPay.colAdvance': 'Advance',
  'supplierPay.colOldestDue': 'Oldest due date',
  'supplierPay.colInvoiceCount': 'Invoices',
  'supplierPay.empty': 'Every invoice is closed',
  'supplierPay.emptyHint':
    'No supplier has an open debt. A new invoice appears here as soon as it is received in the procurement module.',
  'supplierPay.emptyFiltered': 'No debt matches the filter',
  'supplierPay.emptyFilteredHint':
    'Change the search or the «overdue only» filter — there is debt, it simply falls outside this slice.',
  'supplierPay.noInvoices': 'No open invoices',
  'supplierPay.noInvoicesHint':
    'This factory has been paid, but the invoice has not arrived yet — so the money is sitting as an ADVANCE. In the import cycle this is normal: the 30% deposit is paid before the invoice.',
  'supplierPay.invoices': 'Open invoices',
  'supplierPay.invoicesHint':
    'Oldest due date first. Automatic allocation follows exactly the same order — invoices without a due date come last.',
  'supplierPay.invDoc': 'Invoice',
  'supplierPay.invDate': 'Date',
  'supplierPay.invDue': 'Due',
  'supplierPay.invTotal': 'Total',
  'supplierPay.invPaid': 'Paid',
  'supplierPay.invBalance': 'Balance',
  'supplierPay.invBalanceBase': 'Balance (USD)',
  'supplierPay.invOverdue': '{days} days late',
  'supplierPay.invNoDue': 'no due date',
  'supplierPay.pay': 'Make a payment',
  'supplierPay.formTitle': 'Payment to the factory',
  'supplierPay.formHint':
    'The document is entered AFTER the bank transfer has been executed — that is why there is no draft stage. The next step shows which account the money leaves and how much, for confirmation.',
  'supplierPay.account': 'Cash / bank account',
  'supplierPay.accountPick': 'Choose an account',
  'supplierPay.amount': 'Amount',
  'supplierPay.rate': 'Bank rate',
  'supplierPay.rateHint':
    'The bank\'s actual rate FOR THAT DAY — not the daily reference rate. The money is withdrawn from the som account and reaches the factory in another currency, so the conversion really happens and on a large transfer the gap is worth hundreds of dollars. The rate is locked into the document.',
  'supplierPay.date': 'Payment date',
  'supplierPay.method': 'Method',
  'supplierPay.reference': 'Payment order',
  'supplierPay.referenceHint': 'SWIFT or payment order number',
  'supplierPay.notes': 'Note',
  'supplierPay.allocTitle': 'Which invoices to close',
  'supplierPay.allocAuto': 'Automatically — oldest due date first',
  'supplierPay.allocAutoHint':
    'The oldest debt is the most dangerous one: the factory stops the shipment. Invoices without a due date come last.',
  'supplierPay.allocPick': 'I will choose',
  'supplierPay.allocPickHint':
    'Name the exact invoice — for example when a container release depends on that one.',
  'supplierPay.allocAdvance': 'Advance — do not allocate to any invoice',
  'supplierPay.allocAdvanceHint':
    'The case where the factory asks for a deposit before writing the invoice. Forcing the money onto some invoice would make the debt report lie.',
  'supplierPay.currencyUnsupported':
    'This account is held in {currency}, which is not among the system\'s payment currencies. Choose another account.',
  'supplierPay.insufficient': 'Not enough money in the account',
  'supplierPay.insufficientHint':
    'Account «{code}» holds {balance} and the payment is {amount}. Top the account up first (an inter-account transfer) or correct the amount.',
  'supplierPay.continue': 'Continue',
  'supplierPay.confirmTitle': 'Money LEAVES the cash account — please confirm',
  'supplierPay.confirmHint':
    'There is no undo button for this action: it changes the cash balance, the factory debt and the ledger all at once. Check the three figures below.',
  'supplierPay.confirmFrom': 'From which account',
  'supplierPay.confirmAmount': 'How much leaves',
  'supplierPay.confirmRateHint': 'Locked into the document',
  'supplierPay.confirmBalance': 'Balance',
  'supplierPay.confirmBalanceHint': 'Now → after the payment',
  'supplierPay.confirmAuto': 'Invoices are closed automatically, oldest due date first.',
  'supplierPay.confirmAdvance':
    'The payment is not allocated to any invoice — it stays as an advance.',
  'supplierPay.confirmPicked': 'Invoices to be closed: {docs}',
  'supplierPay.confirmSubmit': 'I confirm — release the money',
  'supplierPay.resultDone': 'Payment recorded',
  'supplierPay.resultPaid': 'Paid',
  'supplierPay.resultBase': 'USD equivalent',
  'supplierPay.resultAdvance': 'Left as an advance',
  'supplierPay.resultCash': 'Balance of «{code}»',
  'supplierPay.resultSupplierBalance': 'Debt still owed to the factory',
  'supplierPay.allocInvoice': 'Invoice',
  'supplierPay.allocClosed': 'Closed',
  'supplierPay.allocSpent': 'Spent',
  'supplierPay.allocBefore': 'Balance — before',
  'supplierPay.allocAfter': 'Balance — after',
  'supplierPay.allocFx': 'FX difference',
  'supplierPay.allocFxHint':
    'Positive means a GAIN: we wrote off more of the liability than the money we spent. On a customer payment the very same equation is a LOSS.',
  'ar.title': 'Accounts receivable',
  'ar.description': 'Who owes how much and behind which invoices. Click a row to open the customer\'s open invoices.',
  'ar.code': 'Code',
  'ar.customer': 'Customer',
  'ar.total': 'Total debt',
  'ar.overdue': 'Overdue',
  'ar.notDue': 'Not due',
  'ar.d0_30': '0–30 days',
  'ar.d31_60': '31–60 days',
  'ar.d61_90': '61–90 days',
  'ar.d90plus': '90+ days',
  'ar.oldestDue': 'Oldest due date',
  'ar.invoiceCount': 'Invoices',
  'ar.invoiceCountShort': '{count} documents',
  'ar.filterOverdue': 'Overdue only',
  'ar.tileTotal': 'Total debt',
  'ar.tileTotalHint': 'Across {count} customers',
  'ar.tileOverdue': 'Overdue',
  'ar.tileOverdueHint': 'The amount to be collected today',
  'ar.tile90': 'Over 90 days',
  'ar.tile90Hint': 'This is not collection, it is likely loss',
  'ar.empty': 'No customers with debt',
  'ar.emptyHint': 'All invoices are closed or the filter is too narrow.',
  'ar.blocked': 'Blocked',
  'ar.overLimit': 'Over limit',
  'ar.balance': 'Debt',
  'ar.advance': 'Advance (unallocated payment)',
  'ar.net': 'Net position',
  'ar.netHint': 'Debt − advance. If negative, we owe the customer.',
  'ar.creditLimit': 'Credit limit',
  'ar.availableCredit': 'Available credit',
  'ar.overLimitHint': 'The limit is already exceeded — a new order requires approval.',
  'ar.paymentTerm': 'Payment term',
  'ar.days': '{days} days',
  'ar.fxPolicy': 'FX policy',
  'ar.fxPolicyPayment': 'Rate on the payment day',
  'ar.fxPolicySale': 'Rate on the sale day',
  'ar.fxPolicyHint': 'Defines which day\'s rate the debt is measured at — this is where the FX difference comes from.',
  'ar.buckets': 'Aging buckets',
  'ar.openInvoices': 'Open invoices',
  'ar.openInvoicesHint': 'Starting from the earliest due date. Payments are allocated in the same order.',
  'ar.noOpenInvoices': 'No open invoices',
  'supplierInvoice.title': 'Supplier invoices',
  'supplierInvoice.description': 'The invoice issued by the factory. On recognition, the "goods received, invoice not received" (GRNI) liability moves into supplier debt.',
  'supplierInvoice.new': 'New invoice',
  'supplierInvoice.save': 'Save as draft',
  'supplierInvoice.docNo': 'Invoice number',
  'supplierInvoice.docNoPlaceholder': 'For example: SZ-2026-0417',
  'supplierInvoice.docNoHint': 'The number is assigned by the FACTORY — the system does not issue its own. This exact number appears on the bank transfer and on the customs document.',
  'supplierInvoice.supplier': 'Supplier',
  'supplierInvoice.date': 'Invoice date',
  'supplierInvoice.dateHint': 'The FX rate is recorded AS OF THIS date and does not change afterwards.',
  'supplierInvoice.dueDate': 'Due date',
  'supplierInvoice.currency': 'Currency',
  'supplierInvoice.total': 'Total (incl. VAT)',
  'supplierInvoice.totalBase': 'Total (USD)',
  'supplierInvoice.net': 'Net of tax',
  'supplierInvoice.vat': 'VAT',
  'supplierInvoice.vatRate': 'VAT rate, %',
  'supplierInvoice.vatRateHint': 'The tax is extracted FROM the "Total", not added on top. If left empty — 0%.',
  'supplierInvoice.grossHint': 'In the "Total" field enter the amount from the bottom of the factory invoice — INCLUDING VAT. The bank transfer is made for exactly the same figure.',
  'supplierInvoice.previewHint': 'Preliminary calculation. The exact figures of the document are written by the server.',
  'supplierInvoice.purchaseOrder': 'Purchase order',
  'supplierInvoice.receipt': 'Goods receipt',
  'supplierInvoice.receiptHint': 'MANDATORY for recognition: GRNI is closed against the goods receipt. If the goods have not arrived yet, leave the document as a draft.',
  'supplierInvoice.noLink': 'Not linked',
  'supplierInvoice.notes': 'Notes',
  'supplier.kind': 'Counterparty type',
  'supplier.kind.goods': 'Factory / goods',
  'supplier.kind.logistics': 'Logistics / forwarder',
  'supplier.kind.service': 'Service',
  'supplier.kindAll': 'All types',
  'supplier.kindHint':
    'The type separates reports and pickers: a factory invoice closes against the goods receipt, a logistics invoice against the container.',
  'si.kind.factory': 'Factory invoice (by goods receipt)',
  'si.kind.logistics': 'Logistics invoice (by container)',
  'si.kindTitle': 'Document type',
  'si.kindHint':
    'The two close DIFFERENT ledger accounts, so a single document is only ever one of them.',
  'si.shipment': 'Container',
  'si.shipmentSelect': 'Select a container',
  'si.shipmentRequired': 'A container is required for a logistics invoice',
  'si.costs': 'Costs covered',
  'si.costsHint': 'Estimated lines cannot be selected — enter the document amount first',
  'si.costsEmpty': 'This container has no costs that can be attached',
  'si.costsSelected': '{count} lines selected · {amount}',
  'si.costsRequired': 'Select at least one cost line',
  'si.dueFromTerms': 'Contract terms: {days} days',
  'si.dueOverride': 'A different due date for this document',
  'si.dueNoTerms': 'The contract has no term — enter the date manually',
  'si.error.estimateCost':
    'An estimated cost creates no debt — clear the "estimated" mark and recalculate the landed cost',
  'si.error.lcNotPosted':
    'The landed cost is not posted — the accrued liability is not in the ledger yet',
  'si.error.costTaken': 'Another invoice has already been recognized for this cost',
  'si.error.shapeConflict': 'One document cannot close both a goods receipt and a container',
  'si.copy': 'Copy',
  'si.copyHint':
    'The fields are copied from this document, while the number and the attached costs stay EMPTY — those belong to each document alone.',
  'si.copied': 'Copied — enter the number and save after checking',
  'si.docsTitle': 'Document files',
  'si.docsHint':
    'The forwarder invoice, bill of lading and customs papers are uploaded to the CONTAINER card — this invoice is bound to that container.',
  'si.docsOpen': 'Open the container card',
  'ap.logistics': 'Logistics ledger',
  'ap.kindNeedsSupplierView': 'Splitting by type requires permission to view counterparty data.',
  'supplierInvoice.statusLabel': 'Status',
  'supplierInvoice.status.draft': 'Draft',
  'supplierInvoice.status.received': 'Recognized',
  'supplierInvoice.status.cancelled': 'Cancelled',
  'supplierInvoice.receive': 'Recognize',
  'supplierInvoice.cancel': 'Cancel',
  'supplierInvoice.cancelPrompt': 'Reason for cancellation (at least 3 characters):',
  'supplierInvoice.filterStatus': 'Status',
  'supplierInvoice.filterStatusAll': 'All',
  'supplierInvoice.empty': 'No supplier invoices',
  'supplierInvoice.emptyHint': 'When the factory invoice arrives, enter it here. Nothing is written to the ledger until it is recognized.',
  'ap.title': 'Accounts payable',
  'ap.description': 'How much we owe the factories and which advances are outstanding. An advance is money that has gone out but has not yet turned into goods.',
  'ap.code': 'Code',
  'ap.supplier': 'Supplier',
  'ap.currency': 'Currency',
  'ap.openPoCount': 'Open orders',
  'ap.ordered': 'Ordered',
  'ap.paid': 'Paid',
  'ap.outstanding': 'Debt (by order)',
  'ap.invoiceOpen': 'Debt (by invoice)',
  'ap.notDue': 'Not due',
  'ap.d0_30': '0–30 days',
  'ap.d31_60': '31–60 days',
  'ap.d61_90': '61–90 days',
  'ap.d90plus': '90+ days',
  'ap.oldestDue': 'Oldest due date',
  'ap.openInvoiceCount': 'Open invoices',
  'ap.advance': 'Open advance',
  'ap.advanceAge': 'Advance age',
  'ap.oldestAdvance': 'Oldest advance',
  'ap.nearestExpected': 'Nearest expected arrival',
  'ap.paymentTerm': 'Payment terms',
  'ap.days': '{days} days',
  'ap.filterAdvances': 'With advances only',
  'ap.tileOutstanding': 'Total debt',
  'ap.tileOutstandingHint': 'Across {count} suppliers',
  'ap.tileInvoiceOpen': 'Debt by invoice',
  'ap.tileInvoiceOpenHint': 'The unpaid part of invoices issued by the factory and recognized by us. Same definition as the "Supplier debt" account in the ledger.',
  'ap.tileOverdue': 'Overdue',
  'ap.tileOverdueHint': 'Invoices whose due date has come and gone. Since a payment is not tied to a specific invoice, settlement starts from the oldest invoice.',
  'ap.tileAdvance': 'Open advance',
  'ap.tileAdvanceHint': 'Money paid that has not yet turned into goods',
  'ap.tileStale': 'Advances outstanding for over {days} days',
  'ap.tileStaleHint': 'The import cycle is complete but the advance is not closed — needs checking',
  'ap.empty': 'No open debt or advances',
  'ap.emptyHint': 'All purchase orders are closed or no open order has been created yet.',
  'fxRates.description': 'The daily rate is entered once a day and is shown at the top of the app. Sales are in USD, the cash account is in soum, purchases are in yuan — if the rate is wrong, every document of that day is calculated wrong.',
  'fxRates.frozenTitle': 'Changing the rate DOES NOT AFFECT old documents',
  'fxRates.frozenBody': 'When a document is created, the rate is recorded into it and frozen there. If you change the rate here, only SUBSEQUENT documents are calculated at the new rate — yesterday\'s invoices, payments and the profit of a closed period are not recalculated.',
  'fxRates.uzsLabel': '1 USD = ? soum',
  'fxRates.cnyLabel': '1 USD = ? ¥',
  'fxRates.missing': 'No rate entered at all',
  'fxRates.stale': 'Not today\'s',
  'fxRates.locked': 'Day closed',
  'fxRates.formTitle': 'Enter rate',
  'fxRates.currency': 'Currency',
  'fxRates.rate': 'FX rate',
  'fxRates.uzsPlaceholder': '12900',
  'fxRates.cnyPlaceholder': '7.25',
  'fxRates.rateDate': 'For which date',
  'fxRates.saved': '{currency}: {rate} — saved for {date}',
  'fxRates.formHint': 'Each currency is saved separately. The rate of a closed day cannot be changed. The change is written to the audit log: who changed it and when must be traceable.',
  'fxRates.historyTitle': 'Rate history',
  'fxRates.historyCurrency': 'Select currency',
  'fxRates.historySource': 'The history is built FROM THE AUDIT LOG: for each day the last rate of that day is shown, and corrections made during the day are in the full log.',
  'fxRates.historyNoPermission': 'Rate history comes from the audit log and requires a separate permission (view audit log). You do not have this permission, so the history is not shown — this does not mean there is no history.',
  'fxRates.historyEmpty': 'No rate changes for this currency were found in the log.',
  'fxRates.chartLabel': 'Daily movement of the {currency} rate',
  'fxRates.chartHint': 'The bars are measured from zero — so a change of a few percent is barely visible. The exact difference is in the "Change" column below; hover over a bar to see that day\'s rate.',
  'fxRates.change': 'Change',
  'fxRates.actor': 'Who',
  'fxRates.changedAt': 'When',
  'fxRates.openAudit': 'Open full log',
  'error.403': 'You do not have permission for this action',
  'error.404': 'Not found',
  'error.500': 'Server error',
  'error.pageNotFound': 'No such page',
  'error.screenFailed': 'Could not open the screen',
  'error.screenFailedHint': 'The network may have dropped or the app may have been updated. Try again, and if that does not help, reload the page.',
  'nav.group.accounting': 'Accounting',
  'nav.accJournals': 'Journal entries',
  'nav.accPeriods': 'Periods',
  'nav.accAccounts': 'Chart of accounts',
  'nav.accIncomeStatement': 'Profit and loss',
  'nav.accBalanceSheet': 'Balance sheet',
  'nav.accEquity': 'Equity',
  'acc.account.account': 'Account',
  'acc.account.code': 'Code',
  'acc.account.name': 'Name',
  'acc.account.type': 'Type',
  'acc.account.roles': 'Roles',
  'acc.account.contra': 'contra',
  'acc.account.group': 'group',
  'acc.account.inactive': 'inactive',
  'acc.account.debitSide': 'debit balance',
  'acc.account.creditSide': 'credit balance',
  'acc.type.asset': 'Asset',
  'acc.type.liability': 'Liability',
  'acc.type.equity': 'Equity',
  'acc.type.income': 'Income',
  'acc.type.expense': 'Expense',
  'acc.pnl.title': 'Profit and loss',
  'acc.pnl.description': 'A report built from the ledger: from revenue to net profit. Every line comes with the current period, the PREVIOUS period and the difference — a single period on its own means nothing.',
  'acc.pnl.line': 'Line item',
  'acc.pnl.current': 'Current period',
  'acc.pnl.previous': 'Previous period',
  'acc.pnl.previousShort': 'previous:',
  'acc.pnl.previousValue': 'previous: {value}',
  'acc.pnl.delta': 'Difference',
  'acc.pnl.trend': 'Trend',
  'acc.pnl.vsPrevious': 'compared with the previous period',
  'acc.pnl.comparedWith': 'Period compared: {from} — {to}',
  'acc.pnl.expenseMix': 'Operating expense breakdown',
  'acc.pnl.revenue': 'Revenue',
  'acc.pnl.returns': 'Returns',
  'acc.pnl.discounts': 'Discounts given',
  'acc.pnl.netRevenue': 'Net revenue',
  'acc.pnl.cogs': 'Cost of goods sold',
  'acc.pnl.grossProfit': 'GROSS PROFIT',
  'acc.pnl.operatingExpense': 'Operating expenses',
  'acc.pnl.operatingProfit': 'OPERATING PROFIT',
  'acc.pnl.fxResult': 'FX difference (gain − loss)',
  'acc.pnl.otherResult': 'Other income',
  'acc.pnl.netProfit': 'NET PROFIT',
  'acc.pnl.checkFailed': 'The report does not match the ledger',
  'acc.pnl.checkFailedDetail': 'Net profit in the report is {statement}, while the ledger (income − expense) gives {ledger}. Difference: {difference}. This means some account did not fall into a report group.',
  'acc.bs.title': 'Balance sheet',
  'acc.bs.description': 'The position as of a given date: assets, liabilities and equity. The equation is checked and the result is shown openly.',
  'acc.bs.equation': 'ASSETS = LIABILITIES + EQUITY',
  'acc.bs.balanced': 'The equation holds',
  'acc.bs.notBalanced': 'THE EQUATION IS BROKEN',
  'acc.bs.differenceIs': 'Difference: {value}.',
  'acc.bs.section': 'Section',
  'acc.bs.amount': 'Amount',
  'acc.bs.assets': 'ASSETS',
  'acc.bs.liabilities': 'LIABILITIES',
  'acc.bs.equity': 'EQUITY',
  'acc.bs.totalAssets': 'Total assets',
  'acc.bs.totalLiabilities': 'Total liabilities',
  'acc.bs.totalEquity': 'Total equity',
  'acc.bs.unclosedResult': 'Current year result (not closed)',
  'acc.bs.unclosedHint': 'Income {income} − expense {expense}. After the year is closed this line drops to zero and the amount moves to "Retained earnings".',
  'acc.equity.title': 'Statement of changes in equity',
  'acc.equity.description': 'The path from opening equity to closing equity: the period result, contributions and withdrawals.',
  'acc.equity.line': 'Line item',
  'acc.equity.amount': 'Amount',
  'acc.equity.opening': 'Opening equity',
  'acc.equity.closing': 'Closing equity',
  'acc.equity.ofAccounts': 'of which: equity accounts',
  'acc.equity.ofUnclosed': 'of which: unclosed result',
  'acc.equity.periodResult': 'Current period result (profit / loss)',
  'acc.equity.contributions': 'Additional contributions',
  'acc.equity.withdrawals': 'Withdrawals',
  'acc.equity.otherEquity': 'Other movement on equity accounts',
  'acc.equity.checkFailed': 'The equity report does not add up',
  'acc.equity.checkFailedDetail': 'Expected closing value {expected}, actual {actual}.',
  'acc.equity.profitCheckFailed': 'The period result does not match profit and loss',
  'acc.equity.profitCheckDetail': 'The result in the equity report is {equity}, net profit in the profit and loss report is {pnl}. Both come from the same journal entries — a difference means there is a mapping error.',
  'acc.accounts.title': 'Chart of accounts',
  'acc.accounts.description': 'The tree of accounting accounts and their link to semantic roles. The code never knows the account number — it only knows the ROLE, and the role is linked to an account here.',
  'acc.accounts.chart': 'Account tree',
  'acc.accounts.chartHint': 'No journal entry is written to a group account — it only sums up its children.',
  'acc.mapping.title': 'Role → account mapping',
  'acc.mapping.hint': 'Each role is mapped to EXACTLY one account. A journal entry cannot be written with an unmapped role, and the event stays in the queue.',
  'acc.mapping.role': 'Role',
  'acc.mapping.expectedType': 'Expected type',
  'acc.mapping.entityScoped': 'entity-scoped',
  'acc.mapping.typeMismatch': 'actual type: {actual}',
  'acc.mapping.unmappedTitle': 'Unmapped roles: {count}',
  'acc.mapping.unmappedHint': 'Events for these roles WILL NOT BECOME journal entries — they stay in the queue and the period cannot be closed. Map the role to an account.',
  'acc.periods.title': 'Accounting periods',
  'acc.periods.description': 'Once a month is closed, no journal entry can be written into it. Before closing, a checklist is run: unposted drafts, unbalanced entries and queued events.',
  'acc.periods.list': 'Periods of {year}',
  'acc.periods.period': 'Period',
  'acc.periods.status': 'Status',
  'acc.periods.journals': 'Journal entries',
  'acc.periods.drafts': 'Drafts',
  'acc.periods.closedAt': 'Closed',
  'acc.periods.select': 'Select',
  'acc.periods.selectHint': 'Select a period to see the checklist.',
  'acc.periods.statusOpen': 'open',
  'acc.periods.statusClosed': 'closed',
  'acc.periods.statusLocked': 'locked',
  'acc.periods.checklistTitle': '{period} — pre-closing check',
  'acc.periods.checklistHint': 'The period will not close until the blockers are resolved. Warnings can be knowingly skipped by the operator.',
  'acc.periods.checklistClean': 'No blockers and no warnings — the period can be closed.',
  'acc.periods.blocker': 'Blocker',
  'acc.periods.warning': 'Warning',
  'acc.periods.totals': 'Period turnover:',
  'acc.periods.debit': 'debit',
  'acc.periods.credit': 'credit',
  'acc.periods.balanced': 'balanced',
  'acc.periods.notBalanced': 'NOT BALANCED, difference {value}',
  'acc.periods.closeAction': 'Close period',
  'acc.periods.noClosePermission': 'You do not have permission to close a period — you can still view the list. If it needs closing, ask your chief accountant.',
  'acc.yearClose.title': 'Closing year {year}',
  'acc.yearClose.description': 'Income and expense accounts are reset to zero and the result is transferred to "Retained earnings". The action is IRREVERSIBLE — run a dry run first.',
  'acc.yearClose.dryRun': 'Dry run (nothing written)',
  'acc.yearClose.commit': 'REAL close — write the journal entry',
  'acc.yearClose.dryRunTitle': 'Dry run — nothing was written',
  'acc.yearClose.doneTitle': 'Year closed — journal entries written to the ledger',
  'acc.yearClose.income': 'Total income',
  'acc.yearClose.expense': 'Total expense',
  'acc.yearClose.profit': 'Profit',
  'acc.yearClose.loss': 'Loss',
  'acc.yearClose.notBalanced': 'NOT BALANCED',
  'acc.journal.title': 'Journal entries',
  'acc.journal.cardTitle': 'Journal entry',
  'acc.journal.description': 'Every document reaches the ledger as a debit and a credit.',
  'acc.journal.about': 'About this page',
  'acc.journal.aboutBody': 'A posted entry is never changed or deleted. If it is wrong, a reversing entry is written instead and both records stay in the ledger — which is why a report can be rebuilt for any date. Click the number in the list to open the entry lines and the source document.',
  'acc.journal.docNo': 'Number',
  'acc.journal.entryDate': 'Event date',
  'acc.journal.postingDate': 'Posting date',
  'acc.journal.period': 'Period',
  'acc.journal.status': 'Status',
  'acc.journal.statusAll': 'All',
  'acc.journal.statusDraft': 'Draft',
  'acc.journal.statusPosted': 'Posted',
  'acc.journal.statusReversed': 'Reversed',
  'acc.journal.descriptionField': 'Description',
  'acc.journal.source': 'Source',
  'acc.journal.sourceDoc': 'Document #{id}',
  'acc.journal.sourceUnknown': 'Other event',
  'acc.src.inventory.receipt': 'Stock receipt',
  'acc.src.inventory.issue': 'Stock issue',
  'acc.src.inventory.transfer': 'Transfer between warehouses',
  'acc.src.inventory.revaluation': 'Stock revaluation',
  'acc.src.inventory.count': 'Stock count',
  'acc.src.inventory.giveaway': 'Samples and display',
  'acc.src.inventory.return': 'Goods returned',
  'acc.src.invoice.issued': 'Invoice',
  'acc.src.credit_note.issued': 'Credit note',
  'acc.src.payment.received': 'Customer payment',
  'acc.src.payment.supplier': 'Supplier payment',
  'acc.src.supplier_advance.applied': 'Supplier advance applied',
  'acc.src.purchase.invoice_received': 'Supplier invoice',
  'acc.src.landed_cost.cogs_variance': 'Cost variance',
  'acc.src.fx.revaluation': 'FX revaluation',
  'acc.src.expense.posted': 'Expense',
  'acc.src.bonus.accrual': 'Bonus accrued',
  'acc.src.bonus.payout': 'Bonus paid',
  'acc.src.charity.accrued': 'Charity accrued',
  'acc.src.charity.paid': 'Charity paid',
  'acc.src.employee.advance': 'Employee advance',
  'acc.src.employee.debt': 'Employee debt',
  'acc.src.employee.debt.writeoff': 'Employee debt written off',
  'acc.src.payroll.accrued': 'Payroll accrued',
  'acc.src.payroll.paid': 'Payroll paid',
  'acc.journal.eventCode': 'Event code',
  'acc.journal.manual': 'manual',
  'acc.journal.amount': 'Amount',
  'acc.journal.total': 'Total',
  'acc.journal.postedAt': 'Posted at',
  'acc.journal.lines': 'Journal entry lines',
  'acc.journal.debit': 'Debit',
  'acc.journal.credit': 'Credit',
  'acc.journal.docCurrency': 'Document currency / FX rate',
  'acc.journal.lineNote': 'Note',
  'acc.journal.filterStatus': 'By status:',
  'acc.journal.filterAccount': 'Account #{id}',
  'acc.journal.backToList': 'Back to journal entries',
  'acc.journal.empty': 'No journal entries found',
  'acc.journal.emptyHint': 'Widen the filter or pick another period.',
  'acc.journal.reversedTitle': 'This journal entry has been reversed',
  'acc.journal.reversedHint': 'The record STAYS in the ledger and appears in reports — the reversing entry brings it to zero.',
  'nav.documentsExpiring': 'Expiring documents',
  'doc.panel.title': 'Documents',
  'doc.panel.hint': 'The file is attached to this object and is searched from here. If the same file is uploaded twice, no duplicate is created — the existing one is returned.',
  'doc.empty': 'No documents',
  'doc.emptyHint': 'Drop a file here or click the "Choose file" button.',
  'doc.loadError': 'Could not load documents',
  'doc.upload': 'Choose file',
  'doc.uploading': 'Uploading…',
  'doc.dropHere': 'Drop the file here',
  'doc.dropHint': 'Allowed types: images (JPG, PNG, WEBP), PDF, Word, Excel, PowerPoint, CSV. Maximum size — 25 MB.',
  'doc.uploaded': '“{fileName}” uploaded',
  'doc.duplicateNotice': '“{fileName}” was already here — no duplicate was created. This is not an error: it is normal for two people to upload the same file from two sources.',
  'doc.kind': 'Type',
  'doc.kind.invoice': 'Invoice',
  'doc.kind.packing_list': 'Packing list',
  'doc.kind.customs': 'Customs document',
  'doc.kind.contract': 'Contract',
  'doc.kind.certificate': 'Certificate',
  'doc.kind.photo': 'Photo',
  'doc.kind.act': 'Act',
  'doc.kind.other': 'Other',
  'doc.fileName': 'File',
  'doc.size': 'Size',
  'doc.uploadedAt': 'Uploaded',
  'doc.uploadedBy': 'Uploaded by',
  'doc.expiresOn': 'Valid until',
  'doc.expiresOnHint': 'For certificates and contracts. You cannot clear customs with an expired certificate — the system reminds you as the date approaches.',
  'doc.titleField': 'Title',
  'doc.titlePlaceholder': 'Optional — if left empty, the file name is shown',
  'doc.download': 'Download',
  'doc.replace': 'New version',
  'doc.replaceHint': 'The old copy is NOT DELETED — it moves to the archive and stays in place: landed cost may have been calculated from those old figures.',
  'doc.archive': 'Archive',
  'doc.archiveConfirm': 'The document will move to the archive. The file is not deleted and can be opened from the archive. Continue?',
  'doc.archived': 'Archived',
  'doc.showArchived': 'Show archived too',
  'doc.replacesLine': 'New version of document #{id}',
  'doc.preview': 'Preview',
  'doc.previewFailed': 'Could not open the preview',
  'doc.entity.shipments': 'Container',
  'doc.entity.purchase_orders': 'Purchase order',
  'doc.entity.goods_receipts': 'Goods receipt',
  'doc.entity.sales_returns': 'Return',
  'doc.entity.sales_return_lines': 'Return line',
  'doc.entity.sales_orders': 'Sales order',
  'doc.entity.invoices': 'Invoice',
  'doc.entity.payments': 'Payment',
  'doc.entity.customers': 'Customer',
  'doc.entity.suppliers': 'Supplier',
  'doc.entity.products': 'Product',
  'doc.entity.users': 'Employee',
  'doc.entity.stock_counts': 'Stock count',
  'doc.entity.deliveries': 'Delivery',
  'doc.expiring.title': 'Documents expiring soon',
  'doc.expiring.description': 'Certificates and contracts by expiry date. You cannot clear customs with an expired certificate, and the container sits at the port — demurrage accrues per day.',
  'doc.expiring.window': 'Window',
  'doc.expiring.windowDays': '{days} days',
  'doc.expiring.daysLeft': 'Left',
  'doc.expiring.left': '{days} days',
  'doc.expiring.today': 'Expires today',
  'doc.expiring.overdue': 'Expired {days} days ago',
  'doc.expiring.entity': 'Related to',
  'doc.expiring.empty': 'No documents are expiring soon',
  'doc.expiring.emptyHint': 'Widen the window or set an expiry date on the documents — a document without an expiry date never appears in this list.',
  'nav.approvals': 'My queue',
  'nav.approvalRules': 'Approval rules',
  'nav.delegations': 'Delegation',
  'appr.queueDescription': 'Documents waiting for your signature. The list shows only approvals assigned to you or to your role, or delegated to you — someone else\'s queue is not visible here.',
  'appr.loadError': 'Could not load approval data',
  'appr.empty': 'No approvals are waiting for you',
  'appr.metric.pending': 'Pending',
  'appr.metric.pendingHint': 'documents waiting for your signature',
  'appr.metric.overdue': 'Overdue',
  'appr.metric.overdueHint': 'escalation deadline has passed',
  'appr.metric.oldest': 'Longest waiting',
  'appr.metric.oldestHint': 'since the stage started',
  'appr.metric.topAmount': 'Largest amount',
  'appr.metric.topAmountHint': 'the most expensive document in the queue',
  'appr.col.document': 'Document',
  'appr.col.amount': 'Amount',
  'appr.col.waitingOn': 'Waiting on',
  'appr.col.waitingTime': 'Waiting time',
  'appr.col.stage': 'Stage',
  'appr.hours': '{hours} h',
  'appr.stageOf': '{stage} / {total}',
  'appr.stageShort': 'Stage {stage}',
  'appr.roleTarget': '{role} (role)',
  'appr.onBehalfOf': 'On behalf of {name}',
  'appr.escalated': 'Escalated',
  'appr.discountOf': 'discount {pct}%',
  'appr.waiting': 'waiting',
  'appr.notYet': 'not their turn yet',
  'appr.approve': 'Approve',
  'appr.reject': 'Reject',
  'appr.rejectConfirm': 'Confirm rejection',
  'appr.rejectReason': 'Rejection reason',
  'appr.rejectReasonHint': 'Write what needs to be fixed — the reason goes to the document author',
  'appr.raceLost': 'Someone signed this before you did. The list has been refreshed — please review it again.',
  'appr.docType.purchaseOrder': 'Purchase order',
  'appr.docType.salesDiscount': 'Sales discount',
  'appr.state.pending': 'Awaiting signature',
  'appr.state.approved': 'Approved',
  'appr.state.rejected': 'Rejected',
  'appr.state.notRequired': 'No approval required',
  'appr.panelTitle': 'Approval',
  'appr.panelSubtitle': '{amount} · document author: {author}',
  'appr.historyTitle': 'Signature history',
  'appr.act.approved': 'Approved',
  'appr.act.rejected': 'Rejected',
  'appr.rulesDescription': 'Whose signature is needed for which document and under what condition. With no rules, no approval is required and documents pass exactly as they do today.',
  'appr.rule.code': 'Code',
  'appr.rule.name': 'Name',
  'appr.rule.docType': 'Document type',
  'appr.rule.condition': 'Condition',
  'appr.rule.steps': 'Stages',
  'appr.rule.fourEyes': 'Four-eyes',
  'appr.rule.status': 'Status',
  'appr.rule.active': 'Active',
  'appr.rule.inactive': 'Disabled',
  'appr.rule.enable': 'Enable',
  'appr.rule.disable': 'Disable',
  'appr.rule.enabled': 'Rule “{code}” enabled',
  'appr.rule.disabled': 'Rule “{code}” disabled',
  'appr.rule.empty': 'No rules — approval is not required right now and documents pass in the usual order.',
  'appr.rule.new': 'New rule',
  'appr.rule.editTitle': 'Edit rule “{code}”',
  'appr.rule.saved': 'Rule “{code}” saved',
  'appr.rule.create': 'Create rule',
  'appr.rule.created': 'Rule “{code}” created',
  'appr.rule.minAmount': 'Amount (from, USD)',
  'appr.rule.maxAmount': 'Amount (to, USD)',
  'appr.rule.minDiscount': 'Discount (from, %)',
  'appr.rule.fromAmount': 'from {amount}',
  'appr.rule.toAmount': 'to {amount}',
  'appr.rule.fromDiscount': 'discount from {pct}%',
  'appr.rule.noCondition': 'no condition — applies to all documents',
  'appr.rule.rangeHint': 'Range: the lower bound is INCLUDED, the upper one is NOT. So with the ranges 0–10,000 and 10,000–∞, $10,000 falls only into the second one. An empty field means no condition is set.',
  'appr.rule.fourEyesLabel': 'The person who created the document cannot approve it themselves',
  'appr.rule.fourEyesHint': 'If several rules match and ANY ONE of them sets this requirement, it applies — you cannot get around it by adding a softer rule.',
  'appr.rule.unionHint': 'If several rules match one document, ALL of them apply; none is picked over the others. Editing a rule does not touch an open queue: the plan is snapshotted when the request is created.',
  'appr.rule.addStep': 'Add stage',
  'appr.rule.seq': 'Order',
  'appr.rule.approver': 'Who signs',
  'appr.rule.escHours': 'Escalation (hours)',
  'appr.rule.escTarget': 'Escalate to',
  'appr.rule.escalateAfter': 'after {hours} h to {target}',
  'appr.rule.seqHint': 'The same order number means parallel (both sign), different numbers mean sequential. If an escalation deadline is set, the escalation target must be set as well.',
  'appr.deleg.description': 'Temporarily hand your signing right to another employee during leave or a business trip. Delegation does not take the right away — it only adds one.',
  'appr.deleg.from': 'On whose behalf',
  'appr.deleg.to': 'To whom',
  'appr.deleg.self': 'Myself',
  'appr.deleg.docType': 'Document type',
  'appr.deleg.allDocTypes': 'All',
  'appr.deleg.period': 'Period',
  'appr.deleg.validFrom': 'Start',
  'appr.deleg.validTo': 'End',
  'appr.deleg.reasonHint': 'Leave, business trip…',
  'appr.deleg.new': 'New delegation',
  'appr.deleg.create': 'Delegate',
  'appr.deleg.created': 'Delegation recorded',
  'appr.deleg.empty': 'No delegations',
  'appr.deleg.revoke': 'Revoke',
  'appr.deleg.inclusiveHint': 'Both ends of the period are included: “until 25 August” means you can still sign on 25 August.',
  'appr.deleg.noChainHint': 'Chaining does not work: A → B → C. Only the original holder can delegate a right — otherwise the question “who approved this?” could not be answered.',
  'appr.deleg.needUserView': 'Creating a delegation requires permission to view the employee list. Contact your administrator — they can create the delegation on your behalf.',
  'nav.group.pos': 'Cash desk',
  'nav.directSale': 'Sale',
  'nav.myCash': 'My cash desk',
  'pos.title': 'Sale',
  'pos.subtitle': 'Product → customer → payment. All on one screen.',
  'pos.scan.label': 'Code or name',
  'pos.scan.placeholder': 'Type or scan an SKU/barcode, or search by name…',
  'pos.scan.hint': 'On an exact code match the line is added IMMEDIATELY (that is how the scanner works). By name — pick from the list.',
  'pos.scan.notFound': 'No such code found',
  'pos.scan.qty': 'Quantity',
  'pos.scan.add': 'Add',
  'pos.lines.title': 'Sale lines',
  'pos.lines.product': 'Product',
  'pos.lines.qty': 'Quantity',
  'pos.lines.price': 'Price',
  'pos.lines.amount': 'Amount',
  'pos.lines.remove': 'Remove',
  'pos.lines.empty': 'No lines — type or scan a product code',
  'pos.lines.priceList':
    'Price comes from the company price list. Once a customer is selected, the agreed price and contract discount are applied.',
  'pos.total.title': 'Total',
  'pos.total.subtotal': 'Subtotal',
  'pos.total.discount': 'Discount',
  'pos.total.vat': 'VAT',
  'pos.total.payable': 'TO PAY',
  'pos.total.preview': 'This is a PREVIEW. The final amount is calculated by the server — price and VAT are fixed when the document is posted.',
  'pos.debt.current': 'Customer debt',
  'pos.debt.overdue': 'Overdue',
  'pos.debt.blocked': 'Customer is BLOCKED — the sale will not go through',
  'pos.debt.loadError': 'Could not load the debt',
  'pos.customer.title': 'Customer',
  'pos.customer.required': 'Select a customer',
  'pos.customer.new': 'New customer',
  'pos.customer.newTitle': 'Quick customer',
  'pos.customer.name': 'Name',
  'pos.customer.phone': 'Phone',
  'pos.customer.code': 'Code',
  'pos.customer.codeHint': 'The code was suggested from the phone number — change it if needed. A second card with the same code cannot be created.',
  'pos.customer.create': 'Create',
  'pos.customer.created': 'Customer created',
  'pos.pay.title': 'Payment',
  'pos.pay.cash': 'Cash',
  'pos.pay.card': 'Card',
  'pos.pay.transfer': 'Bank transfer',
  'pos.pay.amount': 'Amount',
  'pos.pay.full': 'Full',
  'pos.pay.fullHint': 'Leave it empty — the server calculates the full amount itself (in the cash account currency, at the document FX rate).',
  'pos.pay.partialWarning': 'An amount was entered: the remainder stays as CUSTOMER DEBT and has to pass the credit limit check.',
  'pos.pay.reference': 'Receipt / document number',
  'pos.pay.noneWarning': 'No payment selected — the whole amount is recorded as DEBT and counts against the credit limit.',
  'pos.sell': 'SELL',
  'pos.selling': 'Selling…',
  'pos.reset': 'Clear',
  'pos.keyboardHint': 'Keyboard: the code field is always focused · Enter — add line · Alt+S — sell · Alt+N — new sale',
  'pos.done.title': 'Sale completed',
  'pos.done.duplicate': 'This sale is already recorded — pressing again did not create a new document',
  'pos.done.order': 'Order',
  'pos.done.delivery': 'Delivery note',
  'pos.done.invoice': 'Invoice',
  'pos.done.paid': 'Paid',
  'pos.done.debt': 'DEBT REMAINS',
  'pos.done.newSale': 'New sale',
  'pos.err.accountMissing': 'The cash account is not configured. This setting is made by an administrator — show them the message below.',
  'pos.err.stock': 'Not enough stock in the warehouse — the sale did not go through',
  'pos.err.credit': 'Credit limit: the unpaid part exceeded the limit',
  'pos.err.price': 'Price not found — the product is not in the price list',
  'pos.err.noLines': 'At least one line is required',
  'cash.title': 'My cash desk',
  'cash.subtitle': 'How much was collected today, and by which method',
  'cash.date': 'Date',
  'cash.total': 'Total',
  'cash.saleCount': '{count} sales',
  'cash.noSales': 'No sales yet today',
  'cash.method': 'Method',
  'cash.amount': 'Amount',
  'cash.count': 'Count',
  'cash.salesTitle': 'Today\'s sales',
  'cash.time': 'Time',
  'cash.doc': 'Document',
  'cash.customer': 'Customer',
  'cash.invoice': 'Invoice',
  'cash.debt': 'Debt',
  'cash.baseHint': 'The grand total is in USD: methods can be in different currencies (cash in soum, transfer in dollars) and cannot be added up directly.',
  'cash.notShift': 'This is NOT a shift report — there are no shifts here, the unit is the DAY. Day closing and cash collection are separate documents under «Branch cash desk».',
  'nav.procurementWorkspace': 'Procurement workspace',
  'proc.ws.title': 'Procurement department',
  'proc.ws.subtitle': 'One screen to open at the start of the day: what is urgent, where the orders are, when and how much to pay.',
  'proc.ws.asOf': 'As of: {date}',
  'proc.ws.recalculated': '{count} payment due dates were recalculated — the base date (shipment or ready date) has shifted.',
  'proc.ws.loadError': 'Could not load the workspace',
  'proc.ws.forbidden': 'This screen is for the procurement and finance departments: it shows supplier prices and payment terms.',
  'proc.ws.attention': 'Needs attention',
  'proc.ws.attention.clear': 'Nothing urgent today',
  'proc.ws.attention.clearHint': 'No overdue payments, no late production and no late containers. An empty list is the answer itself.',
  'proc.ws.kind.payment_overdue': 'Overdue payments',
  'proc.ws.kind.payment_due_soon': 'Due within 3 days',
  'proc.ws.kind.production_late': 'Ready date has passed, still not ready',
  'proc.ws.kind.arrival_late': 'ETA has passed, the container has not arrived',
  'proc.ws.countUnit': '{count} pcs',
  'proc.ws.pipeline': 'Order pipeline',
  'proc.ws.pipelineHint': 'The chain from China to the warehouse. Amounts are USD equivalents at the document FX rate.',
  'proc.ws.calendar': 'Payment calendar',
  'proc.ws.calendarHint': 'Next {days} days. Grouped by date × supplier: one transfer goes to one factory.',
  'proc.ws.calendarEmpty': 'No payments are scheduled in the next {days} days',
  'proc.ws.calendarTotal': 'Total: {amount}',
  'proc.ws.dueDate': 'Due date',
  'proc.ws.supplier': 'Supplier',
  'proc.ws.terms': 'Stage',
  'proc.ws.amount': 'Amount (USD)',
  'proc.ws.overdue': 'Overdue payments',
  'proc.ws.overdueDays': '{days} days',
  'proc.ws.doc': 'Document',
  'proc.ws.reliability': 'Supplier performance',
  'proc.ws.reliabilityHint': 'The gap between the date the factory promised (plan) and the actual ready date. Vessel delays are NOT MIXED IN here — they are measured separately.',
  'proc.ws.reliabilityEmpty': 'No measurements yet: the ready dates (plan and actual) are not filled in on the orders.',
  'proc.ws.measured': 'Measured',
  'proc.ws.avgDelay': 'Average delay',
  'proc.ws.worstDelay': 'Worst case',
  'proc.ws.lateNow': 'Late right now',
  'proc.ws.days': '{days} days',
  'proc.ws.reorder': 'Reorder — 10 most urgent',
  'proc.ws.reorderHint': 'The lead time is 120–150 days: the decision is made four months before the stock runs out.',
  'proc.ws.reorderEmpty': 'No urgent orders are needed for now',
  'proc.ws.reorderError': 'Could not load the reorder analysis',
  'proc.ws.sku': 'Code',
  'proc.ws.product': 'Product',
  'proc.ws.onHand': 'Stock',
  'proc.ws.daysOfCover': 'Days of cover',
  'proc.ws.suggested': 'Suggested',
  'poTerms.title': 'Payment schedule',
  'poTerms.hint': 'Imports are paid in stages. The due date is tied to an EVENT, not to a DATE: the condition “5 days before shipment” SHIFTS BY ITSELF when the shipment date moves.',
  'poTerms.empty': 'No payment schedule entered',
  'poTerms.emptyHint': 'Without a schedule the order does not reach the payment calendar, and no debt warning is raised either.',
  'poTerms.loadError': 'Could not load the payment schedule',
  'poTerms.seq': 'No.',
  'poTerms.label': 'Stage',
  'poTerms.share': 'Share',
  'poTerms.amountBase': 'USD',
  'poTerms.basis': 'Basis',
  'poTerms.offset': 'Offset',
  'poTerms.dueDate': 'Due date',
  'poTerms.status': 'Status',
  'poTerms.percentTotal': 'Total share: {percent}',
  'poTerms.percentIncomplete': 'The shares add up to less than 100% — the schedule is incomplete and the remaining amount will not reach the calendar.',
  'poTerms.undated': '{count} stages have no due date: the base date is not known yet (no container, or the ready date is not filled in). The date is NOT GUESSED.',
  'poTerms.recalculated': 'The base date has shifted — {count} due dates were recalculated.',
  'poTerms.overdue': '{days} days overdue',
  'poTerms.noDate': 'Due date not known yet',
  'poTerms.edit': 'Edit schedule',
  'poTerms.add': 'Add stage',
  'poTerms.remove': 'Remove',
  'poTerms.save': 'Save schedule',
  'poTerms.saved': 'Payment schedule saved',
  'poTerms.saveError': 'Could not save the schedule',
  'poTerms.cancelEdit': 'Cancel',
  'poTerms.percentPlaceholder': '30.00',
  'poTerms.labelPlaceholder': 'Advance 30%',
  'poTerms.offsetHint': 'A negative number means BEFORE THE EVENT (for example −5)',
  'poTerms.preset': 'Template: 30% advance / 70% before shipment',
  'poTerms.basis.order': 'Order date',
  'poTerms.basis.ready': 'Ready date',
  'poTerms.basis.shipment': 'Shipment',
  'poTerms.basis.arrival': 'Arrival',
  'poTerms.source.order_date': 'order date',
  'poTerms.source.ready_date': 'PLANNED ready date',
  'poTerms.source.actual_ready_date': 'ACTUAL ready date',
  'poTerms.source.shipment_etd': 'planned departure (ETD)',
  'poTerms.source.shipment_atd': 'ACTUAL departure (ATD)',
  'poTerms.source.shipment_eta': 'planned arrival (ETA)',
  'poTerms.source.shipment_ata': 'ACTUAL arrival (ATA)',
  'poTerms.status.planned': 'Planned',
  'poTerms.status.due': 'Due',
  'poTerms.status.paid': 'Paid',
  'poTerms.status.cancelled': 'Cancelled',
  'poTerms.notLedger': 'The “Paid” mark is a PLAN status — it does not create a journal entry. Actual cash movement is recorded by the finance department.',
  'poReady.title': 'Factory ready date',
  'poReady.hint': 'This is NOT the arrival date. The factory produces in 40 days, and the container then travels another 90–110 days. If the two are not tracked separately, the REASON for a delay is lost.',
  'poReady.plan': 'Plan',
  'poReady.actual': 'Actual',
  'poReady.delayLabel': 'Plan vs actual gap',
  'poReady.delay': 'Gap: {days} days',
  'poReady.early': 'Ready early: {days} days',
  'poReady.onTime': 'Ready on plan',
  'poReady.pending': 'Not ready yet',
  'poReady.late': 'The ready date passed {days} days ago',
  'poReady.save': 'Save dates',
  'poReady.saved': 'Dates saved',
  'poReady.saveError': 'Could not save the dates',
  'poReady.notSet': 'Not set',
  'nav.group.branchCash': 'Branch cash desk',
  'nav.dayClosing': 'Day closing',
  'nav.expenses': 'Branch expenses',
  'closing.account': 'Cash account',
  'closing.accountPick': 'Select a cash account…',
  'closing.date': 'Business day',
  'closing.opening': 'Opening balance',
  'closing.cashIn': 'Cash in today',
  'closing.cashOut': 'Cash out today',
  'closing.expected': 'Expected balance',
  'closing.counted': 'Counted (actual)',
  'closing.countedPlaceholder': 'Count it by hand',
  'closing.countedHint': 'The system does not fill in the counted amount, and that is deliberate: if you copy the expected figure, closing becomes a ritual and a shortage is never found.',
  'closing.difference': 'Difference',
  'closing.kind.match': 'No difference',
  'closing.kind.shortage': 'SHORTAGE — less cash in the drawer',
  'closing.kind.surplus': 'SURPLUS — more cash in the drawer',
  'closing.reason': 'Reason for the difference',
  'closing.reasonPlaceholder': 'Why did the difference appear?',
  'closing.reasonHint': 'At least 5 characters. A difference without a reason turns into “we rounded it”, and a few months later nobody can say what happened on that day.',
  'closing.notes': 'Notes',
  'closing.countTitle': 'Count the cash',
  'closing.closeAction': 'Close the day',
  'closing.noClosePerm': 'You do not have permission to close the day — view only.',
  'closing.closedTitle': 'Day closed',
  'closing.reopenAction': 'Reopen',
  'closing.reopenReason': 'Reason for reopening',
  'closing.reopenHint': 'Only a manager or a finance officer can reopen. Reopening starts from the end of the chain: opening a day in the middle would silently change the opening balance of the days that follow.',
  'closing.previous': 'Previous closing',
  'closing.previousDiff': 'Uncovered difference: {diff}',
  'closing.breakdown': 'Movements during the day',
  'closing.direction': 'Direction',
  'closing.item': 'Cash flow item',
  'closing.count': 'Count',
  'closing.amount': 'Amount',
  'closing.in': 'In',
  'closing.out': 'Out',
  'closing.noMovements': 'There was no cash movement on this day.',
  'closing.status': 'Status',
  'closing.status.open': 'Open',
  'closing.status.closed': 'Closed',
  'closing.status.reopened': 'Reopened',
  'closing.history': 'Recent closings',
  'closing.historyEmpty': 'No day has been closed yet.',
  'closing.noAccounts': 'No branch cash account is assigned to you',
  'closing.noAccountsHint': 'Day closing is done for a cash account LINKED to a branch. Either the cash account has to be linked to the branch (Settings → Cash and bank), or you have to be granted the scope of that branch.',
  'closing.genericError': 'Could not complete the action',
  'closing.notTransferHint': 'Day closing is NOT A MONEY TRANSFER, it is a reconciliation. After closing, the cash stays in that branch\'s cash account. Handing it over to head office (cash collection) is a separate document: Finance → Transfer between accounts.',
  'closing.moneyStaysHint': 'The money did NOT go to head office automatically — it stayed in this cash account. When you hand it over, record a transfer between accounts.',
  'closing.driftTitle': 'The chain is broken',
  'closing.driftHint': 'The expected balance does not match the cash book total (difference {drift}). This usually happens when a backdated entry lands on a closed day. Contact your finance officer — the cause has to be found before closing.',
  'expense.intro': 'Expenses the branch paid from its own cash account. A draft does not move money — cash leaves the account only when the document is posted.',
  'expense.new': 'New expense',
  'expense.saveDraft': 'Save draft',
  'expense.draftHint': 'After saving, the money has not left yet: the document still has to be posted.',
  'expense.docNo': 'Document',
  'expense.date': 'Date',
  'expense.branch': 'Branch',
  'expense.account': 'Cash account',
  'expense.accountPick': 'Select a cash account…',
  'expense.item': 'Expense type (cash flow)',
  'expense.itemPick': 'Select an item…',
  'expense.amount': 'Amount',
  'expense.payee': 'Paid to',
  'expense.documentRef': 'Receipt/voucher',
  'expense.description': 'Notes',
  'expense.descriptionPlaceholder': 'For example: shop rent for August',
  'expense.descriptionHint': 'At least 5 characters. The cash flow item gives the category (“Rent”), while the note gives the specific fact — an entry saying “expense 500,000” explains nothing at the end of the month.',
  'expense.status': 'Status',
  'expense.statusAll': 'All',
  'expense.status.draft': 'Draft',
  'expense.status.posted': 'Posted',
  'expense.status.cancelled': 'Cancelled',
  'expense.post': 'Post',
  'expense.awaitingPost': 'Awaiting posting',
  'expense.cancelAction': 'Cancel',
  'expense.cancelReason': 'Cancellation reason',
  'expense.confirm': 'Confirm',
  'expense.actions': 'Actions',
  'expense.empty': 'No expenses found.',
  'expense.noAccounts': 'No branch cash account is assigned to you. An expense can only be recorded from a BRANCH cash account.',
  'expense.noItems': 'No expense items found. A finance officer has to set up expense items in the cash flow tree (Finance → Cash flow items).',
  'expense.genericError': 'Could not complete the action',
  'nav.fxRevaluation': 'FX revaluation',
  'fxreval.intro': 'At period end the balances held in foreign currency (cash, bank, customer debt, supplier debt) are recalculated at the closing rate. Calculate first and check the lines — posting to the ledger is a separate step.',
  'fxreval.legalEntity': 'Legal entity',
  'fxreval.pickEntity': 'Select a legal entity.',
  'fxreval.currency': 'Currency',
  'fxreval.currencyHint': '{base} is not on the list: it is the base currency, and converting it into itself always gives a zero difference.',
  'fxreval.date': 'Date',
  'fxreval.dateHint': 'Usually the last day of the month. The closing rate of that date is used.',
  'fxreval.previewAction': 'Calculate (preview)',
  'fxreval.staleHint': 'The selection has changed — the figures below are OUT OF DATE. Press “Calculate” again.',
  'fxreval.closingRate': 'Closing rate',
  'fxreval.gain': 'FX gain',
  'fxreval.loss': 'FX loss',
  'fxreval.net': 'Net result',
  'fxreval.netGain': 'GAIN — the balance is worth more in the base currency',
  'fxreval.netLoss': 'LOSS — the balance is worth less in the base currency',
  'fxreval.netZero': 'No difference',
  'fxreval.warningsTitle': 'These balances were not revalued',
  'fxreval.existingTitle': 'A revaluation for this date ALREADY exists',
  'fxreval.existingHint': 'A record already exists for {date} (status: {status}, net result: {net}). Reverse the old one before writing a new one — otherwise the same FX difference lands in the ledger twice.',
  'fxreval.linesTitle': 'Balances to be revalued',
  'fxreval.role': 'Type',
  'fxreval.role.cash': 'Cash',
  'fxreval.role.bank': 'Bank',
  'fxreval.role.ar': 'Customer debt',
  'fxreval.role.ap': 'Supplier debt',
  'fxreval.account': 'Account',
  'fxreval.subject': 'What was revalued',
  'fxreval.foreignAmount': 'Balance in currency',
  'fxreval.previousBase': 'Previous base',
  'fxreval.newBase': 'New base',
  'fxreval.differenceBase': 'DIFFERENCE',
  'fxreval.noLines': 'No balance in this currency was found — there is neither a difference nor a journal entry.',
  'fxreval.postTitle': 'Post to the ledger',
  'fxreval.postHint': 'Once posted, the amount lands in this month’s profit and loss. A mistake cannot be deleted — it can only be reversed, with a reason.',
  'fxreval.postAction': 'Post to the ledger',
  'fxreval.postAgainAction': 'A record exists for this date — post anyway',
  'fxreval.notes': 'Notes',
  'fxreval.notesPlaceholder': 'For example: August closing',
  'fxreval.noRunPerm': 'You do not have permission to post — view only.',
  'fxreval.resultTitle': 'Posted',
  'fxreval.journal': 'Journal entry',
  'fxreval.journalWritten': 'The journal entry has been written',
  'fxreval.journalLine': 'Document {docNo}, status: {status}',
  'fxreval.journalPendingTitle': 'The revaluation is saved, the journal entry is queued',
  'fxreval.journalPendingHint': 'This is NOT an error. The system writes the journal entry through a queue and that usually takes a few seconds. Do not press the button again — refresh the page and the document number will appear in the history.',
  'fxreval.journalPendingShort': 'Queued',
  'fxreval.status': 'Status',
  'fxreval.status.draft': 'Draft',
  'fxreval.status.posted': 'Posted',
  'fxreval.status.reversed': 'Reversed',
  'fxreval.actions': 'Actions',
  'fxreval.history': 'Previous revaluations',
  'fxreval.historyEmpty': 'No revaluation has been done yet.',
  'fxreval.reverseAction': 'Reverse',
  'fxreval.reverseReason': 'Reason for reversal',
  'fxreval.reverseReasonPlaceholder': 'Why is it being reversed?',
  'fxreval.reverseHint': 'At least 3 characters. A reversal changes the figure of a closed period and is often pressed under the pressure of “the report did not look good” — write a reason that still reads well a few months later.',
  'fxreval.genericError': 'Could not complete the action',

  // Compact FX chip in the topbar.
  'fx.missingShort': 'No rate',
  'fx.chipTitle': 'Daily rate: 1 USD = {rate} UZS ({date})',
  'fx.cnyHint':
    '¥ is only for purchasing — when a container arrives from China. It is not a daily rate, so it is not shown in the topbar.',

  // --- Home page: hero strip and KPI tiles ---------------------------------
  'dashboard.hero.morning': 'Good morning, {name}',
  'dashboard.hero.day': 'Good afternoon, {name}',
  'dashboard.hero.evening': 'Good evening, {name}',
  'dashboard.hero.night': 'Good night, {name}',

  // Without a name — when the account has no real first name.
  'dashboard.hero.morningPlain': 'Good morning',
  'dashboard.hero.dayPlain': 'Good afternoon',
  'dashboard.hero.eveningPlain': 'Good evening',
  'dashboard.hero.nightPlain': 'Good night',

  'dashboard.hero.weekday.sun': 'Sunday',
  'dashboard.hero.weekday.mon': 'Monday',
  'dashboard.hero.weekday.tue': 'Tuesday',
  'dashboard.hero.weekday.wed': 'Wednesday',
  'dashboard.hero.weekday.thu': 'Thursday',
  'dashboard.hero.weekday.fri': 'Friday',
  'dashboard.hero.weekday.sat': 'Saturday',

  // The amount is gone from the sentence: it sits right next to it, in «Today».
  'dashboard.hero.sales': 'Today: {lines} sales lines.',
  'dashboard.hero.noSalesYet': 'No sales yet today — the day is just starting.',
  'dashboard.hero.trendUp': 'This month is ahead of the same point last month.',
  'dashboard.hero.trendDown': 'This month is behind the same point last month.',
  'dashboard.hero.trendFlat': 'This month is level with the same point last month.',
  'dashboard.hero.tasks': '{count} items are waiting for your attention.',
  'dashboard.hero.allClear': 'Nothing needs attention — everything is in order.',
  'dashboard.hero.plain': 'Have a productive day.',
  'dashboard.hero.dataError': 'Some figures failed to load — the reason is shown in the sections below.',
  'dashboard.hero.today': 'Today',
  'dashboard.hero.thisMonth': 'This month',

  'dashboard.kpi.salesToday': 'Sales today',
  'dashboard.kpi.salesTodayHint': '{count} sales lines',
  'dashboard.kpi.revenueMonth': 'Revenue this month',
  'dashboard.kpi.overdue': 'Overdue receivables',
  'dashboard.kpi.overdueHint': 'Total receivables: {amount}',
  'dashboard.kpi.cashHint': 'In {in} · out {out}',
  'dashboard.kpi.tasksHint': 'Transfers {transfers} · counts {counts}',
  'dashboard.kpi.tasksNone': 'Nothing left open',

  'dashboard.attention.allClearTitle': 'Everything is in order',
  'dashboard.attention.allClearBody':
    'No overdue debt and no documents left unreceived. You can work in peace today.',

  'dashboard.section.ranking': 'Who and what brings the money',
  'dashboard.section.rankingHint': 'By revenue this month, top five',
  'dashboard.section.ar': 'Receivables watch',
  'dashboard.section.arHint': 'Customers with overdue debt, largest first',
  'dashboard.section.stock': 'Stock value',
  'dashboard.section.stockHint': 'Per warehouse, at landed cost',

  'dashboard.arRowHint': 'Total debt: {amount}',
  'dashboard.arNoOverdue': 'No overdue debt',
  'dashboard.arNoOverdueHint':
    'Every invoice is still within its term. No collection calls are needed today.',
  'dashboard.stockEmpty': 'No stock value to show',
  'dashboard.stockEmptyHint':
    'Warehouses with stock appear here. An empty list means no receipt has been posted yet.',
  'dashboard.emptySales': 'No sales this month yet',
  'dashboard.emptySalesHint':
    'Figures appear once a shipment is POSTED — an order on its own does not reach the report.',

  // --- Reversing an expense ---
  'expense.reverseAction': 'Reverse',
  'expense.reverseTitle': 'Reverse {docNo}',
  'expense.reverseHint':
    'The expense is NOT deleted — a reversing document is created and both stay in the list. {amount} goes BACK into the «{account}» register, so the expected balance for the day rises by that amount. The original document moves to «cancelled».',
  'expense.reverseReason': 'Reason for the reversal',
  'expense.reverseReasonPlaceholder':
    'For example: the rent was entered twice; the amount was 50,000, not 500,000',
  'expense.reverseReasonHint':
    'Write down what actually went wrong — at least {min} characters. A reversal RETURNS cash to the register and raises the expected balance: without a reason such an entry becomes a way to quietly cover up surplus cash. The reason is kept in the audit trail.',
  'expense.reverseSubmit': 'Yes, reverse it',
  'expense.reverseDone': 'Reversed',
  'expense.reverseDoneHint':
    '{docNo} was cancelled and a reversing document was created in its place. The original stays in history — a cash report printed yesterday still reads the same today.',
  'expense.reverseReturned': 'Returned to the register',
  'expense.reverseReturnedHint': 'Into «{account}», as an incoming movement',
  'expense.reverseCashAfter': 'Cash balance',
  'expense.reverseCashBefore': 'Before the reversal: {amount}',
  'expense.reverseOriginal': 'Cancelled document',
  'expense.reverseOriginalHint': 'Stays in the list, never deleted',
  'expense.reversalRow': 'Reversal',
  'expense.reversedRow': 'Reversed',

  // --- Reversing a bonus payout ---
  'bnl.actions': 'Actions',
  'bnl.reverseAction': 'Reverse',
  'bnl.reverseTitle': 'Reverse {docNo}',
  'bnl.reverseHint':
    'The payout is NOT deleted — a reversing line is added to the ledger and both stay visible. {amount} goes BACK into the register and the bonus balance returns to what it was before the payout.',
  'bnl.reverseHintInstaller':
    'The payout is NOT deleted — a reversing line is added to the ledger and both stay visible. TWO things come back: {amount} into the register and {points} points into the installer’s account. Once the points are back, the installer can cash them out again or spend them on a reward — so this is not «cancelling» the bonus, it returns it to the UNPAID state.',
  'bnl.reverseReason': 'Reason for the reversal',
  'bnl.reverseReasonPlaceholder':
    'For example: the wrong installer was picked; the number of points was mistyped',
  'bnl.reverseReasonHint':
    'Write down what actually went wrong — at least {min} characters. A reversal RETURNS cash to the register and raises the expected balance: without a reason such an entry becomes a way to quietly cover up surplus cash. The reason is kept in the audit trail.',
  'bnl.reverseSubmit': 'Yes, reverse it',
  'bnl.reverseDone': 'Reversed',
  'bnl.reverseDoneHint':
    '{docNo} was reversed and a reversing line was written in its place. The original line stays in the ledger — a report printed yesterday still reads the same today.',
  'bnl.reverseReturned': 'Returned to the register',
  'bnl.reverseReturnedHint': 'As an incoming movement, on the original payout date',
  'bnl.reverseCashAfter': 'Cash balance',
  'bnl.reverseCashBefore': 'Before the reversal: {amount}',
  'bnl.reversePoints': 'Points returned to the installer',
  'bnl.reversePointsHint': 'The balance is restored — the points can be used again',
  'bnl.reverseOriginal': 'Reversed document',
  'bnl.reverseOriginalHint': 'Stays in the ledger, never deleted',

  'branchFilter.active': 'Branch: {branch}',
  'branchFilter.clear': 'Remove the filter',
  'branchFilter.hint': 'The list is narrowed to the branch selected in the top bar.',
  'branchFilter.cleared': 'Showing all branches.',
  'branchFilter.restore': 'Show only «{branch}»',

  'rebate.column': 'Rebate',
  'rebate.toggle': 'Tiers',
  'rebate.toggleClose': 'Close',
  'rebate.title': '{dealer} — annual rebate tiers',
  'rebate.what':
    'The year-end rebate percentage comes from this ladder: whichever tier the annual turnover reaches or exceeds, that tier’s percentage applies.',
  'rebate.year': 'Year',
  'rebate.loadError': 'Could not load the tiers',
  'rebate.emptyTitle': 'No tiers configured for {year}',
  'rebate.emptyBody':
    'A tier ladder is the contract rule «the more you buy, the more comes back»: for example 1% from 0, 3% from 1 000, 5% from 50 000. Without a ladder no bonus is calculated — the server finds no matching tier and refuses. Add the first tier in the form below.',
  'rebate.rungFrom': 'from this amount up',
  'rebate.rungUntil': 'next tier starts at:',
  'rebate.rungTop': 'no upper bound — top tier',
  'rebate.inactive': 'Disabled',
  'rebate.noZeroTitle': 'The ladder does not start at zero',
  'rebate.noZeroBody':
    'The lowest tier starts at {amount}. A dealer whose annual turnover stays below that falls into NO tier at all and the accrual is refused. If that is deliberate, nothing needs doing; otherwise add a tier starting at 0.',
  'rebate.turnoverUnknown':
    'The dealer’s current turnover is not shown here: the server computes it from invoices while accruing the bonus and does not expose it separately. The ladder is the AGREEMENT; the turnover is the year-end FACT.',
  'rebate.addTitle': 'Add a tier or change its percentage',
  'rebate.upsertHint':
    'Re-entering an existing amount UPDATES that tier’s percentage — it does not create a duplicate.',
  'rebate.fromAmount': 'From amount',
  'rebate.fromAmountHint':
    'In the base currency ({currency}). The bound is inclusive: exactly this amount already belongs to this tier.',
  'rebate.pct': 'Rebate percentage',
  'rebate.pctHint': '0 to 100, up to 2 decimals. Zero is allowed — «no bonus in this tier».',
  'rebate.fromAmountInvalid': 'The amount must be a non-negative number with up to 4 decimals',
  'rebate.pctInvalid': 'The percentage must be 0 to 100 with up to 2 decimals',
  'rebate.save': 'Save the tier',
  'rebate.saved': 'Saved: {pct} from {amount} up',
  'rebate.frozenHint':
    'Changing a tier does NOT touch bonuses already accrued — the percentage in the ledger is a frozen copy and past accruals are never rewritten.',
  'rebate.noManage':
    'You do not have permission to change rebate tiers — finance and admin hold it. Viewing is open to everyone.',

  'customer.contract.title': 'Contract terms',
  'customer.contract.discount': 'Contract discount',
  'customer.contract.discountHint': '0 to 100, up to 2 decimals. Leave empty to keep it unchanged.',
  'customer.contract.no': 'Contract number',
  'customer.contract.noHint': 'Must match the number on the paper contract exactly.',
  'customer.contract.from': 'Valid from',
  'customer.contract.to': 'Valid until',
  'customer.contract.toHint': 'After this date the discount no longer applies.',
  'customer.contract.period': 'Validity',
  'customer.contract.status': 'Status',
  'customer.contract.statusNone': 'No dates given',
  'customer.contract.statusOpen': 'Half-open period',
  'customer.contract.statusActive': 'In force',
  'customer.contract.statusExpired': 'Expired',
  'customer.contract.statusFuture': 'Not in force yet',
  'customer.contract.noDiscount': 'No discount',
  'customer.contract.noDiscountHint': 'Prices follow the standard price list.',
  'customer.contract.appliedHint': 'Offered as the default discount on every line.',
  'customer.contract.notApplied': 'NOT APPLIED — the contract has expired',
  'customer.contract.expiredTitle': 'The contract has expired — the discount is not in force',
  'customer.contract.expiredBody':
    'It ended on {date}. The percentage below is shown as HISTORY and must not go into a quote: the customer writes the quoted price down, and afterwards either the discount is honoured at a loss or the deal falls apart. If the contract was renewed, enter the new dates.',
  'customer.contract.futureTitle': 'The contract is not in force yet',
  'customer.contract.futureBody':
    'The discount applies from {date}. It does not apply to today’s sales.',
  'customer.contract.openTitle': 'The contract period is half-open',
  'customer.contract.openBody':
    'One of the two dates is missing, so the discount runs indefinitely. That must be a deliberate decision — otherwise fill in both dates.',
  'customer.contract.pendingTitle': 'Contract fields are not available yet',
  'customer.contract.pendingBody':
    'The discount, contract number and validity dates are not available on this screen yet. Once they are ready this section fills itself in and the edit form appears — nothing else on the screen changes.',
  'customer.contract.edit': 'Change the contract terms',
  'customer.contract.editHint':
    'A discount is a contract term, not a mood: it lands on every sales line and adds up to a serious amount over a year. A discount with no end date never ends.',
  'customer.contract.saved': 'Contract terms saved',
  'customer.contract.noChanges': 'Nothing changed',
  'customer.contract.pctInvalid': 'The discount must be 0 to 100 with up to 2 decimals',
  'customer.contract.dateInvalid': 'The date must look like 2026-08-13',
  'customer.contract.rangeInvalid': 'The end date cannot be earlier than the start date',
  'customer.contract.noPermission':
    'You do not have permission to change the customer’s credit terms. Ask your manager if you need it.',
  'nav.employees': 'Employees',
  'hr.employees.title': 'Employees',
  'hr.employees.total': 'Total employees',
  'hr.employees.active': 'Active',
  'hr.employees.expiredContracts': 'Expired contracts',
  'hr.employees.expiredHint': 'Employee is formally unprotected',
  'hr.employees.searchHint': 'Name, employee no. or position',
  'hr.employees.emptyTitle': 'No employees',
  'hr.employees.emptyBody': 'Clear the filter or add an employee.',
  'hr.employees.no': 'Emp. no',
  'hr.employees.name': 'Full name',
  'hr.employees.position': 'Position',
  'hr.employees.branch': 'Branch',
  'hr.employees.contract': 'Contract',
  'hr.employees.salary': 'Salary',
  'hr.employees.salaryHint': 'contract amount',
  'hr.employees.central': 'Head office',
  'hr.employees.card': 'Card',
  'hr.employees.new': 'New employee',
  'hr.employees.hiredAt': 'Hired on',
  'hr.employees.statusCol': 'Status',
  'hr.employees.all': 'All',
  'hr.status.active': 'Active',
  'hr.status.suspended': 'Suspended',
  'hr.status.fired': 'Dismissed',
  'hr.contract.none': 'None',
  'hr.contract.open': 'Open-ended',
  'hr.contract.active': 'Active',
  'hr.contract.future': 'Not started',
  'hr.contract.expired': 'Expired',
  'hr.contract.expiredTitle': 'Contract has expired',
  'hr.contract.expiredBody': 'The employee is working without a contract. Ended:',
  'hr.duties.duties': 'Duties',
  'hr.duties.dutiesHint': 'What they do daily — becomes a KPI',
  'hr.duties.obligations': 'Contract obligations',
  'hr.duties.obligationsHint': 'What they signed — evidence in a dispute',
  'hr.duties.empty': 'Nothing recorded yet',
  'hr.duties.add': 'Add duty or obligation',
  'hr.duties.kind': 'Kind',
  'hr.duties.titleField': 'Title',
  'hr.duties.titleHint': 'e.g. close the register daily',
  'hr.duties.kpiLinked': 'Linked to KPI plan:',
  'hr.fire.title': 'Dismiss employee',
  'hr.fire.hint': 'The date drives payroll — without it the employee keeps being paid silently.',
  'hr.fire.date': 'Dismissal date',
  'hr.fire.reason': 'Reason',
  'hr.fire.reasonShort': 'At least 5 characters',
  'hr.fire.submit': 'Dismiss',
  'nav.payroll': 'Payroll and advances',
  'hr.payroll.title': 'Payroll, advances and debts',
  'hr.payroll.runs': 'Payroll runs',
  'hr.payroll.run': 'Calculate payroll',
  'hr.payroll.runHint': 'Books the expense; no cash leaves — payment is separate.',
  'hr.payroll.period': 'Period',
  'hr.payroll.year': 'Year',
  'hr.payroll.month': 'Month',
  'hr.payroll.gross': 'Gross',
  'hr.payroll.advance': 'Advance',
  'hr.payroll.deduction': 'Deducted',
  'hr.payroll.net': 'Net',
  'hr.payroll.pay': 'Pay',
  'hr.payroll.payConfirm': 'Confirm — release the cash',
  'hr.payroll.chooseAccount': 'Choose a register',
  'hr.payroll.account': 'Register',
  'hr.payroll.amount': 'Amount',
  'hr.payroll.noRuns': 'No payroll yet',
  'hr.payroll.noRunsBody': 'Pick a period and press Calculate payroll.',
  'hr.payroll.advances': 'Advances',
  'hr.payroll.advancesHint': 'Paid mid-month — settled in payroll',
  'hr.payroll.noAdvances': 'No advances',
  'hr.payroll.giveAdvance': 'Give advance',
  'hr.payroll.openAdvances': 'Open advances',
  'hr.payroll.openAdvancesHint': 'withheld in the next payroll',
  'hr.payroll.debts': 'Employee debts',
  'hr.payroll.debtsHint': 'Shortfall, damage, loan',
  'hr.payroll.noDebts': 'No debts',
  'hr.payroll.addDebt': 'Record debt',
  'hr.payroll.openDebts': 'Open debts',
  'hr.payroll.openDebtsHint': 'withheld from payroll',
  'hr.payroll.doc': 'Document',
  'hr.payroll.source': 'Source',
  'hr.payroll.sourceHint': 'also decides the ledger entry',
  'hr.payroll.balance': 'Balance',
  'hr.payroll.advance.posted': 'Open',
  'hr.payroll.advance.settled': 'Settled',
  'hr.payroll.advance.reversed': 'Reversed',
  'hr.debt.shortfall': 'Cash shortfall',
  'hr.debt.damage': 'Damaged goods',
  'hr.debt.loan': 'Loan',
  'hr.debt.other': 'Other',
  'hr.debt.status.open': 'Open',
  'hr.debt.status.settled': 'Settled',
  'hr.debt.status.written_off': 'Written off',
  'nav.charity': 'Charity fund',
  'charity.title': 'Charity fund',
  'charity.accrued': 'Accrued',
  'charity.paid': 'Given',
  'charity.available': 'Available in fund',
  'charity.availableHint': 'a liability — not part of equity',
  'charity.accrue': 'Appropriate from profit',
  'charity.accrueHint': 'A share of net profit. No appropriation in a loss month.',
  'charity.pct': 'Percent',
  'charity.baseProfit': 'Base profit',
  'charity.amount': 'Appropriation',
  'charity.give': 'Give aid',
  'charity.recipient': 'Recipient',
  'charity.recipientHint': 'a person or an organisation — the money must leave a trace',
  'charity.purpose': 'Purpose',
  'charity.appropriations': 'Appropriations',
  'charity.payouts': 'Aid given',
  'charity.noAppropriations': 'No appropriations yet',
  'charity.noPayouts': 'No aid given yet',
  'nav.control': 'Control desk',
  'hr.control.title': 'Control desk',
  'hr.control.subtitle': 'Contracts, duties, advances, debts and payroll in one list. This screen changes nothing.',
  'hr.control.includeLeft': 'Include leavers',
  'hr.control.employees': 'Employees',
  'hr.control.critical': 'Critical',
  'hr.control.criticalHint': 'at least one high signal',
  'hr.control.openAdvance': 'Open advances',
  'hr.control.openAdvanceHint': 'cash out, not yet withheld',
  'hr.control.openDebt': 'Open debts',
  'hr.control.openDebtHint': 'withheld from payroll',
  'hr.control.board': 'Control board',
  'hr.control.employee': 'Employee',
  'hr.control.signals': 'Signals',
  'hr.control.money': 'Advance / debt',
  'hr.control.noSignals': 'All clear',
  'hr.control.clean': 'Nothing to flag',
  'hr.control.cleanBody': 'Every contract is valid; no open advances or debts.',
  'hr.control.left': 'left',
  'hr.control.lastPayroll': 'Last payroll',
  'hr.control.neverPaid': 'No payroll yet',
  'hr.control.ai': 'AI summary',
  'hr.control.aiPending': 'Thinking...',
  'hr.control.aiTitle': 'AI assistant summary',
  'hr.control.aiConfidence': 'confidence',
  'hr.control.signal.contract_missing': 'No contract',
  'hr.control.signal.contract_expired': 'Contract expired',
  'hr.control.signal.contract_expiring': 'Contract expiring (days)',
  'hr.control.signal.contract_future': 'Contract not started',
  'hr.control.signal.no_duties': 'No duties recorded',
  'hr.control.signal.no_obligations': 'No obligations recorded',
  'hr.control.signal.advance_open': 'Open advance',
  'hr.control.signal.advance_stale': 'Advance overdue (days)',
  'hr.control.signal.advance_after_leave': 'Left with an open advance',
  'hr.control.signal.debt_open': 'Open debt',
  'hr.control.signal.debt_heavy': 'Heavy debt',
  'hr.control.signal.debt_after_leave': 'Left with a debt',
  'hr.control.signal.payroll_missing': 'Payroll not run',
  'hr.control.signal.salary_zero': 'Salary is zero',
  'hr.control.signal.no_kpi': 'No KPI plan',
  'hr.payroll.reverse': 'Reverse',
  'hr.payroll.reverseTitle': 'Return the advance',
  'hr.payroll.reverseHint': 'The cash RETURNS to the register. The reason is recorded permanently.',
  'hr.payroll.writeOff': 'Write off',
  'hr.payroll.writeOffTitle': 'Forgive the debt',
  'hr.payroll.writeOffHint': 'This is the company\'s loss — collection is abandoned.',
  'hr.payroll.reasonPlaceholder': 'Reason (at least 5 characters)',
  'hr.payroll.reverseRunTitle': 'Reverse the payroll run',
  'hr.payroll.reverseRunHint': 'If paid, the cash returns; advances and debts are restored.',
  'hr.control.signal.no_branch': 'No branch — their money never reaches the ledger',
  'charity.reverse': 'Reverse',
  'charity.reverseTitle': 'Reverse the aid',
  'charity.reverseHint': 'The cash returns and the fund balance is restored.',
  'charity.reasonPlaceholder': 'Reason (at least 5 characters)',
  'nav.discounts': 'Discounts',
  'reports.discounts.title': 'Discounts by customer',
  'reports.discounts.subtitle': 'Who got what: the on-invoice discount and the accruing annual rebate.',
  'reports.discounts.byCustomer': 'By customer',
  'reports.discounts.customer': 'Customer',
  'reports.discounts.list': 'List amount',
  'reports.discounts.instant': 'On-invoice discount',
  'reports.discounts.instantHint': 'given on the invoice — the customer paid less',
  'reports.discounts.annual': 'Annual rebate',
  'reports.discounts.annualHint': 'a liability — not paid yet, it accrues',
  'reports.discounts.total': 'Total discount',
  'reports.discounts.pct': 'Rate',
  'reports.discounts.pctHint': 'against the list amount',
  'reports.discounts.invoices': 'invoices',
  'reports.discounts.noInvoices': 'No sales in this period',
  'reports.discounts.empty': 'No discounts given',
  'reports.discounts.emptyBody': 'No discount was recorded for anyone in this period.',
  'reports.discounts.pnlNote': 'The on-invoice discount here does NOT equal the "Discounts given" line in the P&L, and that is correct: an on-invoice discount is netted at source, so revenue is already booked lower. The P&L line shows bonuses paid afterwards. The annual rebate matches in both places.',
  'dashboard.attention.control': 'Critical in the control desk',
  'nav.creditNotes': 'Credit notes',
  'creditNote.title': 'Credit notes',
  'creditNote.subtitle': 'The document that reduces a customer\'s debt when they return goods.',
  'creditNote.list': 'List',
  'creditNote.docNo': 'Document',
  'creditNote.customer': 'Customer',
  'creditNote.amount': 'Amount',
  'creditNote.balance': 'Balance',
  'creditNote.statusCol': 'Status',
  'creditNote.allStatuses': 'All statuses',
  'creditNote.issue': 'Issue',
  'creditNote.cancel': 'Cancel',
  'creditNote.cancelTitle': 'Cancel the draft',
  'creditNote.cancelHint': 'Only a draft can be cancelled — an issued note stays in the ledger.',
  'creditNote.empty': 'No credit notes',
  'creditNote.emptyBody': 'A credit note is issued from the return card when a customer returns goods.',
  'creditNote.status.draft': 'Draft',
  'creditNote.status.issued': 'Issued',
  'creditNote.status.applied': 'Applied',
  'creditNote.status.cancelled': 'Cancelled',
  'creditNote.issueDate': 'Date',
  'creditNote.reason': 'Reason',
  'creditNote.reason.return': 'Goods returned',
  'creditNote.reason.price_correction': 'Price correction',
  'creditNote.reason.discount': 'Discount',
  'creditNote.reason.write_off': 'Written off',
  'creditNote.applied': 'Applied',
  'creditNote.fromReturnDoc': 'Return document',
  'creditNote.notes': 'Notes',
  'creditNote.lines': 'Lines',
  'creditNote.lineName': 'Name',
  'creditNote.lineQty': 'Quantity',
  'creditNote.linePrice': 'Price',
  'creditNote.lineAmount': 'Amount',
  'creditNote.allocations': 'Applied to invoices',
  'creditNote.allocInvoice': 'Invoice',
  'creditNote.allocDate': 'Date',
  'creditNote.fromReturn': 'Issue a credit note',
  'creditNote.fromReturnHint': 'Lines are copied from the return — nothing is re-entered by hand.',
  'creditNote.created': 'Credit note draft created',
  'nav.treasury': 'Treasury',
  'treasury.title': 'Treasury',
  'treasury.subtitle': 'Where the money is, how much, and when it runs out.',
  'treasury.gapTitle': 'Cash shortfall ahead',
  'treasury.gapBody': 'On {date} ({days} days from now) you will be short {amount}.',
  'treasury.driftTitle': 'Register balance does not match the ledger',
  'treasury.total': 'Total cash',
  'treasury.totalHint': 'all registers and bank accounts',
  'treasury.expectedIn': 'Expected in',
  'treasury.expectedOut': 'Expected out',
  'treasury.horizonHint': 'within 90 days',
  'treasury.lowest': 'Lowest point',
  'treasury.byCurrency': 'By currency',
  'treasury.currency': 'Currency',
  'treasury.balance': 'Balance',
  'treasury.inBase': 'In base',
  'treasury.accounts': 'accounts',
  'treasury.calendar': 'Payment calendar',
  'treasury.calendarHint': 'What comes in and goes out in the coming days',
  'treasury.calendarEmpty': 'No expected payments in the coming days.',
  'treasury.date': 'Date',
  'treasury.in': 'In',
  'treasury.out': 'Out',
  'treasury.net': 'Net',
  'treasury.workingCapital': 'Working capital',
  'treasury.netWorkingCapital': 'Net working capital',
  'treasury.days': 'days',
  'treasury.dso': 'days to collect receivables',
  'treasury.dio': 'days inventory sits in stock',
  'treasury.dpo': 'days to pay suppliers',
  'treasury.ccc': 'cash conversion cycle',
  'nav.mySettings': 'My settings',
  'mySettings.title': 'My settings',
  'mySettings.telegram': 'Connect Telegram',
  'mySettings.telegramHint': 'Alerts arrive in this chat: overdue debts, low stock, approval requests.',
  'mySettings.notLinked': 'Telegram is not linked yet — you will not receive alerts.',
  'mySettings.connect': 'Get a linking code',
  'mySettings.unlink': 'Unlink',
  'mySettings.linkedAt': 'Linked',
  'mySettings.codeTitle': 'Linking code',
  'mySettings.codeExpires': 'The code is valid for {minutes} minutes.',
  'mySettings.quietHours': 'Quiet hours',
  'mySettings.quietHoursHint': 'No messages are sent in this window — they arrive in the morning.',
  'mySettings.quietEnabled': 'Enabled',
  'mySettings.from': 'From',
  'mySettings.to': 'To',
  'mySettings.timezone': 'Timezone',
  'treasury.transfer': 'Move cash',
  'treasury.transferDo': 'Move',
  'treasury.fromAccount': 'From',
  'treasury.toAccount': 'To',
  'treasury.amount': 'Amount',
  'treasury.converts': '{from} → {to}: the amount is converted at the daily rate.',
  'notif.title': 'Notifications',
  'notif.readAll': 'Mark all read',
  'notif.empty': 'No new messages',
  'dashboard.myKpi': 'My results',
  'dashboard.myKpiHint': 'Your plan for this month and how it is going',
  'nav.dealerControl': 'Dealer control',
  'dealerControl.title': 'Dealer control',
  'dealerControl.subtitle': 'The dealer owes us. Is that money still in their stock, owed by their customers — or gone?',
  'dealerControl.gapTitle': 'Uncovered risk',
  'dealerControl.gapBody': '{count} dealers cannot cover their debt. Total uncovered: {amount}.',
  'dealerControl.owedToUs': 'Owed to us',
  'dealerControl.owedToUsHint': 'open invoices',
  'dealerControl.customerDebt': 'Owed by their customers',
  'dealerControl.customerDebtHint': 'sold by the dealer, not yet collected',
  'dealerControl.stock': 'Stock at the dealer',
  'dealerControl.stockHint': 'our goods, not sold yet',
  'dealerControl.atRisk': 'Dealers at risk',
  'dealerControl.atRiskHint': 'coverage is short or a signal is raised',
  'dealerControl.board': 'Dealers',
  'dealerControl.dealer': 'Dealer',
  'dealerControl.coverage': 'Coverage',
  'dealerControl.gap': 'Gap',
  'dealerControl.signals': 'Status',
  'dealerControl.open': 'Open',
  'dealerControl.lastSale': 'last sale',
  'dealerControl.noSales': 'no sales',
  'dealerControl.empty': 'No dealers',
  'dealerControl.emptyBody': 'Once a dealer card exists, their status appears here.',
  'dealerControl.risk.ok': 'Healthy',
  'dealerControl.risk.watch': 'Watch',
  'dealerControl.risk.high': 'At risk',
  'dealerControl.signal.coverage_gap': 'Debt not covered',
  'dealerControl.signal.coverage_thin': 'Thin coverage',
  'dealerControl.signal.overdue_heavy': 'Too much overdue',
  'dealerControl.signal.stock_idle': 'Stock not moving',
  'dealerControl.signal.no_customers': 'No customers',
  'dealerControl.customers': 'The dealer\'s customers',
  'dealerControl.customersHint': 'Who owes what — the money sits here',
  'dealerControl.customer': 'Customer',
  'dealerControl.debt': 'Debt',
  'dealerControl.overdue': 'Overdue',
  'dealerControl.blocked': 'blocked',
  'dealerControl.noCustomers': 'No customers recorded',
  'dealerControl.stockCard': 'The dealer\'s stock',
  'dealerControl.stockCardHint': 'Our goods — the part not sold yet',
  'dealerControl.noStock': 'Stock is empty or not recorded',
  'dealerControl.product': 'Product',
  'dealerControl.qty': 'Qty',
  'dealerControl.value': 'Value',

  // --- Cash flow items ---
  'nav.cashFlowItems': 'Cash flow items',
  'cfi.description':
    'Every cash movement is linked to an item — the cash flow statement is built from those links.',
  'cfi.code': 'Code',
  'cfi.codeHint': 'Uppercase letters, digits and hyphens. The code cannot be changed later.',
  'cfi.name': 'Name',
  'cfi.flowType': 'Section',
  'cfi.direction': 'Direction',
  'cfi.parent': 'Parent item',
  'cfi.parentNone': 'Root (no parent)',
  'cfi.transactions': 'Movements',
  'cfi.status': 'Status',
  'cfi.system': 'System',
  'cfi.active': 'Active',
  'cfi.archived.badge': 'Archived',
  'cfi.new': 'New item',
  'cfi.create': 'Add',
  'cfi.created': '{code} added.',
  'cfi.saved': 'Changes saved.',
  'cfi.archive': 'Archive',
  'cfi.archived': 'Item archived.',
  'cfi.empty': 'No items',
  'cfi.loadError': 'Could not load items',
  'cfi.flow.operating': 'Operating',
  'cfi.flow.investing': 'Investing',
  'cfi.flow.financing': 'Financing',
  'cfi.flow.internal': 'Internal transfer',
  'cfi.dir.in': 'Inflow',
  'cfi.dir.out': 'Outflow',
  'cfi.dir.both': 'Both',
  'cfi.dir.any': 'Not set',
  'cfi.unclassifiedTitle': 'Some movements have no item',
  'cfi.unclassifiedBody':
    '{count} cash movements are not linked to an item — they land in the "Unclassified" line of the cash flow statement.',
  'cfi.reclassify': 'Link them',
  'cfi.reclassified': '{linked} movements linked to items.',
  'cfi.reclassifiedPartial':
    '{linked} linked, no matching item found for {left} — those need manual linking.',
  'cfi.allClassified': 'All cash movements are linked to items.',
  'invoice.credits': 'Credit notes',
  'invoice.creditsHint':
    'These documents reduce the invoice balance without a payment: goods returned, price corrected, discount granted or debt written off.',
  // --- Ask Alight ---
  'nav.aiAsk': 'Ask Alight',
  'ai.description':
    'Ask in plain language. Where the answer came from — the database or the model — is shown above it.',
  'ai.askTitle': 'Question',
  'ai.question': 'Your question',
  'ai.questionPlaceholder': 'For example: who are the largest debtors?',
  'ai.skill': 'Skill',
  'ai.skillAuto': 'Choose automatically',
  'ai.skillHint':
    'Picking a skill only RAISES the answer tier — quality goes up and so does the cost.',
  'ai.ask': 'Ask',
  'ai.answer': 'Answer',
  'ai.confidence': 'Confidence',
  'ai.cost': 'Cost',
  'ai.model': 'Model',
  'ai.tokens': 'Text volume (question / answer)',
  'ai.usedTools': 'Sources used:',
  'ai.tier': 'Tier',
  'ai.calls': 'Calls',
  'ai.latency': 'Latency',
  'ai.freeShare': 'Free answers',
  'ai.monthBudget': 'Monthly budget',
  'ai.usageTitle': 'My usage',
  'ai.usagePeriod': '{from} — {to}',
  'ai.toolsTitle': 'Sources available to me',
  'ai.toolsHint': 'AI can only read from these sources, selected by your permissions.',
  'ai.notConfiguredTitle': 'AI key is not configured',
  'ai.notConfiguredBody':
    'Questions still work: the answer comes straight from the database (tier L0). Model answers need a key.',
  'ai.budgetOutTitle': 'Budget exhausted',
  'ai.budgetOutBody': 'The daily or monthly cap is reached — answers are served at tier L0.',
  // --- Conversation mode ---
  'ai.chatPlaceholder': 'Type your question — for example "how is business today?"',
  'ai.send': 'Send',
  'ai.newChat': 'New chat',
  'ai.thinking': 'Thinking…',
  'ai.you': 'You',
  'ai.evo': 'Alight',
  'ai.sendHint': 'Enter to send, Shift+Enter for a new line',
  'ai.starters': 'Where shall we start?',
  'ai.starter.today': 'How is business today?',
  'ai.starter.debts': 'Who owes us the most?',
  'ai.starter.stock': 'Which products are running out?',
  'ai.starter.profit': 'How much profit this month?',
  'ai.contextHint':
    'The conversation lives only in this window — it disappears on reload and is never stored on the server.',
  'ai.details': 'Details',
  'ai.sources': 'Sources',
  'ai.micStart': '🎤 Speak',
  'ai.micStop': '⏹ Stop',
  'ai.micListening': 'Listening… speak, then press "Stop".',
  'ai.micDenied':
    'Microphone access was denied. Click the lock icon in the address bar and allow the microphone.',
  'ai.micError': 'Could not recognise the speech. Try again or type the question.',
  'ai.speak': '🔊 Listen',
  'ai.speakPreparing': 'Preparing audio…',
  'ai.speakTruncated':
    'The answer is long — only the beginning was spoken; the full text is on screen.',
  'ai.speakStop': '⏹ Stop',
  'ai.agents': 'Agents — each reports on its own area',
  'ai.agentSources': '{count} sources',
  'ai.briefing': 'Daily briefing',
  'ai.briefingHint':
    'Cash, receivables, sales, stock and risks — in one short summary, one click away.',
  // --- Print templates ---
  'nav.printTemplates': 'Print templates',
  'printTpl.description':
    'Forms that go to the customer: invoice, delivery note, cash receipt. Text and details are edited here.',
  'printTpl.code': 'Code',
  'printTpl.name': 'Name',
  'printTpl.locale': 'Language',
  'printTpl.paper': 'Paper',
  'printTpl.size': 'Size',
  'printTpl.updated': 'Updated',
  'printTpl.default': 'Default',
  'printTpl.body': 'Template body (HTML)',
  'printTpl.bodyHint':
    'Values go in {{braces}}. Syntax is checked on the server when saving — a broken template is rejected.',
  'printTpl.saved': 'Template saved.',
  'printTpl.reset': 'Discard unsaved changes',
  'printTpl.empty': 'No templates',
  'printTpl.loadError': 'Could not load templates',
  // --- Trial balance and reconciliation ---
  'nav.accTrialBalance': 'Trial balance',
  'nav.accReconciliation': 'Reconciliation',
  'tb.title': 'Trial balance sheet',
  'tb.description':
    'Opening balance, period turnover and closing balance for every account. Total debit must equal total credit.',
  'tb.from': 'From',
  'tb.to': 'To',
  'tb.hideEmpty': 'Hide accounts with no activity',
  'tb.account': 'Account',
  'tb.accountCode': 'Account code',
  'tb.accountName': 'Account name',
  'tb.openingDebit': 'Opening debit',
  'tb.openingCredit': 'Opening credit',
  'tb.turnoverDebit': 'Turnover debit',
  'tb.turnoverCredit': 'Turnover credit',
  'tb.closingDebit': 'Closing debit',
  'tb.closingCredit': 'Closing credit',
  'tb.total': 'TOTAL',
  'tb.empty': 'No entries in this period',
  'tb.balanced': 'Debit equals credit — the sheet balances.',
  'tb.unbalancedTitle': 'Debit does NOT equal credit',
  'tb.unbalancedBody':
    'Difference: {difference}. In this state no number in the table below can be trusted — open the reconciliation first.',
  'recon.description':
    'Whether the ledger agrees with the operational side. Not a report but a diagnostic: it answers "can these numbers be trusted".',
  'recon.checks': 'Checks',
  'recon.check': 'Check',
  'recon.ledger': 'Ledger',
  'recon.source': 'Operations',
  'recon.difference': 'Difference',
  'recon.status': 'Status',
  'recon.ok': 'Agrees',
  'recon.gap': 'Gap',
  'recon.allOk': 'The ledger fully agrees with the operational side.',
  'recon.gapTitle': 'The ledger and operations disagree',
  'recon.gapBody':
    'The queue is empty, so the cause is not lag. See which check failed in the table below.',
  'recon.pendingTitle': 'The queue has unprocessed events',
  'recon.pendingBody':
    '{count} events are not written to the ledger yet — a gap is EXPECTED. Drain the queue first.',
  'recon.drain': 'Drain the queue',
  'recon.drained': 'Posted {posted} events, {remaining} left in the queue.',
  'recon.cashTitle': 'Cash and bank reconciliation',
  'recon.cashHint':
    'Every account is compared in ITS OWN currency: the stored balance must equal the sum of movements. A gap means money moved outside the cash flow statement.',
  'recon.account': 'Account',
  'recon.stored': 'Stored balance',
  'recon.computed': 'From movements',
  // --- Stock adjustment ---
  'adj.new': 'Adjustment',
  'adj.create': 'Create adjustment',
  'adj.created': '{docNo} created — the balance changes once approved.',
  'adj.reason': 'Reason',
  'adj.direction': 'Direction',
  'adj.increase': 'Found extra (+)',
  'adj.decrease': 'Write off (−)',
  'adj.hint':
    'An adjustment covers one specific event: a box broke, goods were found, goods were stolen. To recount the whole warehouse use a stock count.',
  // --- Treasury: scenarios and expected flows ---
  'treasury.scenarios': 'Scenarios',
  'treasury.scenariosHint':
    'A single forecast promises "this will happen" and that is always false. Three scenarios ask the right question: what if customers pay late?',
  'treasury.scenario': 'Scenario',
  'treasury.scenario.base': 'Base',
  'treasury.scenario.conservative': 'Conservative',
  'treasury.scenario.aggressive': 'Optimistic',
  'treasury.lowestDate': 'Lowest on',
  'treasury.shortfall': 'Shortfall',
  'treasury.noGap': 'Covered',
  'treasury.expectedInList': 'Expected inflows',
  'treasury.expectedInHint': 'Which documents bring how much money in the next 90 days',
  'treasury.expectedOutList': 'Expected outflows',
  'treasury.expectedOutHint': 'Which documents must be paid in the next 90 days',
  'treasury.expectedTotal': 'Total expected',
  'treasury.overdue': 'Overdue',
  'treasury.expectedEmpty': 'No movements expected in the next 90 days',
  'treasury.doc': 'Document',
  'treasury.party': 'Counterparty',
  'treasury.expectedDate': 'Expected date',
  'mySettings.templates': 'What notifications arrive',
  'mySettings.templatesHint':
    'Informational only: template text is a system setting and applies to everyone equally.',
  'mySettings.everyTime': 'arrives every time',
  'mySettings.cooldown': 'repeats once every {value}',
  'mySettings.days': '{n} days',
  'mySettings.hours': '{n} h',
  'mySettings.urgent': 'Urgent',
  'customer.telegram': 'Telegram notifications',
  'customer.telegramHint':
    'Payment confirmations go to the customer Telegram chat. To link it, give the customer the code below — they send it to the bot.',
  'customer.telegramCode': 'Get a code',
  'customer.telegramExpires': 'The code is valid for {minutes} min.',
  'fxRates.cbuImport': 'Load from CBU',
  'fxRates.cbu.created': 'recorded',
  'fxRates.cbu.updated': 'updated',
  'fxRates.cbu.unchanged': 'unchanged',
  'fxRates.cbu.kept': 'left alone — set manually',
  'fxRates.cbu.locked': 'day is closed',

  // --- Incoming goods ---
  'incoming.title': 'Incoming goods',
  'incoming.description':
    'When the supplier issues an invoice, the shipment appears in this list. Once the goods arrive you receive them — only then are they added to your warehouse stock.',
  'incoming.docNo': 'Document',
  'incoming.issuedDate': 'Issued',
  'incoming.statusCol': 'Status',
  'incoming.total': 'Total',
  'incoming.receivedAt': 'Received',
  'incoming.lineCount': 'Lines',
  'incoming.status.pending': 'Expected',
  'incoming.status.received': 'Received',
  'incoming.status.cancelled': 'Cancelled',
  'incoming.filterStatus': 'Status',
  'incoming.searchPlaceholder': 'Document number…',
  'incoming.loadError': 'Could not load incoming goods',
  'incoming.empty': 'No expected shipments yet',
  'incoming.emptyHint':
    'As soon as the supplier issues an invoice, the shipment shows up here on its own — nothing to request or create. Earlier shipments are in the history.',
  'incoming.emptyHistory': 'No documents in this status',
  'incoming.emptyHistoryHint':
    'This list only shows documents in the selected status. Go back to expected shipments to see what is on its way.',
  'incoming.emptySearch': 'Document not found',
  'incoming.emptySearchHint':
    'Search works by document number. Check the number or clear the search to see the whole list.',
  'incoming.showHistory': 'Show received',
  'incoming.showPending': 'Back to expected',
  'incoming.lines': 'Shipment contents',
  'incoming.linesHint':
    "The price comes from the supplier's document and the goods are received at that price — it cannot be changed here.",
  'incoming.lineSku': 'Code',
  'incoming.lineName': 'Product',
  'incoming.lineQty': 'Quantity',
  'incoming.lineCost': 'Price',
  'incoming.lineAmount': 'Amount',
  'incoming.receiveTitle': 'Receive the shipment',
  'incoming.receiveHint':
    'If the goods have arrived, pick which of your warehouses they went to. Quantity and price stay as in the document.',
  'incoming.warehouse': 'Warehouse',
  'incoming.notes': 'Note',
  'incoming.notesHint':
    'Optional. If left empty, the warehouse entry carries the document number.',
  'incoming.receiveSubmit': 'Receive',
  'incoming.receiveWarning':
    'Once received, stock and cost change immediately; this can only be corrected with a reversing document.',
  'incoming.received': '“{docNo}” received — the goods are in your warehouse.',
  'incoming.alreadyReceived':
    'This shipment has already been received: the goods are in your warehouse and counted in stock.',
  'incoming.cancelledHint':
    'This document was cancelled — it cannot be received. If the goods did arrive, ask the supplier for a new document.',

  // --- Partner organizations ---
  'nav.partnerOrgs': 'Partner organizations',
  'porg.title': 'Partner organizations',
  'porg.description':
    'A partner organization is a customer or dealer that sells through this system ITSELF: its own stock, its own prices, its own profit. We only decide which sections are open to it.',
  'porg.isolation': 'Our warehouses and reports are invisible to them: each organization sees only its own data.',
  'porg.code': 'Code',
  'porg.name': 'Name',
  'porg.moduleCount': 'Sections',
  'porg.userCount': 'Users',
  'porg.status': 'Status',
  'porg.active': 'Active',
  'porg.inactive': 'Suspended',
  'porg.createdAt': 'Opened on',
  'porg.empty': 'No partner organizations',
  'porg.emptyHint':
    'Open your first organization right here — code, administrator and package are set in one form.',
  'porg.loadError': 'Could not load organizations',
  'porg.rowHint': 'Click a row to open that organization’s package.',
  'porg.new': 'New organization',
  'porg.create': 'Open organization',
  'porg.codeHint': 'Must be unique across the whole database and cannot be changed later.',
  'porg.customerSection': 'Customer card',
  'porg.customer': 'Customer',
  'porg.customerHint':
    'Tells us which of our customers this organization is: debt and settlements live on that card, and an invoice we issue arrives on their side as an inbound supply notice.',
  'porg.customerMissing': 'Not linked',
  'porg.customerMissingWarning':
    'No customer card selected. The organization will open and work, but when we invoice it the goods will not reach THEIR warehouse — no error is raised, simply nothing happens. The card can be linked later.',
  'porg.supplyRequired':
    'An organization linked to a customer card MUST have the “supply” section in its package. With the link in place every invoice of ours writes them a supply notice; if the section is closed they never see it — the shipment arrives and the screen stays empty.',
  'porg.adminSection': 'Administrator',
  'porg.adminHint':
    'The organization’s first user. They add the rest of their staff themselves — we do not interfere.',
  'porg.adminFullName': 'Full name',
  'porg.adminEmail': 'Email',
  'porg.packageSection': 'Initial package',
  'porg.created.title': 'Organization “{code}” created',
  'porg.password': 'Temporary password',
  'porg.passwordWarning':
    'This password is shown here only ONCE — it is stored nowhere. Once this page is closed it cannot be retrieved. Copy it now and hand it to the administrator through a trusted channel (in person or by phone); do not send it by email or into a shared chat.',
  'porg.passwordLogin': 'Sign-in email: {email}',
  'porg.openModules': 'Open the package',

  'porg.modules.title': 'Package — which sections are open',
  'porg.modules.note':
    'This list decides which sections exist AT ALL in that organization. Who inside it sees what is decided by THEIR own roles — the two decisions do not replace each other.',
  'porg.modules.hint':
    'Section codes come from the server catalogue: they are derived from the permission list, never written by hand.',
  'porg.modules.selected': '{count} section(s) selected',
  'porg.modules.permissions': '{count} permission(s)',
  'porg.modules.emptyWarning':
    'No section is selected. Saved like this, the organization can sign in and will see no section at all — just an empty screen.',
  'porg.modules.save': 'Save package',
  'porg.modules.saved': 'Package saved: {count} section(s) open.',
  'porg.modules.empty': 'The catalogue is empty',
  'porg.modules.loadError': 'Could not load the module catalogue',
  'porg.notFound': 'Organization not found',

  // --- Entering a partner organization to look at it ---
  'partnerView.enter': 'Enter and view',
  'partnerView.enterHint':
    'Opens that organization’s own data READ-ONLY, and the visit is written to that organization’s log as well.',
  'partnerView.enterFailed': 'Could not enter the organization',
  'partnerView.banner.title': 'PARTNER ORGANIZATION VIEW',
  'partnerView.banner.org': '{code} — {name}',
  'partnerView.banner.notYours': 'What is on screen is NOT YOURS — it belongs to this organization.',
  'partnerView.banner.readOnly': 'Read-only: nothing can be written, changed or posted.',
  'partnerView.banner.audited': 'This visit is recorded in that organization’s own log.',
  'partnerView.banner.window': 'Viewing window: {window}. After it ends you must enter again.',
  'partnerView.exit': 'Leave',
  'partnerView.expired':
    'The viewing window has ended — you are back in your own organization. Enter again if you need to.',
};
